<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1" :fill="fill">
      <path
        class="st3"
        d="M306.2,114.5c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.1,0,0.2c0.3,0,0.6,0,0.9,0V114.5z"
      />
      <path
        class="st3"
        d="M303.2,116.2c-0.5,0-0.9-0.1-1.4-0.2c-0.2,0.3-0.4,0.7-0.4,1.1c-0.1,0.9,0.4,1.6,1.3,2.1
		c0.2,0.1,0.4,0.2,0.5,0.3C303.3,118.4,303.3,117.3,303.2,116.2z"
      />
      <path
        class="st3"
        d="M306.2,121.2v-2.9V118v-1.8c-0.6,0-1.1,0-1.7,0c-0.2,1.2-0.3,2.4-0.4,3.7c0.6,0.3,1.2,0.7,1.8,1
		C306,121.1,306.1,121.1,306.2,121.2z"
      />
      <path
        class="st3"
        d="M228.5,143.8L228.5,143.8C228.5,143.8,228.6,143.8,228.5,143.8L228.5,143.8L228.5,143.8
		C228.5,143.9,228.5,143.9,228.5,143.8C228.5,143.9,228.5,143.9,228.5,143.8z"
      />
      <path
        class="st3"
        d="M250.2,139.8L250.2,139.8C250.1,139.7,250.1,139.8,250.2,139.8C250.1,139.8,250.2,139.8,250.2,139.8z"
      />
      <path
        class="st3"
        d="M103.7,301.5c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6
		c0.3,1.4,1.8,2.3,3.4,2.2c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4c-0.3-1.8-2.1-2.8-4.2-2.4c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.2-0.4-0.2
		c-0.5-0.1-0.9-0.2-1.5-0.2c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1
		c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5
		c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6
		C103.3,300.5,103.6,301,103.7,301.5z"
      />
      <path
        class="st3"
        d="M86.9,321.3c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9
		l-0.1-0.1c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2
		c-1.3,1.2-1.3,1.2-0.5,2.5c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3
		c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6c0.7-0.3,0.5-0.8,0.4-1.2C87,322.3,86.9,321.8,86.9,321.3z"
      />
      <path
        class="st3"
        d="M167.3,275.1c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9c-0.5-0.1-1.1,0-1.6,0.1
		C168,271.7,166.9,273.1,167.3,275.1z"
      />
      <path
        class="st3"
        d="M179.7,278.4c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C179.9,278.9,179.9,278.6,179.7,278.4z"
      />
      <path
        class="st3"
        d="M102.1,308.4c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3-0.1-0.4C102.5,308.9,102.3,308.6,102.1,308.4z"
      />
      <path
        class="st3"
        d="M172.2,266.4c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8
		c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9C170.1,265.5,171.1,266.2,172.2,266.4z"
      />
      <path
        class="st3"
        d="M148,337.3c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C151.1,337.9,149.6,337,148,337.3z"
      />
      <path
        class="st3"
        d="M245.8,236.6c-0.6-0.6-1.4-0.5-2.2-0.2c-0.7,0.2-1.3,0.6-1.9,0.8c0.3,1.1,0.8,1.9,2.1,2.2
		c1.4,0.3,2.1-0.5,3.1-1.2c0.1,0.5,0.3,1,0.7,1.3c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5
		c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7s0.5-0.8,0.4-1.6c-0.6-0.1-1.2-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0
		c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.8,0.1-1.5,0.4-2.4,1.1C247,237.2,246.2,237,245.8,236.6z"
      />
      <path
        class="st3"
        d="M232.8,294.9c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C230.9,296.8,232.3,296.1,232.8,294.9z"
      />
      <path
        class="st3"
        d="M188.3,256.3c-1.1-0.2-2.2-0.5-3.3-0.7c0.3,0.3,0.6,0.6,1.1,0.8C186.8,256.6,187.6,256.5,188.3,256.3z"
      />
      <path
        class="st3"
        d="M184.5,254.6c0.3,0.1,0.6,0.1,0.9,0.2c1.4,0.3,2.7,0.6,4.1,0.8l0,0c0.8-0.8,1-2,0.4-2.9
		c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9c-0.1,0.4-0.3,0.8-0.4,1.2C184.5,254.1,184.5,254.4,184.5,254.6z"
      />
      <path
        class="st3"
        d="M194.3,257.8c0-0.1-0.1-0.3-0.2-0.4c-1.7-0.3-3.3-0.7-5-1c-0.3,0.1-0.5,0.3-0.7,0.5c-0.6,0.6-0.5,1.3-0.2,1.9
		c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1s0.7,0.2,1.1,0.4
		c0.4-0.5,0.8-1,1.2-1.6C195,258.7,194.5,258.4,194.3,257.8z"
      />
      <path
        class="st3"
        d="M225.9,294.5c-0.2-0.1-0.5-0.3-0.7-0.3c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7
		c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2
		c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4C227.3,296.2,226.9,295.1,225.9,294.5
		z"
      />
      <path
        class="st3"
        d="M91.4,307.2c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C92.2,304.8,91.2,306,91.4,307.2z"
      />
      <path
        class="st3"
        d="M188.1,263.8c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C188,264.8,188.2,264.2,188.1,263.8z"
      />
      <path
        class="st3"
        d="M90.1,299.9c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C89.5,298.8,89.7,299.4,90.1,299.9z"
      />
      <path
        class="st3"
        d="M1.2,311c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4
		c-0.3-0.6-0.8-1-1.4-1.1v1.1v1.5v0.8v0.7c0.1-0.1,0.3-0.1,0.4-0.2C0.7,311.5,1,311.3,1.2,311z"
      />
      <path
        class="st3"
        d="M90.7,314.2c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6
		c-0.3,0.1-0.6,0.2-1,0.4c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9
		c0.8,0.3,1.6,0.1,2.9-0.8c1.3,1,1.8,1.1,2.6,0.6C90.9,315.5,91.1,314.8,90.7,314.2z"
      />
      <path
        class="st3"
        d="M273.6,247.1c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2
		C272.9,248.2,273.4,247.7,273.6,247.1z"
      />
      <path
        class="st3"
        d="M4.5,310.9c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C7.2,311.3,5.9,310.6,4.5,310.9z"
      />
      <path
        class="st3"
        d="M88.7,295.9c-0.1-0.4-0.1-0.9-0.3-1.3c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0
		c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7C89.6,296.2,89.1,296,88.7,295.9z"
      />
      <path
        class="st3"
        d="M90,297C89.9,297,89.9,297.1,90,297C90,297.1,90,297.1,90,297L90,297L90,297z"
      />
      <path
        class="st3"
        d="M249.4,264.9c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C248.8,265.6,249.1,265.4,249.4,264.9z"
      />
      <path
        class="st3"
        d="M207.3,269c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3s0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5C206.1,270.6,207.6,269.4,207.3,269z"
      />
      <path
        class="st3"
        d="M108,311.7c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3c0.3,1.1,1.5,1.6,2.8,1.3
		c1.2-0.3,1.9-1.3,1.7-2.3C108.2,312.2,108.1,311.9,108,311.7z"
      />
      <path
        class="st3"
        d="M247.7,280.6c1.5,0,3,0,4.5,0c0.1-0.3,0.1-0.6,0-0.8c-0.1-0.4-0.4-0.7-0.9-0.9
		C249.8,278.5,248.1,279.4,247.7,280.6z"
      />
      <path
        class="st3"
        d="M247.6,281.2L247.6,281.2c0,0.5,0.3,1-0.1,1.7c0.9-0.2,1.6-0.3,2.2-0.5c0.4-0.1,0.9-0.3,1.3-0.6
		c-0.4-0.1-0.9-0.1-1.3-0.2C249,281.6,248.3,281.4,247.6,281.2z"
      />
      <path
        class="st3"
        d="M10.3,306c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		s0.5-0.9,0.4-1.4C11.3,306.8,10.9,306.3,10.3,306z"
      />
      <path
        class="st3"
        d="M276.9,265.9c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.1,0,2.2,0,3.2-0.1
		c0.3-0.8,0.6-1.7,0.9-2.5C277.1,265.9,277,265.9,276.9,265.9z"
      />
      <path
        class="st3"
        d="M3.4,306.5c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C1.2,306.2,2.3,306.7,3.4,306.5z"
      />
      <path
        class="st3"
        d="M200.3,264.3c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.6,0.8,1.3,0.5c0.6-0.2,0.6-0.6,0.5-1.1
		c0-0.4-0.2-0.9,0-1.2c1.3-1.5,0.5-2.6-0.5-3.7C200.6,261.5,199.4,262.6,200.3,264.3z"
      />
      <path
        class="st3"
        d="M15,301.8L15,301.8v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9c0.2,0.2,0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C15.2,303,15.3,302.3,15,301.8z"
      />
      <path
        class="st3"
        d="M164.9,303.8c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C167.2,304.1,166,303.5,164.9,303.8z"
      />
      <path
        class="st3"
        d="M295.5,254.4h0.1c0.5-0.1,1-0.4,1.3-0.7c0,0,0-0.1,0.1-0.1c-1.2,0-2.4,0-3.5,0
		C293.9,254.2,294.7,254.5,295.5,254.4z"
      />
      <path
        class="st3"
        d="M256.9,249.9L256.9,249.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7c-0.1,0-0.2-0.1-0.3-0.1
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C257.2,250.2,257,250.1,256.9,249.9z"
      />
      <path
        class="st3"
        d="M195,250.8c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C192.4,250.3,192.7,250.7,195,250.8z"
      />
      <path
        class="st3"
        d="M283.4,249.2c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C283.8,250.3,283.7,249.6,283.4,249.2z"
      />
      <path
        class="st3"
        d="M247.6,244.6c0.2-0.2,0.5-0.3,0.7-0.5s0.4-0.3,0.6-0.5c-0.3-0.7-0.5-1.5-0.8-2.1c0-0.1-0.1-0.2-0.1-0.2
		c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0c-0.3,0.3-0.5,0.6-0.7,0.9c-0.4,0.6-0.5,1.3-0.8,2c-0.2,0.6,0.3,1,0.9,1.4
		C246.6,245.1,247.1,244.9,247.6,244.6z"
      />
      <path
        class="st3"
        d="M260.3,256.9h0.1c0.5-0.1,0.9-0.5,1.2-0.9c0.3-0.4,0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C258.5,256.8,259.4,257.2,260.3,256.9z"
      />
      <path
        class="st3"
        d="M244.6,254.5c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4
		C244.5,254.3,244.5,254.4,244.6,254.5z"
      />
      <path
        class="st3"
        d="M41.2,332.3c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C43.3,332.5,42.3,332.1,41.2,332.3z"
      />
      <path
        class="st3"
        d="M36.6,338.3c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C38.6,338.7,37.6,338.1,36.6,338.3z"
      />
      <path
        class="st3"
        d="M140,276c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C141,276.6,140.6,276.2,140,276z"
      />
      <path
        class="st3"
        d="M21.1,304.9c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C21.1,305,21.1,305,21.1,304.9z"
      />
      <path
        class="st3"
        d="M8.4,298.1c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C9.1,298.6,8.8,298.3,8.4,298.1z"
      />
      <path
        class="st3"
        d="M176.2,289.8c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C176.3,290.3,176.3,290.1,176.2,289.8L176.2,289.8z"
      />
      <path
        class="st3"
        d="M276.4,255.6c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C276.9,254.1,276.3,254.9,276.4,255.6z"
      />
      <path
        class="st3"
        d="M222.3,276c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5c0.8,0.1,1.3-0.3,1.1-1c-0.1-0.4-0.5-0.8-0.4-1.1
		c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3c-0.4-0.2-0.8-0.4-1.2-0.6C222.4,275.9,222.3,275.9,222.3,276z"
      />
      <path
        class="st3"
        d="M220.6,301.1c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C221.3,301,220.9,301,220.6,301.1z"
      />
      <path
        class="st3"
        d="M0.4,316.9c-0.1,0-0.3,0.1-0.4,0.2v2.6c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.6-1.1,1.3-1.8
		C2.3,317.1,1.3,316.6,0.4,316.9z"
      />
      <path
        class="st3"
        d="M272.9,264.7c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C272.2,264.3,272.5,264.6,272.9,264.7z"
      />
      <path
        class="st3"
        d="M286.4,288.1c0-0.2-0.2-0.4-0.3-0.6c-0.3-0.3-0.9-0.5-1.4-0.4c-0.1,0-0.1,0-0.2,0s-0.2,0-0.2,0.1
		c-0.7,0.2-1.2,0.9-1.1,1.5c0.1,0.8,0.9,1.3,1.8,1.1C285.8,289.7,286.6,288.9,286.4,288.1z"
      />
      <path
        class="st3"
        d="M213,315.3c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C211.6,316.3,212.3,315.9,213,315.3z"
      />
      <path
        class="st3"
        d="M278.3,289.4c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C280,289.6,279.3,289.2,278.3,289.4z"
      />
      <path
        class="st3"
        d="M111.7,314.7c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C113.5,314.9,112.5,314.4,111.7,314.7z"
      />
      <path
        class="st3"
        d="M211.7,317.1c-0.8,0.2-1.3,0.9-1.2,1.6s1,1.2,1.9,1s1.4-1,1.3-1.7C213.4,317.2,212.6,316.8,211.7,317.1z"
      />
      <path
        class="st3"
        d="M294.1,258c0.1,0.1,0.2,0.3,0.4,0.5c0.4-0.5,0.7-1.1,1.1-1.6C295,257,294.4,257.3,294.1,258z"
      />
      <path
        class="st3"
        d="M238.2,253.7c-0.5,0.4-0.6,0.8-0.2,1.3c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3
		c0.3,0.1,0.6,0.1,0.9-0.1c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7C239.5,253.3,238.8,253.3,238.2,253.7z"
      />
      <path
        class="st3"
        d="M11.8,295.3c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C10.1,295.1,10.9,295.5,11.8,295.3z"
      />
      <path
        class="st3"
        d="M0,336.6v2.4c0.1,0,0.3,0,0.4,0c0.8-0.2,1.4-0.9,1.2-1.5C1.5,337,0.7,336.5,0,336.6z"
      />
      <path
        class="st3"
        d="M1.5,325.5c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.6-0.2-0.9-0.2v0.7v1.6c0.1,0,0.2,0,0.3,0
		C1,326.8,1.6,326.1,1.5,325.5z"
      />
      <path
        class="st3"
        d="M259.6,257.5c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C260.4,257.5,260,257.4,259.6,257.5z"
      />
      <path
        class="st3"
        d="M17.8,336.9L17.8,336.9c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3
		c0.6-0.2,1-0.4,1.2-0.7C18.4,338.3,18.4,337.7,17.8,336.9C17.9,336.9,17.8,336.9,17.8,336.9z"
      />
      <path
        class="st3"
        d="M286.7,292.4c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7c0.7-0.2,1.1-0.8,1-1.3
		C288.1,292.6,287.4,292.3,286.7,292.4z"
      />
      <path
        class="st3"
        d="M212.3,305.3c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C213.6,305.5,213,305.2,212.3,305.3z"
      />
      <path
        class="st3"
        d="M16.4,311c0.2-0.5,0-0.9-0.5-1.1c-0.9-0.3-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4
		C15.6,311.9,16.1,311.6,16.4,311z"
      />
      <path
        class="st3"
        d="M216.3,312.3c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		C217.1,312,216.7,312.1,216.3,312.3z"
      />
      <path
        class="st3"
        d="M183.3,274c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2C184.6,274.1,184,273.8,183.3,274z"
      />
      <path
        class="st3"
        d="M261.1,268.8C261.1,268.8,261,268.8,261.1,268.8c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.7,0,1.1
		c0.6,0.1,1.2,0.2,1.7,0.3c0.3-0.2,0.6-0.4,0.9-0.6c-0.2-0.3-0.3-0.4-0.4-0.6C262.7,268.7,261.8,268.5,261.1,268.8z"
      />
      <path
        class="st3"
        d="M158,309.3c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C159.4,309.5,158.6,309.2,158,309.3z"
      />
      <path
        class="st3"
        d="M197,265.8c-0.4,0.5-0.7,1.1-1.1,1.6c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5c0.8-0.9,1.5-1.5,2-2.2
		C197.9,266.4,197.9,266,197,265.8z"
      />
      <path
        class="st3"
        d="M217,271.1c0.8,0.9,0.9,0.9,2.2,0.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.4-0.8-0.9-1.5-0.9-2.3c0-0.2-0.4-0.4-0.7-0.7
		c0.2,1.3,0.2,1.3-0.6,2.6C216.9,271,217,271.1,217,271.1z"
      />
      <path
        class="st3"
        d="M86,319.5c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C84.6,319.3,85.2,319.7,86,319.5z"
      />
      <path
        class="st3"
        d="M212.8,269.8c0-0.1-0.6-0.1-0.9-0.1c-0.2,0.7-0.3,1.5,0.6,1.9c0.3-0.2,0.7-0.5,0.8-0.4c0.8,0.5,1-0.1,1.1-0.5
		c0.1-0.3-0.1-0.6-0.1-0.8C213.7,269.8,213.1,270.6,212.8,269.8z"
      />
      <path
        class="st3"
        d="M189.7,248.8c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C190.8,248,190.2,248.5,189.7,248.8z"
      />
      <path
        class="st3"
        d="M233.7,285.4c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C234.5,285.2,233.9,285.2,233.7,285.4z"
      />
      <path
        class="st3"
        d="M231,273c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0c1.1-0.8,0.5-1.3,0-1.8C232.1,272.2,231.3,272.2,231,273z"
      />
      <path
        class="st3"
        d="M88,309.4c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4C88.5,309,88.2,309.2,88,309.4L88,309.4z"
      />
      <path
        class="st3"
        d="M167.9,301.1c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C167.1,302,167.5,301.6,167.9,301.1z"
      />
      <path
        class="st3"
        d="M248.7,321.1c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C248.7,320.2,248.5,320.4,248.7,321.1z"
      />
      <path
        class="st3"
        d="M229.3,273.8c0.1-0.3,0-0.6,0-0.9s0.1-0.7,0.2-1.1c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8
		c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0C227.8,272.3,228.4,273.1,229.3,273.8z"
      />
      <path
        class="st3"
        d="M201.4,259.6c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7c-0.2,0.4-0.1,0.8,0.3,0.9
		c0.4,0.1,0.9,0,1.3-0.2C201.2,260.4,201.2,260,201.4,259.6z"
      />
      <path
        class="st3"
        d="M203.5,243.3c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C202.1,243,202.1,243,203.5,243.3z"
      />
      <path
        class="st3"
        d="M74.7,326.9c1-0.6,1.8-1.1,2.7-1.6C75.7,324.7,75.2,325,74.7,326.9z"
      />
      <path
        class="st3"
        d="M27.9,336.7c1.5-0.5,1.7-0.8,1.2-1.9C27.9,335.5,27.9,335.5,27.9,336.7z"
      />
      <path
        class="st3"
        d="M210.3,268.2c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C211,268.1,210.5,268.1,210.3,268.2z"
      />
      <path
        class="st3"
        d="M215.8,294.9c0,0.5,0.5,0.8,1.1,0.7c0.6-0.1,0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8
		C216.1,294.1,215.8,294.4,215.8,294.9z"
      />
      <path
        class="st3"
        d="M217.8,278.3c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C218.3,279.3,218.2,278.7,217.8,278.3z"
      />
      <path
        class="st3"
        d="M251.6,283.2c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C251.8,283.1,251.7,283.1,251.6,283.2z"
      />
      <path
        class="st3"
        d="M232.2,298.2c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C233.2,298.8,232.7,298.6,232.2,298.2z"
      />
      <path
        class="st3"
        d="M227.4,273c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C227.6,273.6,227.8,273.2,227.4,273z"
      />
      <path
        class="st3"
        d="M193.4,254.6C193.4,254.7,193.4,254.6,193.4,254.6c-0.3,0.1-0.7,0.5-0.7,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5c-0.2-0.3-0.3-0.6-0.5-0.8c0,0,0,0,0-0.1C193.9,254.7,193.6,254.6,193.4,254.6z"
      />
      <path
        class="st3"
        d="M137.6,283.5c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C139,283.2,138.3,283.2,137.6,283.5z"
      />
      <path
        class="st3"
        d="M233.5,279.8c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C234.7,279.5,234.2,279.6,233.5,279.8z"
      />
      <path
        class="st3"
        d="M116,310c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6s0.9-0.5,0.8-0.9C117,310.1,116.4,309.8,116,310z"
      />
      <path
        class="st3"
        d="M30.2,303.1c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4
		s0.3,0.2,0.4,0.2C30.2,303.8,30.5,303.5,30.2,303.1z"
      />
      <path
        class="st3"
        d="M152.8,304.1c-0.3,0.2-0.7,0.6-0.6,0.8c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C153.9,304.2,153.3,303.9,152.8,304.1z"
      />
      <path
        class="st3"
        d="M74.5,317c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C74.4,317.1,74.4,317.1,74.5,317z"
      />
      <path
        class="st3"
        d="M220.2,272.1c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C221.7,272.8,221.5,272.4,220.2,272.1z"
      />
      <path
        class="st3"
        d="M235.4,282.1c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C236.5,283.1,236.1,282.6,235.4,282.1z"
      />
      <path
        class="st3"
        d="M232.2,277.6c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.6,0.2,0.9,0.5,1.2c0.1,0.1,0.5,0.1,0.7,0c0,0,0,0,0.1,0
		s0.2-0.4,0.2-0.5C233.1,278.5,232.7,278.2,232.2,277.6z"
      />
      <path
        class="st3"
        d="M240.6,264.7L240.6,264.7L240.6,264.7L240.6,264.7c0.5-0.5-0.6-0.9-0.2-1.4c-0.1-0.1-0.3-0.2-0.4-0.2
		c-0.2,0-0.4,0.1-0.9,0.2C239.6,263.9,239.5,264.7,240.6,264.7z"
      />
      <path
        class="st3"
        d="M204.9,253.5c0.1,0,0.3,0,0.4-0.1c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		C204.3,253.2,204.4,253.5,204.9,253.5z"
      />
      <path
        class="st3"
        d="M251.6,275c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C250.9,274.8,251.5,275.1,251.6,275z"
      />
      <path
        class="st3"
        d="M249.1,234.8c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C250,235.1,249.7,235,249.1,234.8z"
      />
      <path
        class="st3"
        d="M78.6,331.5c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C79.3,331.7,78.9,331.6,78.6,331.5z"
      />
      <path
        class="st3"
        d="M305,230.2c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C305.8,230.3,305.5,230,305,230.2z"
      />
      <path
        class="st3"
        d="M206,250.9c1.1,0.7,1.1,0.7,1.8-0.1C207.1,250.7,206.7,250,206,250.9z"
      />
      <path
        class="st3"
        d="M79.2,325.7c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C78.7,326.1,79.2,325.9,79.2,325.7z"
      />
      <path
        class="st3"
        d="M206.6,245c0.7-0.4,0.4-1,0.4-1.5C205.9,244,205.8,244.1,206.6,245z"
      />
      <path
        class="st3"
        d="M252,241.3c-0.8,1-1.3,1.7-1.2,2.5C251.3,243.2,252.3,242.7,252,241.3z"
      />
      <path
        class="st3"
        d="M227.2,281c0.1,0,0.1-0.1,0.1-0.1c-0.2,0-0.4,0-0.5,0C227,280.9,227.1,281,227.2,281z"
      />
      <path
        class="st3"
        d="M227.8,280.3c0-0.1-0.4-0.2-0.7-0.4c-0.3,0.3-0.5,0.5-0.7,0.8c0.1,0,0.1,0.1,0.2,0.1c0.3,0,0.5,0,0.8,0
		c0,0,0,0,0,0.1C227.6,280.6,227.7,280.4,227.8,280.3z"
      />
      <path
        class="st3"
        d="M233.3,245.2c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C233.8,245.4,233.6,245.3,233.3,245.2z"
      />
      <path
        class="st3"
        d="M241.7,258c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C242.5,257.3,242.1,257.6,241.7,258z"
      />
      <path
        class="st3"
        d="M46.1,327.4c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C46.7,327.5,46.4,327.4,46.1,327.4z"
      />
      <path
        class="st3"
        d="M12,327.3c0.7-0.7,0.8-1.2,0.2-1.9C11.4,326,11.5,326.5,12,327.3z"
      />
      <path
        class="st3"
        d="M226.6,290.9c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C226.1,290.6,226.3,290.7,226.6,290.9z"
      />
      <path
        class="st3"
        d="M114.3,301.6c-0.2,0.4-0.6,0.7-0.5,0.9c0.1,0.2,0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C115,302.1,114.6,301.9,114.3,301.6z"
      />
      <path
        class="st3"
        d="M188.9,268.5c1.3-0.8,0.1-1.1,0.1-1.7C187.7,267.6,188.9,267.9,188.9,268.5z"
      />
      <path
        class="st3"
        d="M258.2,277.8c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C258.8,277.4,258.6,277.5,258.2,277.8z"
      />
      <path
        class="st3"
        d="M228.7,241.9c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C229.2,243.1,228.9,242.6,228.7,241.9z"
      />
      <path
        class="st3"
        d="M90.4,317.2c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C91.6,316.4,91,316.8,90.4,317.2z"
      />
      <path
        class="st3"
        d="M248.7,245.3c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C249.2,246.1,248.8,245.7,248.7,245.3z"
      />
      <path
        class="st3"
        d="M256.1,286c0.1,0.8,0.1,0.8,0.9,1.3C256.9,286.8,256.9,286.3,256.1,286z"
      />
      <path
        class="st3"
        d="M205.7,321.1c0,0.7,0.2,1.1,1,1.7C206.8,321.8,206.6,321.4,205.7,321.1z"
      />
      <path
        class="st3"
        d="M230.9,244.3c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C231.5,244.1,231.2,244.2,230.9,244.3
		L230.9,244.3z"
      />
      <path
        class="st3"
        d="M212.2,287c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C212.8,287.4,212.5,287.3,212.2,287z"
      />
      <path
        class="st3"
        d="M81.9,328.6c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C82.2,328.1,82.1,328.4,81.9,328.6z"
      />
      <path
        class="st3"
        d="M252.3,261.2c-0.2-0.7-0.3-1.2-1.2-1.2C251,260.6,251.4,260.9,252.3,261.2z"
      />
      <path
        class="st3"
        d="M233.4,274.1c0.4,0.3,0.8,0.5,1.2,0.8c0.1-0.1,0.2-0.2,0.3-0.4C234.7,274,234.3,273.8,233.4,274.1z"
      />
      <path
        class="st3"
        d="M47.2,337.8c0.2-0.5,0.4-1,0.7-1.6C46.8,337,46.8,337,47.2,337.8z"
      />
      <path
        class="st3"
        d="M273.2,251.3c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C272.8,251.8,273,251.5,273.2,251.3z"
      />
      <path
        class="st3"
        d="M215.4,272c0.1,1,0.1,1.2,0.7,1.3c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6
		C216,272.7,215.7,272.4,215.4,272z"
      />
      <path
        class="st3"
        d="M241.3,246.6c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1-0.2-0.3-0.3-0.5
		c-0.3,0.3-0.5,0.6-0.8,0.8C241.4,246.5,241.3,246.5,241.3,246.6z"
      />
      <path
        class="st3"
        d="M241.3,236.2c0-0.2-0.4-0.3-0.7-0.5c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4
		C241,236.6,241.3,236.4,241.3,236.2z"
      />
      <path
        class="st3"
        d="M31.9,302.5c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C31.4,303.1,31.6,302.8,31.9,302.5z"
      />
      <path
        class="st3"
        d="M74.6,328.9c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C75.2,329,74.9,328.8,74.6,328.9z"
      />
      <path
        class="st3"
        d="M16.8,301c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C16.5,301.3,16.6,301.2,16.8,301z"
      />
      <path
        class="st3"
        d="M29.3,322.4c0.8-0.2,0.9-0.5,0.6-1.2C29.4,321.5,29,321.8,29.3,322.4z"
      />
      <path
        class="st3"
        d="M208.6,255.1c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C208.2,254.3,208.2,254.3,208.6,255.1z"
      />
      <path
        class="st3"
        d="M210,276c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2C209.8,276,209.9,276,210,276
		z"
      />
      <path
        class="st3"
        d="M233,295.9c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4C233.9,296.4,233.6,296,233,295.9z"
      />
      <path
        class="st3"
        d="M89.7,320.7c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C90.2,321.1,89.9,321,89.7,320.7z"
      />
      <path
        class="st3"
        d="M182.3,281.1c0.6-0.2,1.1-0.5,0.7-1.3C182.7,280.4,182.5,280.8,182.3,281.1z"
      />
      <path
        class="st3"
        d="M203.2,239.7c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C202.9,238.8,203,239.2,203.2,239.7z"
      />
      <path
        class="st3"
        d="M202.2,241.2c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C201.6,241.9,202.1,241.9,202.2,241.2z"
      />
      <path
        class="st3"
        d="M193.1,252c0.7,0.2,1.1,0.3,1.8,0.5C194.4,251.8,194,251.6,193.1,252z"
      />
      <path
        class="st3"
        d="M184.2,259c0.4,0.2,0.8,0.4,1.5,0.8C185.3,259,184.9,258.9,184.2,259z"
      />
      <path
        class="st3"
        d="M213.5,289.7c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C213.6,289,213.6,289.4,213.5,289.7z"
      />
      <path
        class="st3"
        d="M252.7,254.4c0.7-0.1,1.1-0.1,1.9-0.2C253.8,254,253.4,253.7,252.7,254.4z"
      />
      <path
        class="st3"
        d="M14,312.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C14.2,312.4,14.1,312.3,14,312.2z"
      />
      <path
        class="st3"
        d="M180.2,288.2c0.3-0.5,0.4-0.8,0.6-1.1C180.3,287.3,179.8,287.6,180.2,288.2z"
      />
      <path
        class="st3"
        d="M195.5,252.6c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C195.4,252.7,195.4,252.6,195.5,252.6z"
      />
      <path
        class="st3"
        d="M292.2,237.8L292.2,237.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C292.8,237.7,292.4,237.5,292.2,237.8z"
      />
      <path
        class="st3"
        d="M216.3,275.7c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.2,0.7-0.7
		C216.7,275.7,216.5,275.7,216.3,275.7z"
      />
      <path
        class="st3"
        d="M44.9,320.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C45.3,320.4,45,320.3,44.9,320.3z"
      />
      <path
        class="st3"
        d="M31,337.8c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C31.6,337.2,31.3,337.5,31,337.8z"
      />
      <path
        class="st3"
        d="M254.1,255.9c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C254.8,256.1,254.5,256,254.1,255.9z"
      />
      <path
        class="st3"
        d="M289.9,255.3c0.1,0,0.2-0.1,0.3-0.1c-0.1,0-0.1,0-0.2,0C289.9,255.2,289.9,255.3,289.9,255.3z"
      />
      <path
        class="st3"
        d="M289.6,255.8c0.1,0.1,0.2,0.2,0.2,0.3c0-0.2-0.1-0.4-0.1-0.5C289.7,255.6,289.6,255.7,289.6,255.8z"
      />
      <path
        class="st3"
        d="M78.6,319.8c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.3,0.3-0.5,0.5
		C78.3,319.7,78.5,319.9,78.6,319.8z"
      />
      <path
        class="st3"
        d="M250.8,245.8c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C250,246.5,250.4,246.1,250.8,245.8z"
      />
      <path
        class="st3"
        d="M67.5,323.4c-0.3-0.3-0.5-0.5-0.7-0.7C66.5,323.5,66.5,323.5,67.5,323.4z"
      />
      <path
        class="st3"
        d="M272.3,265.1c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C272.7,265.6,272.6,265.4,272.3,265.1C272.4,265.2,272.4,265.1,272.3,265.1z"
      />
      <path
        class="st3"
        d="M92.5,292.2c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C92.4,292.5,92.6,292.4,92.5,292.2z"
      />
      <path
        class="st3"
        d="M221.5,311.5c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C221.8,311.2,221.7,311.4,221.5,311.5z"
      />
      <path
        class="st3"
        d="M36.9,306.1c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C36.6,306.4,36.7,306.2,36.9,306.1z"
      />
      <path
        class="st3"
        d="M82.6,334.5c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C83.1,334.6,82.8,334.6,82.6,334.5z"
      />
      <path
        class="st3"
        d="M203.8,250.1c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4c-0.1,0.2-0.3,0.3-0.4,0.5l0,0l0,0
		c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8C203.6,250.3,203.7,250.2,203.8,250.1L203.8,250.1L203.8,250.1z"
      />
      <path
        class="st3"
        d="M205.5,242.9l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C205.6,242.6,205.5,242.7,205.5,242.9z
		"
      />
      <path
        class="st3"
        d="M252.5,256.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C253,256.5,252.8,256.7,252.5,256.9z"
      />
      <path
        class="st3"
        d="M93.1,317.8c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C93.2,317.5,93,317.7,93.1,317.8z"
      />
      <path
        class="st3"
        d="M245.7,240.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C246.4,240.1,246.1,240.3,245.7,240.5z"
      />
      <path
        class="st3"
        d="M10.4,296.3c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C10.1,296.1,10.2,296.2,10.4,296.3z"
      />
      <path
        class="st3"
        d="M200.4,278.3c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C200.5,277.8,200.5,278,200.4,278.3z"
      />
      <path
        class="st3"
        d="M209.6,270.2c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C209.7,270.1,209.6,270.2,209.6,270.2z"
      />
      <path
        class="st3"
        d="M238,245.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0
		c0.2,0,0.4-0.2,0.5-0.5C238,245.7,238,245.6,238,245.5z"
      />
      <path
        class="st3"
        d="M234.6,247.2c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C234.6,247,234.6,247.1,234.6,247.2z"
      />
      <path
        class="st3"
        d="M214.4,280.6c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C214.5,280.1,214.4,280.3,214.4,280.6z"
      />
      <path
        class="st3"
        d="M25.4,329.8c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C25.5,329.7,25.5,329.7,25.4,329.8z"
      />
      <path
        class="st3"
        d="M245,249.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		C245.3,249.4,245.1,249.5,245,249.5z"
      />
      <path
        class="st3"
        d="M199.4,251.4c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C199.7,251.5,199.5,251.4,199.4,251.4z"
      />
      <path
        class="st3"
        d="M83.6,317c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1C83.7,317.4,83.6,317.2,83.6,317z
		"
      />
      <path
        class="st3"
        d="M205.9,257.5c0.1,0.1,0.3,0.2,0.4,0.1c0.1,0,0.2-0.2,0.3-0.4c-0.2-0.1-0.4-0.1-0.5-0.1
		C206,257.2,205.8,257.4,205.9,257.5z"
      />
      <path
        class="st3"
        d="M265.8,245.8c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C265.9,245.9,265.8,245.9,265.8,245.8z"
      />
      <path
        class="st3"
        d="M265.3,246.4c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0S265.3,246.4,265.3,246.4z"
      />
      <path
        class="st3"
        d="M230,270.6c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C230.3,270.6,230.1,270.5,230,270.6z"
      />
      <path
        class="st3"
        d="M201,330.8c0.2,0.2,0.4,0.4,0.6,0.6C201.6,331.1,201.9,330.8,201,330.8z"
      />
      <path
        class="st3"
        d="M201.6,331.4C201.6,331.4,201.6,331.5,201.6,331.4c0,0.1,0.1,0.1,0.1,0.1C201.7,331.5,201.6,331.5,201.6,331.4
		L201.6,331.4z"
      />
      <path
        class="st3"
        d="M93.1,301.5c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C93,301.7,93.2,301.5,93.1,301.5z"
      />
      <path
        class="st3"
        d="M229.1,314.4c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C229.2,314.2,229.1,314.3,229.1,314.4z"
      />
      <path
        class="st3"
        d="M263.4,232.6c-0.1,0-0.2,0.2-0.2,0.2c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3
		C263.6,232.7,263.5,232.6,263.4,232.6z"
      />
      <path
        class="st3"
        d="M213.7,278.7c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C213.5,278.9,213.6,278.8,213.7,278.7z"
      />
      <path
        class="st3"
        d="M305.7,232.1c0.1,0.1,0.2,0.2,0.4,0.2c0,0,0.1,0,0.1-0.1v-0.5c-0.1,0-0.1,0-0.2,0
		C305.9,231.8,305.8,232,305.7,232.1z"
      />
      <path
        class="st3"
        d="M204.2,256.7c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C204.3,256.3,204.2,256.5,204.2,256.7z"
      />
      <path
        class="st3"
        d="M202.1,269.1c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C202.3,268.9,202.2,269,202.1,269.1z"
      />
      <path
        class="st3"
        d="M304.4,233c0,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5
		C304.4,232.7,304.4,232.9,304.4,233z"
      />
      <path
        class="st3"
        d="M204.9,280.7c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0
		C205,280.2,204.9,280.5,204.9,280.7z"
      />
      <path
        class="st3"
        d="M127,296.9c0.2,0.2,0.4,0.5,0.6,0.8C127.9,296.9,127.4,297,127,296.9z"
      />
      <path
        class="st3"
        d="M127,296.9C127,296.9,127,296.8,127,296.9c-0.1-0.1-0.1-0.1-0.1-0.1l0,0C127,296.9,127,296.9,127,296.9z"
      />
      <path
        class="st3"
        d="M183.9,283.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C184.1,283.5,184,283.4,183.9,283.3z"
      />
      <path
        class="st3"
        d="M30.2,310.7c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C30.3,310.6,30.3,310.7,30.2,310.7z"
      />
      <path
        class="st3"
        d="M212.8,278c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C213,278,212.9,278,212.8,278z"
      />
      <path
        class="st3"
        d="M213.1,278.6C213.1,278.6,213,278.6,213.1,278.6c-0.1-0.1-0.1-0.1-0.1-0.1v0.1
		C213,278.6,213,278.6,213.1,278.6z"
      />
      <path
        class="st3"
        d="M244.2,260.5l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1h-0.1c-0.1,0-0.2,0-0.4,0
		C244.3,260.5,244.3,260.5,244.2,260.5z"
      />
      <path
        class="st3"
        d="M198.1,274.4l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C198.2,274.1,198.1,274.2,198.1,274.4z"
      />
      <path
        class="st3"
        d="M248.5,251.5c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4
		C248.8,251.6,248.5,251.5,248.5,251.5z"
      />
      <path
        class="st3"
        d="M90.4,312.2c0.1,0.1,0.2,0.1,0.4,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.4-0.1
		C90.5,312,90.4,312.2,90.4,312.2z"
      />
      <path
        class="st3"
        d="M203.7,241.2c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C203.9,241.3,203.8,241.3,203.7,241.2z"
      />
      <path
        class="st3"
        d="M238.7,290.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C238.8,290.4,238.7,290.5,238.7,290.6z"
      />
      <path
        class="st3"
        d="M290.9,255.5c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C291,255.6,291,255.6,290.9,255.5z"
      />
      <path
        class="st3"
        d="M58.7,312.1c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C58.9,312.1,58.8,312.1,58.7,312.1z"
      />
      <path
        class="st3"
        d="M58.7,312.5C58.6,312.5,58.6,312.5,58.7,312.5c-0.1,0.1-0.1,0.1-0.1,0.2h0.1C58.7,312.6,58.7,312.5,58.7,312.5
		z"
      />
      <path
        class="st3"
        d="M238.2,246.6C238.3,246.6,238.2,246.5,238.2,246.6c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C237.9,246.8,238.1,246.7,238.2,246.6z"
      />
      <path
        class="st3"
        d="M297.5,236.6c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C297.5,236.2,297.5,236.3,297.5,236.6z"
      />
      <path
        class="st3"
        d="M129.9,335c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C130,335.1,130,335,129.9,335z"
      />
      <path
        class="st3"
        d="M109,277.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C109.1,277.2,109,277.1,109,277.1z"
      />
      <path
        class="st3"
        d="M67.2,310.8c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C67.2,310.6,67.2,310.7,67.2,310.8z"
      />
      <path
        class="st3"
        d="M205.7,256.9c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C205.5,256.8,205.6,256.9,205.7,256.9z"
      />
      <path
        class="st3"
        d="M230.7,271.4c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		C230.5,271.6,230.6,271.5,230.7,271.4z"
      />
      <path
        class="st3"
        d="M248.2,250.9c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C247.6,251.4,247.8,251.3,248.2,250.9z"
      />
      <path
        class="st3"
        d="M292.3,256.3c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2
		C292.4,256.2,292.3,256.2,292.3,256.3z"
      />
      <path
        class="st3"
        d="M162.2,310.7C162.2,310.7,162.3,310.7,162.2,310.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C162.3,310.6,162.3,310.6,162.2,310.7z"
      />
      <path
        class="st3"
        d="M251.6,254.2L251.6,254.2c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0c-0.1-0.1-0.1-0.2-0.2-0.2
		C251.7,254,251.6,254.1,251.6,254.2z"
      />
      <path
        class="st3"
        d="M62.5,321c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C62.7,320.7,62.6,320.9,62.5,321z"
      />
      <path
        class="st3"
        d="M209.4,266.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C209.6,266.7,209.5,266.7,209.4,266.8z"
      />
      <path
        class="st3"
        d="M195.7,272.9c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C195.7,272.7,195.6,272.8,195.7,272.9z"
      />
      <path
        class="st3"
        d="M119.2,284.4c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2-0.1l-0.1,0.1l0.1,0.1
		C119.1,284.3,119.1,284.3,119.2,284.4z"
      />
      <path
        class="st3"
        d="M291.7,257.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		C291.9,256.9,291.7,257,291.7,257.1z"
      />
      <path
        class="st3"
        d="M249.3,265.9C249.3,265.9,249.2,266,249.3,265.9C249.2,266,249.2,266,249.3,265.9
		C249.2,266,249.2,266,249.3,265.9C249.3,266,249.3,266,249.3,265.9z"
      />
      <path
        class="st3"
        d="M248.8,266.2c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.2,0.2-0.3C249.1,266.1,248.9,266.1,248.8,266.2z"
      />
      <path
        class="st3"
        d="M249.2,240.3c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1C249.3,240.4,249.3,240.3,249.2,240.3z"
      />
      <path
        class="st3"
        d="M40,311.2c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0S40,311.3,40,311.2z"
      />
      <path
        class="st3"
        d="M201.8,331.9c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C201.7,331.7,201.8,331.8,201.8,331.9z"
      />
      <path
        class="st3"
        d="M231.3,243.3C231.3,243.3,231.3,243.4,231.3,243.3c0,0.1,0.1,0.1,0.1,0.1v-0.1
		C231.4,243.3,231.3,243.3,231.3,243.3z"
      />
      <path
        class="st3"
        d="M227.9,243.9c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C227.8,243.8,227.9,243.9,227.9,243.9z"
      />
      <path
        class="st3"
        d="M228.3,243.6h0.1C228.4,243.5,228.4,243.5,228.3,243.6C228.3,243.5,228.3,243.5,228.3,243.6
		C228.3,243.5,228.3,243.6,228.3,243.6z"
      />
      <path
        class="st3"
        d="M242.2,240.5l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C242,240.4,242.1,240.5,242.2,240.5z"
      />
      <path
        class="st3"
        d="M259,241.3l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C259.2,241.3,259.1,241.3,259,241.3z"
      />
      <path
        class="st3"
        d="M253.5,236.3l0.1,0.1c0.1,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.2-0.1H253.5z"
      />
      <path
        class="st3"
        d="M198,247.4c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C197.9,247.5,198,247.5,198,247.4
		C198,247.5,198,247.4,198,247.4z"
      />
      <path
        class="st3"
        d="M192.7,248.3c0,0,0.1,0.1,0.1,0.2l0,0l0,0C192.7,248.4,192.7,248.3,192.7,248.3z"
      />
      <path
        class="st3"
        d="M114.6,296.9l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C114.4,297,114.5,296.9,114.6,296.9z"
      />
      <path
        class="st3"
        d="M10.7,316.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2L11,316C10.9,316.1,10.8,316.1,10.7,316.2z"
      />
      <path
        class="st3"
        d="M207,243.1v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C207.1,243.2,207,243.1,207,243.1z"
      />
      <path
        class="st3"
        d="M200.9,240.8l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C201.1,240.8,201,240.8,200.9,240.8z"
      />
      <path
        class="st3"
        d="M144.2,292.6c0.1,0,0.1,0.1,0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C144.4,292.5,144.3,292.6,144.2,292.6z"
      />
      <path
        class="st3"
        d="M121.9,297.8c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C121.9,297.8,121.8,297.8,121.9,297.8z"
      />
      <path
        class="st3"
        d="M204.3,310.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C204.4,310,204.3,310.1,204.3,310.1z"
      />
      <path
        class="st3"
        d="M181.3,285.9c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C181.3,285.8,181.3,285.8,181.3,285.9z"
      />
      <path
        class="st3"
        d="M188.9,260.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C188.8,260.7,188.9,260.7,188.9,260.6z"
      />
      <path
        class="st3"
        d="M225.8,277.1c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4
		C225.9,277.1,225.9,277.1,225.8,277.1z"
      />
      <path
        class="st3"
        d="M88.2,307.3c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C88.4,307.4,88.2,307.3,88.2,307.3
		z"
      />
      <path
        class="st3"
        d="M236.1,275.7c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C236.1,275.5,236.1,275.6,236.1,275.7z"
      />
      <path
        class="st3"
        d="M254.3,259.6c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0,0,0-0.1-0.1-0.1C254.5,259.5,254.4,259.6,254.3,259.6z"
      />
      <path
        class="st3"
        d="M230.1,278.8C230.1,278.8,230,278.8,230.1,278.8c-0.1,0.1,0,0.1,0,0.2l0,0l0,0
		C230.1,278.9,230.1,278.8,230.1,278.8L230.1,278.8z"
      />
      <path
        class="st3"
        d="M240.3,262C240.3,262,240.3,262.1,240.3,262c0,0.1,0.1,0.1,0.2,0.1l0,0c0,0,0-0.1,0.1-0.1
		C240.5,262,240.4,262,240.3,262L240.3,262z"
      />
      <path
        class="st3"
        d="M201.8,270.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C201.9,270.6,201.8,270.6,201.8,270.6z"
      />
      <path
        class="st3"
        d="M195.3,272.2c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C195.3,272,195.3,272.1,195.3,272.2z"
      />
      <path
        class="st3"
        d="M25.2,308.7c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C25.2,308.8,25.2,308.8,25.2,308.7z"
      />
      <path
        class="st3"
        d="M161.9,310.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C161.9,309.9,161.9,310,161.9,310.1z"
      />
      <path
        class="st3"
        d="M267.4,246.7l-0.1,0.1c0.1,0,0.2,0,0.3,0.1l0.1-0.1C267.6,246.7,267.5,246.7,267.4,246.7z"
      />
      <path
        class="st3"
        d="M216.4,283.7c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C216.4,283.8,216.4,283.7,216.4,283.7z"
      />
      <path
        class="st3"
        d="M243.1,252.7c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C243,252.6,243.1,252.7,243.1,252.7z"
      />
      <path
        class="st3"
        d="M277.8,245.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1
		C277.9,245.8,277.9,245.7,277.8,245.7z"
      />
      <path
        class="st3"
        d="M222.6,282.8v-0.1h-0.1C222.5,282.7,222.5,282.7,222.6,282.8C222.5,282.8,222.5,282.8,222.6,282.8z"
      />
      <path
        class="st3"
        d="M223.1,283.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.1,0,0.2,0C223,283.5,223,283.4,223.1,283.4z"
      />
      <path
        class="st3"
        d="M50.9,321.9L51,322c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0L50.9,321.9z"
      />
      <path
        class="st3"
        d="M198.5,264.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C198.6,264,198.5,264,198.5,264.1z"
      />
      <path
        class="st3"
        d="M252.2,252.3L252.2,252.3c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C251.6,252.6,251.8,252.5,252.2,252.3
		L252.2,252.3z"
      />
      <path
        class="st3"
        d="M52.8,296.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C52.7,296.5,52.8,296.5,52.8,296.5z"
      />
      <path
        class="st3"
        d="M274.1,248.3c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C274.2,248.2,274.1,248.2,274.1,248.3z"
      />
      <path
        class="st3"
        d="M274.5,248.6C274.5,248.5,274.4,248.5,274.5,248.6C274.4,248.5,274.4,248.6,274.5,248.6L274.5,248.6
		L274.5,248.6L274.5,248.6L274.5,248.6z"
      />
      <path
        class="st3"
        d="M243.2,255.2L243.2,255.2c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2C243.5,255,243.4,255.1,243.2,255.2z"
      />
      <path
        class="st3"
        d="M268.4,250c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1L268.4,250z"
      />
      <path
        class="st3"
        d="M268.3,249.9c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4
		c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		C268,250.5,268.2,250.2,268.3,249.9C268.3,250,268.3,250,268.3,249.9C268.3,250,268.3,249.9,268.3,249.9L268.3,249.9z"
      />
      <path
        class="st3"
        d="M274.5,248.9c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C274.5,248.7,274.5,248.8,274.5,248.9z"
      />
      <path
        class="st3"
        d="M261,278.1L261,278.1c-0.1-0.1-0.3-0.2-0.4-0.2h-0.1c0,0,0.1,0,0.1,0.1C260.7,278,260.9,278.1,261,278.1
		C261,278.2,261.1,278.2,261,278.1C261.1,278.2,261.1,278.2,261,278.1C261.1,278.1,261,278.1,261,278.1z"
      />
      <path
        class="st3"
        d="M261.2,278.5c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C261.1,278.3,261.2,278.4,261.2,278.5z"
      />
      <polygon class="st3" points="60.1,322.3 60.2,322.3 60.2,322.2 	" />
      <path
        class="st3"
        d="M204.5,265.7c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1
		C204.6,265.8,204.6,265.7,204.5,265.7z"
      />
      <path
        class="st3"
        d="M97.2,314c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C97.3,314.1,97.2,314.1,97.2,314
		C97.2,314.1,97.2,314,97.2,314z"
      />
      <path
        class="st3"
        d="M269.2,252l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C269.2,251.9,269.2,252,269.2,252z"
      />
      <path
        class="st3"
        d="M2,311.1L2,311.1C2.1,311.2,2.1,311.2,2,311.1L2,311.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C2.1,311,2,311,2,311.1z"
      />
      <path
        class="st3"
        d="M89.6,292.3c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C89.7,292.4,89.6,292.4,89.6,292.3z"
      />
      <path
        class="st3"
        d="M25.3,303.4l-0.1-0.1c0,0.1,0,0.1,0,0.2C25.2,303.4,25.3,303.4,25.3,303.4z"
      />
      <path
        class="st3"
        d="M12.9,304.8L12.9,304.8L12.9,304.8c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C13,304.7,13,304.7,12.9,304.8z"
      />
      <path
        class="st3"
        d="M196.7,264.8v0.1V264.8c0.1,0,0.1-0.1,0.1-0.1C196.7,264.7,196.7,264.8,196.7,264.8z"
      />
      <path
        class="st3"
        d="M45.1,295.9c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2H45C45,296,45.1,296,45.1,295.9z"
      />
      <polygon class="st3" points="246.1,260.6 245.9,260.5 245.9,260.6 	" />
      <polygon class="st3" points="193.5,261.6 193.6,261.6 193.5,261.5 	" />
      <path
        class="st3"
        d="M272.2,244c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C272.1,243.9,272.2,243.9,272.2,244z"
      />
      <path
        class="st3"
        d="M272.6,243.3L272.6,243.3L272.6,243.3c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C272.4,243.6,272.5,243.5,272.6,243.3
		C272.6,243.4,272.6,243.3,272.6,243.3z"
      />
      <path
        class="st3"
        d="M272.7,243.1c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1C272.8,243.2,272.7,243.2,272.7,243.1z"
      />
      <path
        class="st3"
        d="M246.2,248.5C246.3,248.4,246.3,248.4,246.2,248.5C246.2,248.4,246.2,248.4,246.2,248.5L246.2,248.5z"
      />
      <path
        class="st3"
        d="M246.3,248.3c0,0,0,0.1-0.1,0.1C246.3,248.4,246.3,248.4,246.3,248.3L246.3,248.3z"
      />
      <path
        class="st3"
        d="M207.6,256.4l0.1,0.1l0.1-0.1l-0.1-0.1C207.6,256.3,207.6,256.3,207.6,256.4z"
      />
      <path
        class="st3"
        d="M240.9,264.7c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C240.8,264.9,240.8,264.8,240.9,264.7z"
      />
      <polygon class="st3" points="9,297.5 9.1,297.5 9,297.4 	" />
      <path
        class="st3"
        d="M199.9,274l0.1,0.1l0.1-0.1l-0.1-0.1C200,273.9,199.9,273.9,199.9,274z"
      />
      <path
        class="st3"
        d="M45.9,307.9c0,0.1,0,0.1,0,0.2L46,308C46,307.9,46,307.9,45.9,307.9z"
      />
      <polygon class="st3" points="200.4,274.5 200.5,274.6 200.5,274.5 	" />
      <path
        class="st3"
        d="M290.4,255.1c-0.1,0-0.2,0-0.3,0C290.2,255.2,290.3,255.2,290.4,255.1c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C290.7,255.3,290.6,255.2,290.4,255.1z"
      />
      <path
        class="st3"
        d="M208.3,253.4C208.3,253.5,208.4,253.5,208.3,253.4C208.4,253.5,208.4,253.5,208.3,253.4c0.1,0.1,0.1,0,0.1,0
		C208.4,253.5,208.3,253.5,208.3,253.4z"
      />
      <polygon class="st3" points="296.4,234 296.3,233.9 296.3,234 	" />
      <polygon class="st3" points="42.2,310 42.3,310.1 42.3,310 	" />
      <path
        class="st3"
        d="M289.9,256.2c0,0,0-0.1-0.1-0.1C289.8,256.2,289.8,256.2,289.9,256.2c0.1,0.1,0.2,0.2,0.4,0.3h0.1
		c0,0,0-0.1-0.1-0.1C290.2,256.4,290,256.3,289.9,256.2z"
      />
      <path
        class="st3"
        d="M240.7,267.3c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C240.6,267.5,240.7,267.4,240.7,267.3z"
      />
      <path
        class="st3"
        d="M234,246.2c0,0-0.1-0.1-0.2-0.1l0,0l0,0C233.9,246.2,234,246.2,234,246.2z"
      />
      <path
        class="st3"
        d="M249.3,265.7c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C249.4,265.8,249.3,265.7,249.3,265.7z"
      />
      <path
        class="st3"
        d="M141.4,263.2l0.1,0.1l0.1-0.1l-0.1-0.1C141.5,263,141.5,263.1,141.4,263.2z"
      />
      <path
        class="st3"
        d="M252.6,237.3L252.6,237.3c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L252.6,237.3z"
      />
      <path
        class="st3"
        d="M240,240l0.1-0.1l-0.1-0.1l-0.1,0.1C239.9,240,239.9,240,240,240z"
      />
      <path
        class="st3"
        d="M262.8,234.6c0,0.1,0,0.2,0.1,0.2l0.1-0.1C263,234.6,262.9,234.6,262.8,234.6z"
      />
      <path
        class="st3"
        d="M201.2,246.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C201.3,246.6,201.3,246.7,201.2,246.7z"
      />
      <path
        class="st3"
        d="M253.5,235C253.6,235,253.6,235,253.5,235c0.1-0.1,0.1-0.1,0.1-0.1S253.6,234.9,253.5,235L253.5,235z"
      />
      <path
        class="st3"
        d="M253.4,235.1l0.1-0.1C253.5,235,253.5,235,253.4,235.1C253.4,235,253.5,235.1,253.4,235.1z"
      />
      <polygon class="st3" points="203.6,244.7 203.6,244.6 203.5,244.7 	" />
      <path
        class="st3"
        d="M220.7,273.8l0.1,0.1C220.8,273.9,220.8,273.8,220.7,273.8L220.7,273.8z"
      />
      <path
        class="st3"
        d="M220.8,274C220.8,274,220.8,273.9,220.8,274L220.8,274c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C221.1,273.9,221,274,220.8,274z"
      />
      <path
        class="st3"
        d="M114.8,297.6l-0.1,0.1l0.1,0.1l0.1-0.1C114.9,297.7,114.8,297.7,114.8,297.6z"
      />
      <polygon class="st3" points="85.2,306.1 85.3,306 85.2,306 	" />
      <polygon class="st3" points="179.8,286.8 179.9,286.8 179.9,286.7 	" />
      <polygon class="st3" points="181.7,286.7 181.9,286.7 181.9,286.6 	" />
      <path
        class="st3"
        d="M235.9,275c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C235.8,275.1,235.8,275,235.9,275z"
      />
      <polygon class="st3" points="69.9,314.8 70,314.7 69.9,314.7 	" />
      <polygon class="st3" points="237.7,279 237.8,279 237.8,278.9 	" />
      <polygon
        class="st3"
        points="172.1,302.2 172.2,302.3 172.2,302.2 172.3,302.2 172.2,302.2 	"
      />
      <path
        class="st3"
        d="M44.1,334.7c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C44.1,334.6,44.1,334.7,44.1,334.7z"
      />
      <path
        class="st3"
        d="M224.9,298.6L224.9,298.6c0.1-0.1,0.1-0.1,0.1-0.1l0,0L224.9,298.6z"
      />
      <path
        class="st3"
        d="M203.7,316.1l0.1,0.1l0.1-0.1C203.9,316,203.8,316,203.7,316.1C203.8,316,203.7,316,203.7,316.1z"
      />
      <path
        class="st3"
        d="M229.4,313.7l-0.1-0.1l-0.1,0.1l0.1,0.1C229.3,313.8,229.3,313.8,229.4,313.7z"
      />
      <polygon class="st3" points="193.8,333.6 193.9,333.6 193.9,333.5 	" />
      <path
        class="st3"
        d="M228.1,268c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C228.2,267.8,228.2,267.9,228.1,268z"
      />
      <path
        class="st3"
        d="M57.7,144.1c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5
		c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C56.5,142.9,57.1,143.5,57.7,144.1z"
      />
      <path
        class="st3"
        d="M120.4,135.3c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0c1.2-0.3,1.7-1.2,1.3-2.9
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6
		c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8
		c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0
		c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1C119.7,134,119.8,134.6,120.4,135.3z"
      />
      <path
        class="st3"
        d="M4.6,180.4c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C4.1,179,4.1,179.7,4.6,180.4C4.6,180.3,4.6,180.4,4.6,180.4z"
      />
      <path
        class="st3"
        d="M82.9,122c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C83.8,118.3,82.5,120.3,82.9,122z"
      />
      <path
        class="st3"
        d="M198.3,116.5c0.9-0.8,0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.2-0.6,0.6-1,0.9-1.5c-0.5,0-1,0-1.4,0
		c0.1,0.1,0.2,0.2,0.3,0.2c0,0.8-0.3,1.3-1.1,1.8c-0.1,0-0.1,0.1-0.2,0.1c0,0.9,0,1.8,0,2.8C196.4,117.4,197.5,117.3,198.3,116.5z"
      />
      <path
        class="st3"
        d="M199.6,110.5c-0.8,0-1.6,0-2.5,0c0,0.1-0.1,0.1-0.1,0.2c0.8,0,1.6,0,2.4,0
		C199.4,110.6,199.5,110.6,199.6,110.5z"
      />
      <path
        class="st3"
        d="M184.5,118.1c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.2,1.5,2.4,2.3,3.6c0-0.9,0-1.8,0-2.7c-0.4-0.4-0.6-0.8-0.9-1.2c-0.2-0.2-0.5-0.5-0.8-0.5
		c-1.3-0.2-2.1-0.8-2.4-1.7c0,0.8,0,1.5,0,2.2C184.5,117,184.7,117.5,184.5,118.1z"
      />
      <path
        class="st3"
        d="M189.6,123.5c0,0.5,0,0.9,0,1.4c0.3,0.2,0.7,0.4,1.4,0.2c0.1-0.4,0.2-0.9,0.3-1.3c0.2,0,0.4,0,0.8,0.1
		c0-0.1,0-0.2,0-0.3c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C190.6,123.5,190.1,123.5,189.6,123.5z"
      />
      <path
        class="st3"
        d="M190.5,122.4c0,0,0-0.1-0.1-0.1C190.5,122.4,190.5,122.4,190.5,122.4c0.5,0,1,0,1.4,0
		c-0.3-0.8-0.3-1.6-1.4-1.9c-0.2-0.7-0.7-1.2-1.3-1.5c0,1.1,0.1,2.3,0.4,3.5C189.9,122.4,190.2,122.4,190.5,122.4z"
      />
      <path
        class="st3"
        d="M95.8,125.2c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C96.5,125.1,96.1,125.2,95.8,125.2z"
      />
      <path
        class="st3"
        d="M65.8,148.9c2-0.4,3.5-2.1,3.2-3.8c-0.3-1.8-2.3-2.8-4.4-2.4c-2.1,0.5-3.4,2.1-3,3.8
		C61.8,148.2,63.7,149.3,65.8,148.9z"
      />
      <path
        class="st3"
        d="M226.2,133c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2
		c0.1,0.2,0.3,0.4,0.4,0.6c1.8,0.1,3.4,0.8,5,0.1c0-1.4,0-2.8,0-4.2c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0-0.1,0
		C228.9,132.2,227.5,132.3,226.2,133C226.3,133,226.3,133,226.2,133z"
      />
      <path
        class="st3"
        d="M231.7,134c0-0.1,0-0.1,0-0.2c0,0,0,0-0.1,0c0,0.2,0,0.3,0,0.4C231.7,134.2,231.7,134.1,231.7,134z"
      />
      <path
        class="st3"
        d="M96.7,123.7c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C95.9,121.6,95.9,122.8,96.7,123.7z"
      />
      <path
        class="st3"
        d="M301.8,114.5L301.8,114.5c-1.6-0.1-3.2-0.1-4.8-0.1c0,0.1,0,0.1,0,0.2l0,0
		C298.6,114.6,300.1,114.6,301.8,114.5C301.8,114.6,301.8,114.6,301.8,114.5z"
      />
      <path
        class="st3"
        d="M97.9,135.1c1-0.2,1.9-0.8,2.4-1.6c0.3-0.5,0.5-1.1,0.4-1.7c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.2-2.1-1.8-3.6-1.5
		c-1.8,0.4-3,1.9-2.6,3.4C94.5,134.5,96.3,135.4,97.9,135.1z"
      />
      <path
        class="st3"
        d="M107.8,126.9c-0.3-1.5-2-2.4-3.8-2c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2
		C107,129.8,108.1,128.4,107.8,126.9z"
      />
      <path
        class="st3"
        d="M220.4,116.2c1.7-0.4,2.8-1.9,2.5-3.3l0,0c-1.9-0.1-3.6-0.2-5.6-0.3c0,1,0,1.9,0,2.9
		C218,116.1,219.1,116.4,220.4,116.2z"
      />
      <path
        class="st3"
        d="M221.6,111.3c-0.1,0-0.2-0.1-0.2-0.1c-0.9,0-1.9,0-2.8,0c-0.1,0-0.2,0.1-0.3,0.1s-0.1,0.1-0.2,0.1
		C219.3,111.4,220.4,111.4,221.6,111.3C221.6,111.4,221.6,111.4,221.6,111.3z"
      />
      <path
        class="st3"
        d="M93.1,138.1c0.3-0.5,0.4-1,0.2-1.6c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6
		c-0.9,0.6-1.4,1.6-1.1,2.6c0.2,0.8,0.8,1.4,1.6,1.7c0.6,0.3,1.4,0.4,2.1,0.2C91.9,139.5,92.7,138.9,93.1,138.1z"
      />
      <path
        class="st3"
        d="M40.3,162.7c0.5,0.2,1,0.1,1.5-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.3-0.2-0.5
		c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9c-0.9,0.4-1.5,1.4-1.2,2.3
		c0.3,1,1.2,1.4,3.2,1.2C39.3,162.2,39.9,162.5,40.3,162.7z"
      />
      <path
        class="st3"
        d="M109.9,130.8c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6
		c-0.9,0.4-2.1,0.5-2,1.5c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2
		c1.1-0.4,1.7-1.2,1.7-2.2c0-0.6-0.3-1.2-0.7-1.5C111.3,131,110.6,130.8,109.9,130.8z"
      />
      <path
        class="st3"
        d="M25.4,135.7c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9s-1.8-2-3.2-1.7
		C26.3,133.2,25.2,134.5,25.4,135.7z"
      />
      <path
        class="st3"
        d="M98.1,143.4c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.1h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4s-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0
		C96.7,145,97.7,144.4,98.1,143.4z"
      />
      <path
        class="st3"
        d="M105.2,138.6c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1s-0.6,0.2-0.8,0.3
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5c0.3-0.1,0.6-0.2,0.8-0.3
		C104.6,139.5,105,139.1,105.2,138.6z"
      />
      <path
        class="st3"
        d="M35,143.7c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C31.8,143.6,33.5,144.3,35,143.7z"
      />
      <path
        class="st3"
        d="M59.2,133.9c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C56.4,133.4,57.7,134.2,59.2,133.9z"
      />
      <path
        class="st3"
        d="M246.1,74.9c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C245.9,73.3,246,74.2,246.1,74.9z"
      />
      <path
        class="st3"
        d="M298.3,119.3c-1,0.2-1.7,0.8-2.1,1.5c-0.2,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6
		c1.4-0.3,2.4-1.5,2.2-2.6C301.2,119.7,299.8,119,298.3,119.3z"
      />
      <path
        class="st3"
        d="M102.2,146.9c-0.4-0.2-0.8-0.4-1.3-0.6c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3
		c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2
		s1.3,0.8,2.2,0.7c0.9-0.2,1.5-0.7,1.8-1.5C103.2,148,102.9,147.4,102.2,146.9z"
      />
      <path
        class="st3"
        d="M19.5,164.1c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1
		c-0.2-0.4-0.4-0.7-0.6-1.1c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3
		c-0.9,0.9-1,1.8-0.5,2.7C17.2,164.7,18.3,164.9,19.5,164.1z"
      />
      <path
        class="st3"
        d="M66,179.3c0.2,0.4,0.7,0.8,1.5,1.2c1-0.4,1.5-1,1.6-1.9c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.9-1-1.6-1.3
		c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1
		c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8
		c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1C66,178,65.7,178.7,66,179.3z"
      />
      <path
        class="st3"
        d="M72.2,167.6L72.2,167.6c-0.3,0-0.5-0.1-0.7-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0.4,0.1,0.8,0.2,1.2,0.2
		c0.4,0.1,0.7,0.2,1,0.3l0,0c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c1,1.3,1,1.3,2.6,1c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0
		c-0.7-0.1-1.3-0.3-2-0.4c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1C72.6,167.7,72.4,167.7,72.2,167.6z"
      />
      <path
        class="st3"
        d="M250.5,97.7C250.4,97.7,250.4,97.7,250.5,97.7c-0.5,0.9-0.4,2-0.7,3.3c0.6,0,1.1,0,1.7,0
		c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.4,0-0.8,0.1-1.3C251.6,98.7,251.2,98,250.5,97.7z"
      />
      <path
        class="st3"
        d="M110.1,143c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1
		c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1-0.1,0.1-0.2,0.2-0.2C110.1,143.8,110.2,143.4,110.1,143z"
      />
      <path
        class="st3"
        d="M265.7,92.7c0.5,0.1,1.1,0.2,1.5,0c0.8-0.3,1.5-0.7,2.2-1.1c-0.2-1.1-0.5-1.6-0.9-2.2
		c-0.5-0.6-1.2-0.7-1.9-0.5c-0.4,0.1-0.8,0.3-1.2,0.6c0,1,0.1,1.9,0.3,2.9C265.6,92.5,265.7,92.6,265.7,92.7z"
      />
      <path
        class="st3"
        d="M126,110c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C125.2,109.5,125.5,109.9,126,110z"
      />
      <path
        class="st3"
        d="M65.1,128.2c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C62.6,127.9,63.8,128.5,65.1,128.2z"
      />
      <path
        class="st3"
        d="M82.2,117.5c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C79.8,117.1,81,117.7,82.2,117.5z"
      />
      <path
        class="st3"
        d="M282.6,128.2l0.1,0.1c0.2,0,0.3,0,0.5-0.1C283,128.2,282.8,128.2,282.6,128.2z"
      />
      <path
        class="st3"
        d="M281.3,127.1c1.6,0,3.2,0,4.9,0c0-0.4,0-0.8,0-1.1c-0.7-0.4-1.4,0-2.3,0.2c-0.3-1.3-1.7-0.7-2.7-1
		c-0.3,0.4-0.5,0.8-0.8,1.1C280.8,126.6,281.1,126.8,281.3,127.1z"
      />
      <path
        class="st3"
        d="M284.5,128.3c0.3,0.1,0.6,0.1,0.9,0.1C285.1,128.4,284.8,128.3,284.5,128.3z"
      />
      <path
        class="st3"
        d="M68.5,131.5c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C68.4,131.2,68.4,131.3,68.5,131.5z"
      />
      <path
        class="st3"
        d="M95.8,153.5c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-1,0.2-1.8,0.9-1.9,1.7c0,0.2,0,0.3,0,0.5
		c0.2,1.1,1.3,1.7,2.6,1.5c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5C95.5,154.2,95.7,153.9,95.8,153.5z"
      />
      <path
        class="st3"
        d="M252.4,98.6c0.5,0.3,1.2,0.5,2.2,0.7c-0.1,0.7,0,1.2,0.4,1.6c0.4,0,0.7,0,1.1,0c0.3-0.7,0.1-0.9-0.8-1.9
		c0.9-0.9,0.9-1,0.6-1.4c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C251.5,97,251.4,98,252.4,98.6z"
      />
      <path
        class="st3"
        d="M286.2,120.8c-0.2,0.2-0.3,0.3-0.5,0.4c0.2,0.1,0.4,0.2,0.5,0.4C286.2,121.4,286.2,121.1,286.2,120.8z"
      />
      <path
        class="st3"
        d="M290,122.7c0.9-0.8,0.9-2,0.1-2.7c-0.7-0.5-1.6-0.6-2.5-0.2c0,1.1,0,2.2,0,3.2
		C288.4,123.3,289.4,123.3,290,122.7z"
      />
      <path
        class="st3"
        d="M28.2,146.6c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C27.6,148.6,28.4,147.6,28.2,146.6z"
      />
      <path
        class="st3"
        d="M81.2,128.1c-0.4-1.6-0.1-3.4-0.8-5c-2.1,0.8-3,1.8-2.6,3.2C78.1,127.7,79.2,128.3,81.2,128.1z"
      />
      <path
        class="st3"
        d="M34.1,152.9c-0.3-1-1.3-1.5-2.6-1.2c-1.2,0.3-2,1.3-1.8,2.3c0.2,0.9,1.5,1.6,2.6,1.3
		C33.5,155,34.3,153.9,34.1,152.9z"
      />
      <path
        class="st3"
        d="M43.8,158.9c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C43.3,156.1,43.1,157.5,43.8,158.9z"
      />
      <path
        class="st3"
        d="M87.2,131.2c-0.2-0.9-1.3-1.5-2.4-1.3c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2
		C86.6,133.1,87.4,132.1,87.2,131.2z"
      />
      <path
        class="st3"
        d="M259.5,113.1c0,0-0.1,0.1-0.1,0.2c0.1,0,0.3,0,0.4,0c0-0.1,0-0.1,0-0.2C259.8,113.1,259.6,113.1,259.5,113.1z"
      />
      <path
        class="st3"
        d="M2.2,133C2,132.1,1,131.6,0,131.7v3.6c0.2,0,0.3,0,0.5-0.1C1.7,135,2.5,134,2.2,133z"
      />
      <path
        class="st3"
        d="M88.7,149.9C88.8,149.9,88.8,149.9,88.7,149.9c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C88.4,149.7,88.5,149.8,88.7,149.9z"
      />
      <path
        class="st3"
        d="M70.6,138.9c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C71.9,139.1,71.2,138.8,70.6,138.9z"
      />
      <path
        class="st3"
        d="M62.2,170.3c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.8,0.2-1.1,0.8-1,1.4
		c0.1,0.5,0.4,0.9,0.8,1.3c0.5,0.4,1.2,0.5,2,0.2c0.1-0.9-1.7-1.1-0.5-2.2C60.6,170.5,61.3,171.1,62.2,170.3z"
      />
      <path
        class="st3"
        d="M143.3,128.4c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.3,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C143.1,128,143.2,128.3,143.3,128.4z"
      />
      <path
        class="st3"
        d="M235.5,120.3c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2c0.2,0,0.3-0.1,0.4-0.2c0-0.9,0-1.9,0-2.8
		c-0.1,0-0.1,0-0.2-0.1c-0.2,0-0.5,0-0.8,0C236,118.7,235.3,119.4,235.5,120.3z"
      />
      <path
        class="st3"
        d="M191.7,99.2c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C189.4,99,190.4,99.5,191.7,99.2z"
      />
      <path
        class="st3"
        d="M136.6,100.2c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C135.2,99.3,135.6,99.8,136.6,100.2z"
      />
      <path
        class="st3"
        d="M276.5,123.3c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.6-1.2-0.7
		c-0.1,0.1-0.1,0.1-0.1,0.2c0.5,1.1,1.2,2.1,1.9,3C276.6,123.8,276.6,123.6,276.5,123.3z"
      />
      <path
        class="st3"
        d="M118.5,144.9c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0c1-0.2,1.7-1.1,1.5-1.9c-0.2-0.8-1.1-1.2-2-1.1
		c-1,0.2-1.6,0.9-1.6,1.7C118.4,144.7,118.5,144.8,118.5,144.9z"
      />
      <path
        class="st3"
        d="M58.7,126.6c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C56.7,126.2,57.7,126.8,58.7,126.6z"
      />
      <path
        class="st3"
        d="M300.5,87.6c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C300.3,87.4,300.4,87.5,300.5,87.6z"
      />
      <path
        class="st3"
        d="M26.3,163.5c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8
		C26,165.1,26.6,164.3,26.3,163.5z"
      />
      <path
        class="st3"
        d="M113.2,150.7C113.3,150.7,113.3,150.7,113.2,150.7c1.1-0.2,1.7-1,1.5-1.8c-0.1-0.3-0.2-0.5-0.4-0.7
		c-0.4-0.4-1-0.6-1.6-0.5c-0.9,0.2-1.6,1-1.5,1.8C111.5,150.3,112.3,150.8,113.2,150.7z"
      />
      <path
        class="st3"
        d="M233,100.6c1,0,1.9,0.1,2.9,0.1c0.4-0.4,0.6-1,0.5-1.4c-0.2-0.7-0.9-1.1-1.7-0.9
		C233.6,98.6,232.7,99.7,233,100.6C232.9,100.5,233,100.5,233,100.6z"
      />
      <path
        class="st3"
        d="M42.6,135.9c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C41.5,134.4,41.8,135.2,42.6,135.9z"
      />
      <path
        class="st3"
        d="M190.6,116.9c0.1,0.8,0.8,1.1,1.6,0.8c0.6-0.3,1.1-0.7,1.6-0.9c0-0.9,0-1.7,0-2.8c-0.9,0.5-1.6,0.8-2.1,1.2
		C191,115.6,190.5,116.2,190.6,116.9z"
      />
      <path
        class="st3"
        d="M24.1,160.3h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C22.2,160.1,23.2,160.5,24.1,160.3z"
      />
      <path
        class="st3"
        d="M51.2,142.6c0.3-1.9-0.6-2.7-3-2.8C47.5,141.8,48.4,142.8,51.2,142.6z"
      />
      <path
        class="st3"
        d="M75.3,130c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8C73.6,129.8,74.4,130.2,75.3,130z"
      />
      <path
        class="st3"
        d="M94.5,117.7c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C92.7,117.5,93.6,117.9,94.5,117.7z"
      />
      <path
        class="st3"
        d="M71.5,176.3c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0
		c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6l0.3,0.1c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0
		C70.5,176.3,71,176.3,71.5,176.3z"
      />
      <path
        class="st3"
        d="M105.4,118.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C105.9,117.1,105.3,117.8,105.4,118.6z"
      />
      <path
        class="st3"
        d="M104.2,115C104.2,115,104.3,115,104.2,115c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3
		c-0.2-0.6-0.9-0.9-1.7-0.8c-0.9,0.1-1.6,1-1.5,1.7C102.5,114.7,103.3,115.2,104.2,115z"
      />
      <path
        class="st3"
        d="M245.4,124.6c0.1,0.2,0.3,0.3,0.4,0.4c0-0.7,0-1.4,0-2.1c-0.5-0.2-1-0.4-1.5-0.5c-0.3-0.1-0.9,0-1.2,0.2
		c-0.4,0.3-0.2,0.6,0,0.9c0.1,0.1,0.1,0.3,0.2,0.5C244.2,123.9,244.9,123.9,245.4,124.6z"
      />
      <path
        class="st3"
        d="M247.2,124.6c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-0.2-0.2-0.3-0.3-0.4C247.2,124.1,247.2,124.3,247.2,124.6z"
      />
      <path
        class="st3"
        d="M31.4,164.6c-0.3-0.6-0.9-0.9-1.7-0.9c-0.9,0.1-1.5,0.4-1.7,1.3c0.8,0.5,1.5,1.1,2.4,1.7
		C31.4,166.1,31.8,165.4,31.4,164.6z"
      />
      <path
        class="st3"
        d="M134,98.3c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C133.7,100.3,134.2,99.3,134,98.3z"
      />
      <path
        class="st3"
        d="M271.4,93.8c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C270.9,93.5,271.1,93.7,271.4,93.8z"
      />
      <path
        class="st3"
        d="M40.5,150c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C38.3,150.1,39,150.3,40.5,150z"
      />
      <path
        class="st3"
        d="M151,141.2c0,0.3,0.5,0.6,0.8,0.8h0.1c0-0.7,0-1.3,0-2c-0.1,0-0.2,0.1-0.2,0.1
		C151.3,140.5,150.9,140.9,151,141.2z"
      />
      <path
        class="st3"
        d="M72.6,149.8c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C72.3,151.1,72.8,150.5,72.6,149.8z"
      />
      <path
        class="st3"
        d="M295.8,101c0.8-0.1,1.4-0.8,1.3-1.5s-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4C294.2,100.7,295,101.2,295.8,101
		z"
      />
      <path
        class="st3"
        d="M255.8,115c0.1-0.3,0.1-0.5,0.1-0.8c-0.3,0-0.6,0-0.9,0.1C255.3,114.5,255.6,114.7,255.8,115z"
      />
      <path
        class="st3"
        d="M132.4,143.9c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.7,1,1.1,1.8,0.9c0.7-0.2,1.3-0.8,1.2-1.4
		C134,144.2,133.2,143.8,132.4,143.9z"
      />
      <path
        class="st3"
        d="M59.2,158.8c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C61.9,158.9,61.4,158.6,59.2,158.8z"
      />
      <path
        class="st3"
        d="M42.6,148c0.1-1.6-0.4-2.1-2.6-2.4C39.8,147.5,40.5,148.1,42.6,148z"
      />
      <path
        class="st3"
        d="M36.7,165c-0.7,0.1-1.1,0.5-1.2,1.1c-0.1,0.9,0.7,1.2,1.6,1.3c0.1-0.1,0.2-0.2,0.3-0.2
		c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3C37.6,165,37.2,164.9,36.7,165z"
      />
      <path
        class="st3"
        d="M256.2,93.5c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C255.3,93.1,255.8,93.3,256.2,93.5z"
      />
      <path
        class="st3"
        d="M141.1,135.8c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8c-0.6,0.2-1.1,0.5-1.7,0.7
		c0.4,0.4,0.7,1.1,1.2,1.2C139.7,136.3,140.4,136,141.1,135.8z"
      />
      <path
        class="st3"
        d="M124.8,150.9c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2c-0.2,0.2-0.4,0.3-0.7,0.6
		C124.1,150.4,124.5,150.7,124.8,150.9z"
      />
      <path
        class="st3"
        d="M10.1,187.8c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C9,187.1,9.3,187.6,10.1,187.8z"
      />
      <path
        class="st3"
        d="M19.2,170.6c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.7,0.2C18.9,170.6,19,170.6,19.2,170.6z"
      />
      <path
        class="st3"
        d="M65.9,164.8c0.6,0.4,1.3,0.5,2,0.3c0.2-0.1,0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.5-1.5-1-1.7-2.9-1.6
		C64.8,163.9,65.3,164.4,65.9,164.8z"
      />
      <path
        class="st3"
        d="M267.1,80.9c0.1,0,0.2,0,0.3,0C267.3,80.8,267.2,80.8,267.1,80.9C267.1,80.8,267.1,80.9,267.1,80.9z"
      />
      <path
        class="st3"
        d="M111,139.3c0.3-0.3,0.4-0.6,0.3-1c0-0.1-0.1-0.1-0.1-0.1c-0.2-0.5-0.9-0.8-1.6-0.6s-1.1,0.7-1,1.3
		c0.1,0.7,0.8,1,1.6,0.8C110.6,139.7,110.8,139.5,111,139.3z"
      />
      <path
        class="st3"
        d="M86.8,150.6c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4c0.1,0.6,0.9,1,1.6,0.8
		C86.4,151.8,87,151.3,86.8,150.6z"
      />
      <path
        class="st3"
        d="M132.1,121.4c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C131.6,122.4,132,122,132.1,121.4z"
      />
      <path
        class="st3"
        d="M206.5,110.5c-0.1,0-0.1,0-0.2,0H206.5C206.5,110.6,206.5,110.6,206.5,110.5z"
      />
      <path
        class="st3"
        d="M110.1,111.7c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4S109.4,112,110.1,111.7
		z"
      />
      <path
        class="st3"
        d="M16.1,175.4c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C14.7,175.1,15.4,175.5,16.1,175.4z"
      />
      <path
        class="st3"
        d="M110.5,122.5c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C110.9,121.9,110.6,122.2,110.5,122.5z"
      />
      <path
        class="st3"
        d="M26.5,110.8c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.6-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C25.2,110.5,25.9,110.9,26.5,110.8z"
      />
      <path
        class="st3"
        d="M139.6,124.2c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C140.6,125.5,140.4,124.7,139.6,124.2z"
      />
      <path
        class="st3"
        d="M145.7,133.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1
		c0,0.4,0.1,0.8,0.7,0.9c0.6,0,1.2-0.1,1.7-0.1C146.2,134.8,146.3,134.2,145.7,133.9z"
      />
      <path
        class="st3"
        d="M146.2,135.4L146.2,135.4C146.1,135.3,146.1,135.3,146.2,135.4C146.1,135.4,146.1,135.4,146.2,135.4
		C146.1,135.4,146.2,135.4,146.2,135.4z"
      />
      <path
        class="st3"
        d="M100.6,97.9c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C99.2,97.6,99.9,98,100.6,97.9z"
      />
      <path
        class="st3"
        d="M245,133.3c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C244.1,133.1,244.6,133.4,245,133.3z"
      />
      <path
        class="st3"
        d="M77.8,122c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C76.6,121.8,77.2,122.1,77.8,122z"
      />
      <path
        class="st3"
        d="M146.8,135.9c0.5,0.1,0.9,0.2,1.1,0.6c0.2,0.4,0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2s-1.1-0.6-1.7-0.9
		c-0.4,0.2-0.7,0.4-1.1,0.6C146.4,135.6,146.6,135.9,146.8,135.9z"
      />
      <path
        class="st3"
        d="M84.5,177.6c0.3-0.3,0.7-0.7,0.9-1.1c0.1-0.3,0-0.7-0.2-0.9c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1
		c-0.4,0.3-0.9,0.7-0.9,1.2C83,177.4,83.7,177.5,84.5,177.6z"
      />
      <path
        class="st3"
        d="M24.1,127.1c-0.2,1.2-0.3,2.4-0.4,3.5C25.6,129.2,25.7,128.2,24.1,127.1z"
      />
      <path
        class="st3"
        d="M239.5,132.5c0,0.5,0,1.1,0,1.6c0.1,0.1,0.3,0.1,0.4,0.2c0.3,0.1,0.7-0.2,1.1-0.3
		C240.4,132.7,240.1,132.3,239.5,132.5z"
      />
      <path
        class="st3"
        d="M137.3,151.6c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0
		c-0.3,0.1-0.5,0.2-0.7,0.5l0,0C136.5,150.9,136.8,151.4,137.3,151.6z"
      />
      <path
        class="st3"
        d="M2.8,184.7c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C2.8,184.6,2.8,184.7,2.8,184.7z"
      />
      <path
        class="st3"
        d="M48.6,153.8c-0.3-1.3-0.4-1.4-2.2-1.8C46.3,153.7,47,154.2,48.6,153.8z"
      />
      <path
        class="st3"
        d="M246.7,70.8c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C245.6,70.5,246.1,70.9,246.7,70.8z"
      />
      <path
        class="st3"
        d="M136.1,103.3c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2S135.4,103.2,136.1,103.3z"
      />
      <path
        class="st3"
        d="M128.9,101.4c0.1,0.5,0.7,0.9,1.2,0.8s0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C129.2,100.2,128.8,100.9,128.9,101.4z"
      />
      <path
        class="st3"
        d="M82.4,171.6c-1.6,1.4-1.6,1.4-0.7,2.4C83.6,172.6,83.6,172.6,82.4,171.6z"
      />
      <path
        class="st3"
        d="M91.8,164.6c0.5-0.1,0.9-0.5,1-0.9c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.5-0.4-0.9-0.3
		c-0.4,0.1-0.7,0.3-0.9,0.5c-0.1,0.1-0.2,0.3-0.2,0.5s0.2,0.4,0.4,0.6C91.1,164.6,91.5,164.7,91.8,164.6z"
      />
      <path
        class="st3"
        d="M259.2,84.1c0.5-0.2,0.8-0.5,0.9-1c0-0.2-0.1-0.4-0.1-0.6c-1.1,0-1.9,0.3-2.5,1.1
		C257.9,84.2,258.5,84.3,259.2,84.1z"
      />
      <path
        class="st3"
        d="M94.4,157c0.7-0.6,0.5-0.9-0.9-1.5c-1.1,1.1-1.1,1.3,0,2c0.2-0.1,0.3-0.2,0.4-0.2
		C94.1,157.2,94.3,157.1,94.4,157z"
      />
      <path
        class="st3"
        d="M39.4,128.7c-0.1-0.9-0.7-1.4-1.9-1.6C37.1,128.8,37.7,129.3,39.4,128.7z"
      />
      <path
        class="st3"
        d="M187.4,110L187.4,110c-0.3-0.1-0.6-0.1-0.8-0.1c0,0.1,0.1,0.1,0.2,0.1C187,110,187.2,110,187.4,110z"
      />
      <path
        class="st3"
        d="M178.1,113.9c0-0.4,0-0.9,0-1.3c-0.4,0.2-0.7,0.5-1.2,0.8c0.4,0.3,0.7,0.5,1,0.6
		C178,113.9,178,113.8,178.1,113.9z"
      />
      <path
        class="st3"
        d="M185.8,119.7c0.1,0.8-0.3,1.5-0.2,2.2c0.4,0,0.8,0,1.2,0C187,121.2,186.9,120.4,185.8,119.7z"
      />
      <path
        class="st3"
        d="M87.3,144.3c-0.1-0.4-0.7-0.7-1.2-0.6c-0.5,0.1-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6
		C86.9,145.4,87.4,144.7,87.3,144.3z"
      />
      <path
        class="st3"
        d="M50.5,158.2c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C50.8,157.9,50.6,158.1,50.5,158.2z"
      />
      <path
        class="st3"
        d="M280.3,119.3c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1c-0.1,0.2-0.3,0.4-0.5,0.6c0,0.5,0,1,0,1.4
		c0.1-0.1,0.1-0.2,0.2-0.3C279.7,119.7,280,119.5,280.3,119.3z"
      />
      <path
        class="st3"
        d="M176.6,130.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.1-0.5-0.6-0.5-1.8,0
		C176.4,130.5,176.5,130.8,176.6,130.9z"
      />
      <path
        class="st3"
        d="M107.2,103.7c-1.3,0.9-1.3,0.9-0.8,2C108,104.6,108,104.6,107.2,103.7z"
      />
      <path
        class="st3"
        d="M150.2,133.3c-0.5,0.1-1,0.2-1.5,0.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2
		C150.1,134.3,150.4,134,150.2,133.3z"
      />
      <path
        class="st3"
        d="M114.9,110.9c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C113.2,111.3,113.7,111.3,114.9,110.9z"
      />
      <path
        class="st3"
        d="M286.1,133.1c-0.2-0.1-0.4-0.2-0.8-0.2c-0.2,0.6-0.4,1.1-0.7,1.9c0,0.1,0.1,0.1,0.2,0.2c0.6-0.1,1-0.3,1.3-0.5
		C286.1,134,286.1,133.5,286.1,133.1z"
      />
      <path
        class="st3"
        d="M246.2,82.2c0.3-0.5,0.7-0.8,0.7-1.2c0-0.4-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C245.4,81.8,245.8,81.9,246.2,82.2z"
      />
      <path
        class="st3"
        d="M129.4,129.8c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C128.4,129.5,128.9,130,129.4,129.8z"
      />
      <path
        class="st3"
        d="M1.3,173c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1v1.3c0.2,0.1,0.5,0.3,0.7,0.5
		C1,173.7,1.3,173.3,1.3,173z"
      />
      <path
        class="st3"
        d="M128.7,88.9c0.5-1.1,0.5-1.1-0.8-1.8C127.5,88.5,127.5,88.5,128.7,88.9z"
      />
      <path
        class="st3"
        d="M2.5,122.3c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1
		C1.5,122.3,1.9,122.5,2.5,122.3z"
      />
      <path
        class="st3"
        d="M186.7,115c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C186.2,114.2,186,114.7,186.7,115z"
      />
      <path
        class="st3"
        d="M138.4,97.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9
		C137.7,97.2,138.1,97.3,138.4,97.5z"
      />
      <path
        class="st3"
        d="M56.2,155.3c-0.5-0.6-1-1-1.9-1C54.2,155.8,54.6,155.9,56.2,155.3z"
      />
      <path
        class="st3"
        d="M119.3,106.8c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C117.8,106.4,118.3,106.6,119.3,106.8z"
      />
      <path
        class="st3"
        d="M177.6,118.2c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C177.2,118.6,177.4,118.4,177.6,118.2z"
      />
      <path
        class="st3"
        d="M128.1,117.6L128.1,117.6c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3c0.3,0.2,0.5,0.5,0.7,0.6
		c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C128.1,118,128.2,117.7,128.1,117.6z"
      />
      <path
        class="st3"
        d="M259.6,98.3c0,0.2,0.5,0.6,0.8,0.6s0.5-0.4,1-0.7v-0.1c-0.5-0.2-0.8-0.5-1.1-0.5
		C260,97.7,259.5,98.1,259.6,98.3z"
      />
      <path
        class="st3"
        d="M129.5,104.6c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0s-0.2,0.6-0.1,0.8
		C128.6,104.1,129.1,104.3,129.5,104.6z"
      />
      <path
        class="st3"
        d="M281.5,129.1c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C282.2,128.5,281.7,128.5,281.5,129.1z"
      />
      <path
        class="st3"
        d="M254.2,116.2c-0.4-0.1-0.7-0.1-1-0.4l0,0l0,0c-0.3,0.8-0.1,1.1,0.8,1.1C254.1,116.7,254.2,116.4,254.2,116.2z"
      />
      <path
        class="st3"
        d="M13.2,165.7c1-1,0.8-1.3-0.7-1.4C12.5,164.9,12.6,165.4,13.2,165.7z"
      />
      <path
        class="st3"
        d="M121.7,100.5c0.3-1.1,0.3-1.1-1.3-1.4C120.4,99.8,120.6,100.3,121.7,100.5z"
      />
      <path
        class="st3"
        d="M231.9,79c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C231.5,79.4,231.9,79.2,231.9,79z"
      />
      <path
        class="st3"
        d="M0.9,152.8c-0.7,1.2-0.6,1.5,0.7,1.6C1.8,153.7,1.9,153,0.9,152.8z"
      />
      <path
        class="st3"
        d="M24.5,155c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8C23.7,154.7,24.1,154.8,24.5,155z"
      />
      <path
        class="st3"
        d="M74.6,173.7c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C73.9,173.3,73.8,173.6,74.6,173.7z"
      />
      <path
        class="st3"
        d="M246.8,94.8L246.8,94.8c-0.2,0.1-0.5,0.5-0.5,0.7s0.2,0.4,0.4,0.4C246.7,95.6,246.7,95.2,246.8,94.8z"
      />
      <path
        class="st3"
        d="M101.9,151.5c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C102.2,151.9,102.1,151.6,101.9,151.5z"
      />
      <path
        class="st3"
        d="M124.8,120.5c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C123.9,121.1,124.5,121.2,124.8,120.5z"
      />
      <path
        class="st3"
        d="M5.1,201.1c-0.4-0.2-0.7-0.5-0.9-0.4c-0.2,0.1-0.6,0.5-0.5,0.7c0,0.2,0.4,0.3,0.7,0.5
		C4.6,201.6,4.8,201.4,5.1,201.1z"
      />
      <path
        class="st3"
        d="M135,139.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C134.2,139.3,134.6,139.2,135,139.1z"
      />
      <path
        class="st3"
        d="M117.6,108.2c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C116.6,108,116.9,108.4,117.6,108.2z"
      />
      <path
        class="st3"
        d="M203.4,117.4L203.4,117.4c-0.2-0.2-0.4-0.4-0.5-0.6c0,0.2,0,0.4,0,0.6C203.1,117.5,203.2,117.5,203.4,117.4z"
      />
      <path
        class="st3"
        d="M175.8,112.5c0,0.2,0,0.3,0,0.5c0-0.1,0.1-0.1,0.1-0.2C176,112.8,175.9,112.7,175.8,112.5z"
      />
      <path
        class="st3"
        d="M174.7,113l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C174.7,113.2,174.7,113.1,174.7,113z"
      />
      <path
        class="st3"
        d="M202.3,83c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C201.7,83.6,202,83.4,202.3,83z"
      />
      <path
        class="st3"
        d="M94.3,137.9c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C93.9,137,93.9,137,94.3,137.9z"
      />
      <path
        class="st3"
        d="M123.3,110.9c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C123.6,110.5,123.3,110.8,123.3,110.9z"
      />
      <path
        class="st3"
        d="M132.6,96.9c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4
		C131.9,96.4,131.9,96.8,132.6,96.9z"
      />
      <path
        class="st3"
        d="M123.6,141.8c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C123.8,141.2,123.5,141.7,123.6,141.8z"
      />
      <path
        class="st3"
        d="M32.9,169c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9
		C32.8,169.2,32.9,169.1,32.9,169z"
      />
      <path
        class="st3"
        d="M65.6,157.8c0,0.3,0,0.5,0,0.6c0.2,0.3,0.6,0.4,1.2,0.4c0-0.6-0.3-0.8-0.8-1C66,157.8,65.8,157.8,65.6,157.8z"
      />
      <path
        class="st3"
        d="M122.4,94.4c0.4-0.9-0.2-1.1-1-1.3C121.4,93.8,121.4,94.4,122.4,94.4z"
      />
      <path
        class="st3"
        d="M135.2,147.1c0.5,0.1,0.8,0.3,1.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.3-0.4-0.5-0.8-0.9-1.4
		C135.5,146.4,135.3,146.7,135.2,147.1z"
      />
      <path
        class="st3"
        d="M285.9,119.4c-0.2-0.3-0.4-0.6-0.8-1.1C284.6,119.2,285,119.4,285.9,119.4z"
      />
      <path
        class="st3"
        d="M184.3,120.1c0,0.2,0,0.5,0,0.7c0.1-0.2,0.3-0.4,0.4-0.5C184.5,120.2,184.4,120.1,184.3,120.1z"
      />
      <path
        class="st3"
        d="M24.5,177c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		s-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C24.8,176.6,24.6,176.8,24.5,177z"
      />
      <path
        class="st3"
        d="M135.7,124.6c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0c-0.1,0.1-0.1,0.3-0.1,0.4
		C134.9,125.1,135.3,124.9,135.7,124.6z"
      />
      <path
        class="st3"
        d="M188.6,80.1c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C187.8,80.1,188.2,80.2,188.6,80.1z"
      />
      <path
        class="st3"
        d="M138.3,138.3c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1
		C138.3,138,138.3,138.2,138.3,138.3z"
      />
      <path
        class="st3"
        d="M130.9,111c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C130.4,110.5,130.3,110.9,130.9,111z"
      />
      <path
        class="st3"
        d="M170.3,105.5c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C169.7,106,169.9,105.8,170.3,105.5z"
      />
      <path
        class="st3"
        d="M85.7,146.5c0.7,0.3,1.1,0.1,1.4-0.6C86.3,145.7,85.9,145.9,85.7,146.5z"
      />
      <path
        class="st3"
        d="M135.1,128c0.2-0.1,0.4-0.3,0.7-0.5c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C134.6,127.7,135,128,135.1,128z"
      />
      <path
        class="st3"
        d="M134.6,115.9L134.6,115.9c-0.2-0.1-0.5-0.2-0.7-0.2s-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3
		c0.1,0,0.2,0,0.3,0s0.3,0,0.4-0.1C134.6,116.2,134.7,115.9,134.6,115.9z"
      />
      <path
        class="st3"
        d="M12.9,156.6c-0.1-0.6-0.2-1-0.3-1.4C12,155.8,12.1,156.3,12.9,156.6z"
      />
      <path
        class="st3"
        d="M7.7,169.5c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C6.6,168.6,6.7,169,7.7,169.5z"
      />
      <path
        class="st3"
        d="M193.8,122.3c-0.3-0.1-0.6-0.3-0.7-0.2c-0.1,0.1-0.2,0.2-0.3,0.3C193.1,122.4,193.4,122.4,193.8,122.3
		C193.7,122.3,193.7,122.3,193.8,122.3z"
      />
      <path
        class="st3"
        d="M84.4,169.9C84.5,169.9,84.5,169.9,84.4,169.9c0.2-0.1,0.4-0.4,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3C84.1,169.8,84.3,170,84.4,169.9z"
      />
      <path
        class="st3"
        d="M87,167c0.3-0.3,0.5-0.6,0.7-0.9C86.8,166.4,86.8,166.4,87,167z"
      />
      <path
        class="st3"
        d="M164.1,110.4c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C163.9,109.8,164,110.1,164.1,110.4z"
      />
      <path
        class="st3"
        d="M171,118.5c-0.7,0.5-1,1-0.6,1.6C170.7,119.6,171.2,119.1,171,118.5z"
      />
      <path
        class="st3"
        d="M267.6,76c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C267.3,76.1,267.4,76,267.6,76z"
      />
      <path
        class="st3"
        d="M243.9,125.1c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C242.4,124.9,243.1,125,243.9,125.1z"
      />
      <path
        class="st3"
        d="M87.3,173.8c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C86.5,173.4,86.8,173.6,87.3,173.8z"
      />
      <path
        class="st3"
        d="M131.3,125.8c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C130.7,125.5,131,125.6,131.3,125.8z"
      />
      <path
        class="st3"
        d="M174.3,115.4c0.1-0.2,0.2-0.4,0.3-0.7c0-0.2,0-0.4,0-0.7c-0.2,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C174.3,115.4,174.3,115.4,174.3,115.4z"
      />
      <path
        class="st3"
        d="M237.2,131c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3
		v0.1c0,0,0,0,0.1,0c0.4,0.7,0.5,0.7,1.4-0.1C237.7,131.2,237.4,131.1,237.2,131L237.2,131L237.2,131z"
      />
      <path
        class="st3"
        d="M33.2,171.4c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C32.9,171.7,33.2,171.5,33.2,171.4z"
      />
      <path
        class="st3"
        d="M95.3,99.6c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C95,100,95.1,99.8,95.3,99.6z"
      />
      <path
        class="st3"
        d="M49,149.7c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1c-0.1-0.1-0.2-0.1-0.3-0.2
		C49.5,149.2,49.3,149.4,49,149.7z"
      />
      <path
        class="st3"
        d="M27.3,172.8l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C26.9,173.3,27.1,173,27.3,172.8z"
      />
      <path
        class="st3"
        d="M105.3,132.8c0.2-0.8,0.2-1.2-0.7-1.2C104.8,132,104.9,132.3,105.3,132.8z"
      />
      <path
        class="st3"
        d="M241.2,130.5c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C241.5,129.5,241.3,129.8,241.2,130.5z"
      />
      <path
        class="st3"
        d="M128.3,114.1C128.2,114.1,128.2,114.1,128.3,114.1c-0.1,0-0.1,0.1-0.1,0.1S128.2,114.2,128.3,114.1
		C128.2,114.2,128.3,114.1,128.3,114.1z"
      />
      <path
        class="st3"
        d="M128.3,114.1c0.6-0.1,1.1-0.2,1.7-0.4C129.2,113.3,129.1,113.3,128.3,114.1z"
      />
      <path
        class="st3"
        d="M75.8,168.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4
		c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0,0.2C75.6,168,75.7,168.1,75.8,168.3z"
      />
      <path
        class="st3"
        d="M131.1,123.9c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C130.8,124.3,131.1,124.1,131.1,123.9z"
      />
      <path
        class="st3"
        d="M111.6,147.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C111,147.6,111.3,147.5,111.6,147.3z"
      />
      <path
        class="st3"
        d="M28.8,176.2c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C28.5,175.6,28.4,175.9,28.8,176.2z"
      />
      <path
        class="st3"
        d="M168.9,114.5c0,0.1,0,0.3,0,0.4c0.1-0.1,0.2-0.2,0.4-0.3C169.2,114.6,169,114.5,168.9,114.5z"
      />
      <path
        class="st3"
        d="M176.1,128.3c0,0.2,0,0.5,0,0.7c0.1,0,0.2,0,0.3,0s0.3-0.3,0.3-0.4C176.6,128.3,176.4,128.3,176.1,128.3z"
      />
      <path
        class="st3"
        d="M177.9,128.1c0.2-0.1,0.3-0.3,0.4-0.5v-0.1c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1,0.2-0.3,0.5-0.4,0.7
		C177.6,128,177.9,128.1,177.9,128.1z"
      />
      <path
        class="st3"
        d="M55.7,151.9c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0s0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2
		c-0.4,0-0.8,0-1.3,0.1C55.8,151.8,55.8,151.9,55.7,151.9z"
      />
      <path
        class="st3"
        d="M283.3,123.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C282.6,124.2,282.9,124.1,283.3,123.9z"
      />
      <path
        class="st3"
        d="M63.7,175.8c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C63.9,175.6,63.8,175.7,63.7,175.8z"
      />
      <path
        class="st3"
        d="M233.6,127.7c-0.1,0.6,0.3,0.8,1,1.1C234.5,128.1,234.2,127.8,233.6,127.7z"
      />
      <path
        class="st3"
        d="M126.4,88.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C126.2,88.8,126.3,88.8,126.4,88.7z"
      />
      <path
        class="st3"
        d="M79.5,179.5c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C78.9,179.7,79.3,180,79.5,179.5z"
      />
      <path
        class="st3"
        d="M75.6,177.5c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5,0.1-0.8,0.1
		C75.4,177.4,75.5,177.4,75.6,177.5z"
      />
      <path
        class="st3"
        d="M76.7,177.2c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C76.7,177.3,76.7,177.2,76.7,177.2z"
      />
      <path
        class="st3"
        d="M130.1,113.8L130.1,113.8C130,113.7,130,113.8,130.1,113.8C130,113.8,130,113.8,130.1,113.8
		C130,113.8,130.1,113.8,130.1,113.8z"
      />
      <path
        class="st3"
        d="M130.1,115.1c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C130.2,114.7,130.1,114.9,130.1,115.1z"
      />
      <path
        class="st3"
        d="M142.6,129.1c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C141.5,129.3,141.9,129.3,142.6,129.1z"
      />
      <path
        class="st3"
        d="M114.3,106.3c0.4,0.2,0.7,0.4,1.2,0.7C115.4,106.1,115.1,106,114.3,106.3z"
      />
      <path
        class="st3"
        d="M178.2,88.2c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C177.6,88.6,178,88.6,178.2,88.2z"
      />
      <path
        class="st3"
        d="M218.2,117C218.2,117,218.2,116.9,218.2,117c0.1-0.1,0.1-0.2,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1
		c-0.3,0.3-0.6,0.6-0.9,0.9v0.1c0.1,0,0.2,0.1,0.3,0.1C217.7,117.5,218,117.3,218.2,117z"
      />
      <path
        class="st3"
        d="M177.5,122.8L177.5,122.8c0.1,0.1,0.2,0,0.3,0C177.7,122.8,177.6,122.8,177.5,122.8z"
      />
      <path
        class="st3"
        d="M135.4,132C135.5,132,135.5,132,135.4,132c0.3,0,0.5-0.2,0.6-0.3l0,0c0-0.1-0.2-0.2-0.4-0.4
		c-0.2,0.2-0.4,0.4-0.5,0.5C135.1,131.8,135.3,132,135.4,132z"
      />
      <path
        class="st3"
        d="M227.4,130.6c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C227.8,130.8,227.5,130.6,227.4,130.6z"
      />
      <path
        class="st3"
        d="M102.1,156c-0.1-0.3-0.2-0.6-0.3-0.9C101.3,155.8,101.3,155.8,102.1,156z"
      />
      <path
        class="st3"
        d="M173.7,114.3c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2
		C173.4,114.3,173.6,114.3,173.7,114.3z"
      />
      <path
        class="st3"
        d="M246.6,97.7c-0.2-0.2-0.3-0.4-0.6-0.7c-0.1,0.6,0.1,0.9,0.5,0.9C246.5,97.9,246.5,97.8,246.6,97.7z"
      />
      <path
        class="st3"
        d="M136.7,133c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3
		C136.2,133.2,136.5,133.1,136.7,133z"
      />
      <path
        class="st3"
        d="M279.8,115.7c-0.2-0.2-0.4-0.4-0.6-0.6c0,0.2,0,0.3,0,0.5c0.1,0.1,0.2,0.2,0.3,0.3
		C279.6,115.8,279.7,115.7,279.8,115.7z"
      />
      <path
        class="st3"
        d="M288.7,125.7c0.4,0.2,0.6,0.3,1,0.4C289.4,125.6,289.4,125.6,288.7,125.7z"
      />
      <path
        class="st3"
        d="M142.3,126c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5c0.1,0.1,0.3,0.2,0.4,0.1
		C141.9,126.3,142,126.1,142.3,126z"
      />
      <path
        class="st3"
        d="M80.8,167.6c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0-0.1-0.1
		c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0.1,0.2C80.7,167.2,80.8,167.4,80.8,167.6z"
      />
      <path
        class="st3"
        d="M144.8,103.2c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8
		C144.5,103.2,144.7,103.2,144.8,103.2z"
      />
      <path
        class="st3"
        d="M124,98c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5C123.9,98.2,124,98.1,124,98z"
      />
      <path
        class="st3"
        d="M127,94.3c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C126.8,94.4,127,94.3,127,94.3z"
      />
      <path
        class="st3"
        d="M237,132.2c-0.5,0.3-0.8,0.5-1.3,0.8C236.6,132.9,236.6,132.9,237,132.2z"
      />
      <path
        class="st3"
        d="M33.3,160.3c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C33.3,160.9,33.3,160.6,33.3,160.3
		z"
      />
      <path
        class="st3"
        d="M82.8,166.3c0.1-0.3,0.3-0.5,0.4-0.8c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.2-0.4,0.5-0.6,0.7
		C82.5,166.2,82.6,166.3,82.8,166.3z"
      />
      <path
        class="st3"
        d="M27.6,162.8c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C27.4,162.8,27.5,162.8,27.6,162.8z
		"
      />
      <path
        class="st3"
        d="M189.5,113c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.2,0,0.4l0.1,0.1c0.2-0.1,0.3-0.2,0.5-0.4
		C189.7,113.1,189.6,113,189.5,113z"
      />
      <path
        class="st3"
        d="M127.4,90c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C126.8,89.8,127.1,89.9,127.4,90z"
      />
      <path
        class="st3"
        d="M233.6,144.6c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C233,144.9,233.3,144.8,233.6,144.6z"
      />
      <path
        class="st3"
        d="M251.3,140.7c0.6-0.3,1-0.5,1.4-0.6C252.1,139.9,251.6,139.9,251.3,140.7z"
      />
      <path
        class="st3"
        d="M232.4,131.8L232.4,131.8c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1,0.1-0.2,0.1-0.3,0.2v0.1c0,0,0.1,0,0.1,0.1
		c0.2,0.1,0.3,0.3,0.5,0.4C232.2,131.9,232.3,131.9,232.4,131.8z"
      />
      <path
        class="st3"
        d="M232.3,133.6c0.3-0.1,0.7-0.1,1-0.2v-0.1c-0.3,0.1-0.7,0.1-1,0.2C232.3,133.5,232.3,133.5,232.3,133.6z"
      />
      <path
        class="st3"
        d="M163.8,103.7c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C163.6,104,163.6,103.8,163.8,103.7z"
      />
      <path
        class="st3"
        d="M155.9,76.1c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3
		C155.7,76,155.8,76.1,155.9,76.1z"
      />
      <path
        class="st3"
        d="M196.2,68.4h-0.4C195.9,68.4,196,68.5,196.2,68.4C196.1,68.5,196.2,68.5,196.2,68.4z"
      />
      <path
        class="st3"
        d="M171.2,111.7c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C171,112.1,171.1,111.9,171.2,111.7z"
      />
      <path
        class="st3"
        d="M147.4,125.1c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C147.6,124.9,147.5,125,147.4,125.1z"
      />
      <path
        class="st3"
        d="M127.7,97.4c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C127.8,97.2,127.7,97.3,127.7,97.4z"
      />
      <path
        class="st3"
        d="M304.6,83c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C304.5,83,304.5,83,304.6,83z"
      />
      <path
        class="st3"
        d="M134.1,96.9c-0.1-0.3-0.1-0.7-0.7-0.7C133.5,96.5,133.5,96.9,134.1,96.9z"
      />
      <path
        class="st3"
        d="M129.7,115.9c-0.3-0.2-0.5-0.3-0.7-0.5C129,115.7,129,116.1,129.7,115.9z"
      />
      <path
        class="st3"
        d="M128.7,115.2L128.7,115.2l0.1,0.2C128.9,115.4,128.9,115.3,128.7,115.2C128.8,115.3,128.8,115.2,128.7,115.2z"
      />
      <path
        class="st3"
        d="M83.2,142.3l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C83,142.1,83.1,142.2,83.2,142.3z"
      />
      <path
        class="st3"
        d="M82.1,169.7c-0.1,0.1-0.1,0.1-0.2,0.2L82,170c0.2,0.2,0.3,0.3,0.5,0.5c0.1-0.1,0.2-0.2,0.3-0.2
		c-0.2-0.1-0.3-0.3-0.5-0.4C82.2,169.7,82.1,169.7,82.1,169.7z"
      />
      <path
        class="st3"
        d="M77.5,109.3c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3
		C77.1,109.6,77.2,109.4,77.5,109.3z"
      />
      <path
        class="st3"
        d="M212.2,81.3c0.1-0.2,0.2-0.3,0.2-0.4s-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C211.9,81.1,212,81.1,212.2,81.3z"
      />
      <path
        class="st3"
        d="M274.3,118.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.1-0.1,0.1-0.1,0.2s0.1,0.2,0.1,0.2
		C274,118.8,274.1,118.7,274.3,118.5L274.3,118.5z"
      />
      <path
        class="st3"
        d="M145.6,130.5c0,0.1,0.2,0.2,0.4,0.4c0.1-0.4,0.3-0.5,0.2-0.6c0-0.1-0.2-0.1-0.4-0.2
		C145.7,130.2,145.6,130.4,145.6,130.5z"
      />
      <path
        class="st3"
        d="M131.8,115.6c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C132.1,115.8,131.9,115.6,131.8,115.6z"
      />
      <path
        class="st3"
        d="M76.2,174c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.2
		C76,174.2,76.1,174.1,76.2,174z"
      />
      <path
        class="st3"
        d="M224.9,114.3c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C224.8,114.1,224.9,114.2,224.9,114.3z"
      />
      <path
        class="st3"
        d="M255.1,84.8c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C255.1,85,255.1,84.9,255.1,84.8z"
      />
      <path
        class="st3"
        d="M171.3,91.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C171.2,91.9,171.2,91.9,171.3,91.8z"
      />
      <path
        class="st3"
        d="M224.1,113.8c0.1,0,0.3,0,0.4,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C224.1,113.7,224.1,113.8,224.1,113.8z"
      />
      <path
        class="st3"
        d="M224.6,113.9c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1C224.7,113.9,224.6,113.9,224.6,113.9z"
      />
      <path
        class="st3"
        d="M78.3,174c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C78.5,174.1,78.4,174.1,78.3,174z"
      />
      <path
        class="st3"
        d="M231,76.7c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C231.1,76.6,231.1,76.6,231,76.7z"
      />
      <path
        class="st3"
        d="M126.5,103.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C126.2,103.6,126.3,103.7,126.5,103.8z"
      />
      <path
        class="st3"
        d="M25.3,172.8c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1C25.5,172.9,25.4,172.8,25.3,172.8z
		"
      />
      <path
        class="st3"
        d="M124.5,137c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C124.6,137.1,124.6,137.1,124.5,137z"
      />
      <path
        class="st3"
        d="M0.4,203.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v0.1c0.1,0.1,0.2,0.1,0.3,0.2C0.3,203.2,0.4,203.1,0.4,203.1
		z"
      />
      <path
        class="st3"
        d="M0.3,202.2c-0.1-0.2-0.1-0.3-0.2-0.5H0v0.2c0,0.1,0.1,0.2,0.1,0.3C0.2,202.2,0.3,202.2,0.3,202.2z"
      />
      <path
        class="st3"
        d="M83.7,173.5C83.8,173.5,83.8,173.5,83.7,173.5c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1-0.1-0.2-0.1-0.2C84,173.3,83.9,173.4,83.7,173.5C83.8,173.4,83.8,173.4,83.7,173.5z"
      />
      <path
        class="st3"
        d="M185.9,124.6C185.9,124.6,185.8,124.5,185.9,124.6c-0.1-0.1-0.1-0.1-0.1-0.2v0.1
		C185.8,124.6,185.9,124.6,185.9,124.6z"
      />
      <path
        class="st3"
        d="M185.8,124.4c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C185.6,124.2,185.7,124.3,185.8,124.4z"
      />
      <path
        class="st3"
        d="M173.4,108.5c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C173.1,108.6,173.2,108.6,173.4,108.5z"
      />
      <path
        class="st3"
        d="M186.5,124.7c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C186.4,124.9,186.4,124.8,186.5,124.7z"
      />
      <path
        class="st3"
        d="M74.6,143.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C74.5,143.2,74.6,143.2,74.6,143.3z"
      />
      <path
        class="st3"
        d="M75.1,143c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1C75.2,142.9,75.2,142.9,75.1,143z"
      />
      <path
        class="st3"
        d="M189.2,118.2c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.4c-0.1,0-0.3,0-0.4,0.1
		C189.2,118,189.2,118.1,189.2,118.2z"
      />
      <path
        class="st3"
        d="M31.6,158.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		C31.7,158.6,31.6,158.5,31.6,158.5z"
      />
      <path
        class="st3"
        d="M199.9,114.6c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1l-0.1,0.2C199.6,114.4,199.8,114.5,199.9,114.6z"
      />
      <path
        class="st3"
        d="M120.9,108.8c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1
		C120.9,108.7,120.8,108.8,120.9,108.8z"
      />
      <path
        class="st3"
        d="M120.8,131c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1C120.7,131.3,120.8,131.2,120.8,131
		z"
      />
      <path
        class="st3"
        d="M233.8,120.8c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5c0,0.1,0.1,0.1,0.2,0.2
		C233.6,121,233.7,120.9,233.8,120.8z"
      />
      <path
        class="st3"
        d="M238.2,135.3l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2l0.1-0.1
		C238.2,135.4,238.2,135.4,238.2,135.3z"
      />
      <path
        class="st3"
        d="M115.1,112.8c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1
		C115.2,112.9,115.1,112.9,115.1,112.8z"
      />
      <path
        class="st3"
        d="M220,89.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C220,90.3,220,90.1,220,89.9z"
      />
      <path
        class="st3"
        d="M81.2,162.6c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1c-0.1,0.1-0.2,0.2-0.3,0.3C80.9,162.6,81,162.6,81.2,162.6z"
      />
      <path
        class="st3"
        d="M234.4,134.5c0,0,0,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2
		C234.7,134.5,234.5,134.5,234.4,134.5z"
      />
      <path
        class="st3"
        d="M141.6,137.6c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C141.4,137.5,141.5,137.7,141.6,137.6z"
      />
      <path
        class="st3"
        d="M241.2,132.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C241,132.1,241.1,132.2,241.2,132.2z"
      />
      <path
        class="st3"
        d="M23.2,178.5c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C23.3,178.5,23.2,178.5,23.2,178.5z"
      />
      <path
        class="st3"
        d="M150.5,137.2c0-0.1,0.1-0.2,0.1-0.3s-0.1-0.1-0.2-0.2l0,0l0,0c0,0,0,0,0,0.1c-0.1,0.1-0.2,0.3-0.3,0.4l0,0
		C150.2,137.2,150.3,137.2,150.5,137.2z"
      />
      <path
        class="st3"
        d="M140.8,123.7L140.8,123.7C140.8,123.6,140.7,123.6,140.8,123.7C140.7,123.7,140.7,123.8,140.8,123.7
		C140.8,123.7,140.8,123.7,140.8,123.7z"
      />
      <path
        class="st3"
        d="M141.8,122.5c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C142,122.6,141.9,122.5,141.8,122.5z"
      />
      <path
        class="st3"
        d="M241.2,99.3c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C241,99.2,241.1,99.3,241.2,99.3z"
      />
      <path
        class="st3"
        d="M84.1,137.9c0-0.1,0.1-0.1,0.1-0.2C84.2,137.7,84.1,137.8,84.1,137.9c-0.1,0-0.2,0.1-0.2,0.1
		C84,137.9,84,137.9,84.1,137.9z"
      />
      <path
        class="st3"
        d="M105.9,133.3c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C106.3,133.3,106.1,133.3,105.9,133.3z"
      />
      <path
        class="st3"
        d="M76,141l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C75.9,141.2,75.9,141.1,76,141z"
      />
      <path
        class="st3"
        d="M75.5,142.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2V142.5z"
      />
      <path
        class="st3"
        d="M75.1,166.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.3c0,0.1-0.1,0.2-0.1,0.2
		C75,166.2,75.1,166.2,75.1,166.3z"
      />
      <path
        class="st3"
        d="M171.3,123.2h0.1C171.4,123.2,171.4,123.1,171.3,123.2C171.4,123.1,171.3,123.1,171.3,123.2L171.3,123.2z"
      />
      <path
        class="st3"
        d="M112,120.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C111.7,120.8,111.8,120.8,112,120.7
		C111.9,120.8,112,120.7,112,120.7z"
      />
      <path
        class="st3"
        d="M132.6,115.3c0,0,0.1,0,0.2,0C132.8,115.3,132.8,115.2,132.6,115.3C132.6,115.2,132.6,115.2,132.6,115.3
		C132.5,115.2,132.5,115.3,132.6,115.3z"
      />
      <path
        class="st3"
        d="M171.3,125.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C171.3,125.2,171.3,125.3,171.3,125.3z"
      />
      <path
        class="st3"
        d="M148.6,130.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C148.6,130.7,148.6,130.7,148.6,130.6L148.6,130.6z"
      />
      <path
        class="st3"
        d="M139.9,113.4c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C140.1,113.4,140,113.4,139.9,113.4z"
      />
      <path
        class="st3"
        d="M163.3,107.5c0,0.1-0.1,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0s0.1-0.1,0.1-0.2C163.5,107.5,163.4,107.5,163.3,107.5z"
      />
      <path
        class="st3"
        d="M291.1,102c0,0-0.1,0-0.1-0.1c0,0.1,0,0.1,0,0.2L291.1,102C291.1,102.1,291.1,102.1,291.1,102z"
      />
      <path
        class="st3"
        d="M30.6,159.6l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C30.7,159.7,30.7,159.6,30.6,159.6z"
      />
      <path
        class="st3"
        d="M119,141c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C118.9,141.2,118.9,141.1,119,141z"
      />
      <path
        class="st3"
        d="M31.7,160.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C31.7,160.9,31.7,160.8,31.7,160.8z"
      />
      <path
        class="st3"
        d="M188,127l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2l0.1-0.1C188.2,127.2,188.1,127.1,188,127z"
      />
      <path
        class="st3"
        d="M122.4,115.4c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1
		C122.5,115.2,122.4,115.3,122.4,115.4z"
      />
      <path
        class="st3"
        d="M245.4,115c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0S245.4,114.9,245.4,115z"
      />
      <path
        class="st3"
        d="M76.9,178c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C77.1,178,77,178,76.9,178z"
      />
      <path
        class="st3"
        d="M109.7,145.8L109.7,145.8C109.6,145.8,109.6,145.9,109.7,145.8c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C109.9,145.8,109.8,145.8,109.7,145.8L109.7,145.8z"
      />
      <path
        class="st3"
        d="M10,167.8H9.9v0.1c0.1,0,0.1,0,0.2,0C10,167.9,10,167.9,10,167.8z"
      />
      <path
        class="st3"
        d="M33.6,131.4v0.1C33.7,131.5,33.7,131.5,33.6,131.4C33.7,131.5,33.7,131.4,33.6,131.4z"
      />
      <path
        class="st3"
        d="M220.1,90.6l-0.1-0.1c0,0,0,0,0-0.1v0.1C220,90.6,220.1,90.6,220.1,90.6z"
      />
      <path
        class="st3"
        d="M220.4,90.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4C220.4,91,220.4,90.9,220.4,90.9z"
      />
      <path
        class="st3"
        d="M71.5,155.2c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1
		C71.6,155.2,71.6,155.2,71.5,155.2z"
      />
      <path
        class="st3"
        d="M71.4,155.3L71.4,155.3c0.1,0,0.1,0,0.1-0.1C71.5,155.3,71.5,155.3,71.4,155.3L71.4,155.3z"
      />
      <path
        class="st3"
        d="M71.1,155.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C71,155.6,71,155.6,71.1,155.7z"
      />
      <path
        class="st3"
        d="M248.6,82.8c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C248.6,82.9,248.6,82.8,248.6,82.8z"
      />
      <path
        class="st3"
        d="M228.8,143.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C228.9,143.6,228.8,143.5,228.8,143.5z"
      />
      <path
        class="st3"
        d="M26.8,125.9l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C27,125.9,26.9,125.9,26.8,125.9z"
      />
      <path
        class="st3"
        d="M144.5,100.2c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C144.5,100.3,144.5,100.3,144.5,100.2z"
      />
      <path
        class="st3"
        d="M249,138.4v-0.1c-0.2,0-0.4,0.1-0.6,0.1v0.1C248.6,138.5,248.8,138.4,249,138.4z"
      />
      <path
        class="st3"
        d="M27.7,125.4c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C27.6,125.2,27.7,125.3,27.7,125.4z"
      />
      <path
        class="st3"
        d="M27.5,124.9C27.5,125,27.5,125,27.5,124.9c0.1,0.1,0.1,0.1,0.1,0.1C27.6,125.1,27.6,125,27.5,124.9
		C27.5,125,27.5,125,27.5,124.9z"
      />
      <path
        class="st3"
        d="M144.3,99.1l-0.1-0.1l-0.1,0.1l0.1,0.1C144.3,99.1,144.3,99.1,144.3,99.1z"
      />
      <path
        class="st3"
        d="M11.3,188.5c0,0,0.1,0,0.1-0.1v-0.1c-0.1,0-0.1,0.1-0.2,0.1C11.2,188.4,11.3,188.5,11.3,188.5z"
      />
      <path
        class="st3"
        d="M96.6,107.9c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C96.5,107.9,96.5,107.9,96.6,107.9z"
      />
      <path
        class="st3"
        d="M96.3,107.7L96.3,107.7L96.3,107.7C96.2,107.6,96.2,107.6,96.3,107.7C96.3,107.6,96.3,107.7,96.3,107.7z"
      />
      <path
        class="st3"
        d="M172.9,90.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C172.8,90.2,172.9,90.1,172.9,90.1z"
      />
      <path
        class="st3"
        d="M69,174.5v0.1c0,0,0,0.1,0.1,0.1v-0.1C69,174.6,69,174.6,69,174.5z"
      />
      <path
        class="st3"
        d="M119.9,101.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C119.9,100.8,119.8,100.9,119.9,101.1
		C119.7,101,119.8,101.1,119.9,101.1z"
      />
      <path
        class="st3"
        d="M228.5,128.6c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1
		C228.4,128.8,228.5,128.7,228.5,128.6z"
      />
      <path
        class="st3"
        d="M244.3,135.3c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C244.2,135.2,244.3,135.3,244.3,135.3z"
      />
      <path
        class="st3"
        d="M243.1,126.2c0,0.1,0,0.1,0.1,0.2l0.1-0.1C243.3,126.2,243.2,126.2,243.1,126.2
		C243.2,126.2,243.2,126.2,243.1,126.2z"
      />
      <path
        class="st3"
        d="M239.8,127.6l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1C239.8,127.7,239.8,127.6,239.8,127.6z"
      />
      <path
        class="st3"
        d="M286,125c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3C285.9,124.9,286,124.9,286,125z"
      />
      <path
        class="st3"
        d="M107.1,97.4L107.1,97.4c-0.1-0.1-0.2-0.1-0.2,0C106.9,97.4,106.9,97.5,107.1,97.4
		C107,97.4,107,97.4,107.1,97.4z"
      />
      <path
        class="st3"
        d="M79.9,169l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C79.7,169.1,79.8,169,79.9,169z"
      />
      <path
        class="st3"
        d="M183.5,74.2C183.5,74.2,183.4,74.2,183.5,74.2c-0.1,0.1-0.1,0.2-0.1,0.2C183.5,74.4,183.5,74.4,183.5,74.2
		C183.6,74.3,183.5,74.2,183.5,74.2z"
      />
      <path
        class="st3"
        d="M93.5,159.5c0,0.1,0.1,0.1,0.2,0.2l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C93.5,159.4,93.5,159.5,93.5,159.5z"
      />
      <path
        class="st3"
        d="M26.3,174.9C26.4,174.8,26.4,174.8,26.3,174.9c0.1-0.1,0-0.1,0-0.1l-0.1-0.1l-0.1,0.1
		C26.2,174.8,26.2,174.8,26.3,174.9L26.3,174.9z"
      />
      <path
        class="st3"
        d="M154.8,75.1c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C154.7,75.3,154.8,75.2,154.8,75.1z"
      />
      <path
        class="st3"
        d="M65.2,89.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C65.2,89.7,65.3,89.6,65.2,89.5z"
      />
      <path
        class="st3"
        d="M14.3,177.6c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C14.2,177.7,14.3,177.7,14.3,177.6z"
      />
      <path
        class="st3"
        d="M18.3,176.9c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1C18.3,176.8,18.3,176.9,18.3,176.9z"
      />
      <path
        class="st3"
        d="M140,150.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C140,150.6,140,150.6,140,150.6z"
      />
      <path
        class="st3"
        d="M2.1,207.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C2.1,207.9,2.1,207.8,2.1,207.7z"
      />
      <path
        class="st3"
        d="M0.5,200.2c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C0.6,200.2,0.6,200.2,0.5,200.2z"
      />
      <path
        class="st3"
        d="M0.3,200.5v0.1C0.4,200.6,0.4,200.5,0.3,200.5C0.4,200.5,0.4,200.4,0.3,200.5C0.4,200.4,0.4,200.4,0.3,200.5z"
      />
      <path
        class="st3"
        d="M76.9,180.1L76.9,180.1C76.8,180.1,76.8,180.1,76.9,180.1C76.8,180.2,76.9,180.2,76.9,180.1L76.9,180.1z"
      />
      <path
        class="st3"
        d="M76.9,179.9c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C77.1,180,77,179.9,76.9,179.9z"
      />
      <path
        class="st3"
        d="M70.4,179.3C70.4,179.3,70.4,179.2,70.4,179.3c0.1-0.1,0-0.2,0-0.2C70.3,179.2,70.3,179.2,70.4,179.3
		C70.3,179.3,70.3,179.3,70.4,179.3z"
      />
      <path
        class="st3"
        d="M77.7,177c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C77.8,176.9,77.8,176.9,77.7,177z"
      />
      <path
        class="st3"
        d="M79.4,172.1c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C79.5,172.1,79.4,172.1,79.4,172.1z"
      />
      <path
        class="st3"
        d="M79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.4,172.1,79.3,172.1,79.3,172
		C79.3,172.1,79.3,172.1,79.3,172z"
      />
      <path
        class="st3"
        d="M79.1,172c0.1,0,0.1,0,0.2,0.1V172C79.2,172,79.2,172,79.1,172z"
      />
      <path
        class="st3"
        d="M8.3,187.1h0.1l0.1-0.1l-0.1-0.1C8.3,187,8.3,187,8.3,187.1z"
      />
      <path
        class="st3"
        d="M83.2,166.7L83.2,166.7C83.2,166.7,83.3,166.7,83.2,166.7c0.1,0,0.2,0,0.2,0.1
		C83.4,166.7,83.4,166.7,83.2,166.7C83.3,166.6,83.3,166.7,83.2,166.7z"
      />
      <path
        class="st3"
        d="M83.5,166.8L83.5,166.8c0.1,0.1,0.1,0.1,0.1,0.1C83.6,166.8,83.5,166.8,83.5,166.8L83.5,166.8z"
      />
      <polygon class="st3" points="66.2,170.3 66.1,170.4 66.2,170.4 	" />
      <polygon class="st3" points="32.6,175.6 32.5,175.5 32.4,175.5 	" />
      <path
        class="st3"
        d="M233,131.3c0,0.1,0,0.2-0.1,0.2C233,131.4,233,131.4,233,131.3c0.1-0.1,0.1-0.1,0.1-0.2
		C233.1,131.1,233,131.2,233,131.3z"
      />
      <polygon class="st3" points="28.8,172.6 28.9,172.5 28.9,172.5 	" />
      <polygon class="st3" points="87.9,159.5 87.9,159.4 87.8,159.4 	" />
      <path
        class="st3"
        d="M86.5,158.1c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C86.3,158.1,86.4,158.1,86.5,158.1z"
      />
      <path
        class="st3"
        d="M274.5,117.1c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C274.4,117.2,274.5,117.2,274.5,117.1z"
      />
      <path
        class="st3"
        d="M242.7,124.1c0.1,0,0.1,0,0.2,0C242.8,124.1,242.8,124,242.7,124.1C242.7,124,242.7,124,242.7,124.1z"
      />
      <path
        class="st3"
        d="M85.9,157.8l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C86.1,158,86,157.9,85.9,157.8z"
      />
      <path
        class="st3"
        d="M101.9,154.1c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2
		C101.9,154.3,101.9,154.2,101.9,154.1z"
      />
      <path
        class="st3"
        d="M235.3,123.7c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C235.5,123.6,235.4,123.7,235.3,123.7z"
      />
      <polygon class="st3" points="242.6,121.9 242.7,121.8 242.6,121.8 	" />
      <path
        class="st3"
        d="M235.6,123.3c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C235.6,123.4,235.6,123.4,235.6,123.3z"
      />
      <path
        class="st3"
        d="M75.7,157.7l-0.1-0.1l-0.1,0.1l0.1,0.1C75.7,157.7,75.7,157.7,75.7,157.7z"
      />
      <path
        class="st3"
        d="M186.9,124.3L186.9,124.3c0-0.1,0.1-0.2,0.1-0.3C186.9,124.2,186.9,124.2,186.9,124.3
		c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0C186.7,124.6,186.8,124.5,186.9,124.3z"
      />
      <path
        class="st3"
        d="M178.3,126.1L178.3,126.1C178.3,126,178.3,126,178.3,126.1c0-0.1,0-0.1-0.1-0.1l-0.1,0.1
		C178.2,126.1,178.3,126.1,178.3,126.1z"
      />
      <polygon class="st3" points="103.4,141.3 103.3,141.3 103.4,141.4 	" />
      <path
        class="st3"
        d="M138.3,132.4L138.3,132.4c0-0.1-0.1-0.1-0.1-0.1C138.1,132.3,138.2,132.3,138.3,132.4z"
      />
      <path
        class="st3"
        d="M208.5,113.6c0,0-0.1,0-0.1-0.1c0,0.1,0,0.1,0,0.2C208.4,113.6,208.5,113.6,208.5,113.6z"
      />
      <path
        class="st3"
        d="M74.3,142.5l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1S74.4,142.5,74.3,142.5z"
      />
      <path
        class="st3"
        d="M74.5,142.4L74.5,142.4c0.1,0,0.1-0.1,0.1-0.1C74.6,142.3,74.5,142.3,74.5,142.4z"
      />
      <path
        class="st3"
        d="M208,113c0,0-0.1,0-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C208,113.1,208,113,208,113z"
      />
      <path
        class="st3"
        d="M94.3,135.1c0,0-0.1,0.1,0,0.1l0.1,0.1C94.4,135.2,94.4,135.2,94.3,135.1C94.4,135,94.4,135.1,94.3,135.1z"
      />
      <polygon class="st3" points="27.3,149.6 27.3,149.7 27.4,149.7 	" />
      <polygon class="st3" points="127.1,124.3 127.2,124.3 127.2,124.2 	" />
      <path
        class="st3"
        d="M128.7,116.9l0.1-0.1l-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2C128.6,116.8,128.6,116.9,128.7,116.9z"
      />
      <path
        class="st3"
        d="M269.5,84.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C269.4,85.1,269.4,85,269.5,84.9z"
      />
      <polygon
        class="st3"
        points="227,93.9 227,93.8 227,93.8 226.9,93.8 227,93.8 	"
      />
      <polygon class="st3" points="132.3,114.3 132.1,114.4 132.3,114.4 	" />
      <polygon class="st3" points="139.8,112.2 139.9,112.2 139.8,112.1 	" />
      <polygon class="st3" points="242.5,89.5 242.4,89.5 242.5,89.6 	" />
      <polygon class="st3" points="226.5,93 226.4,93.1 226.6,93.1 	" />
      <path
        class="st3"
        d="M115.4,116.8L115.4,116.8h-0.2H115.4C115.3,116.9,115.3,116.9,115.4,116.8z"
      />
      <polygon class="st3" points="2.6,141.3 2.6,141.2 2.5,141.3 	" />
      <path
        class="st3"
        d="M269.6,80.3c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C269.5,80.3,269.6,80.3,269.6,80.3z"
      />
      <path
        class="st3"
        d="M70.4,120.8L70.4,120.8L70.4,120.8v0.2C70.4,121,70.4,120.9,70.4,120.8z"
      />
      <path
        class="st3"
        d="M106.5,110.2C106.5,110.2,106.6,110.2,106.5,110.2h0.2H106.5C106.5,110.1,106.5,110.2,106.5,110.2z"
      />
      <polygon class="st3" points="121.2,105.4 121.2,105.6 121.3,105.5 	" />
      <polygon class="st3" points="139.2,101 139.3,101 139.2,100.9 	" />
      <path
        class="st3"
        d="M96,107.5L96,107.5c0.1,0.1,0.1,0.1,0.2,0.1C96.1,107.5,96.1,107.5,96,107.5z"
      />
      <polygon class="st3" points="134.6,97.2 134.6,97.3 134.7,97.3 	" />
      <path
        class="st3"
        d="M218.2,247.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C218.4,247,218.3,247,218.2,247.1z"
      />
      <path
        class="st3"
        d="M239.9,231.1c0,0-0.1,0-0.1-0.1l0,0l0,0C239.8,231.1,239.9,231.1,239.9,231.1z"
      />
      <path
        class="st3"
        d="M607.6,49.8c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-6.9c-0.9,0.3-1.9,0.5-2.8,0.9
		C608.3,48.1,607.7,48.8,607.6,49.8z"
      />
      <path
        class="st3"
        d="M545.5,197.5c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.8-0.9,0-0.9-0.3-1.1
		c0,0.7,0,1.4,0,2.1c0.3-0.3,0.5-0.7,0.8-1.1c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1
		c0.7,0.1,1.4-0.3,1.3-0.8C546.4,198.2,546.2,197.6,545.5,197.5z"
      />
      <path
        class="st3"
        d="M239.6,266.8c-0.5-0.1-1-0.2-1.5-0.3c0.3,0.2,0.6,0.3,1,0.3C239.2,266.9,239.4,266.9,239.6,266.8z"
      />
      <path
        class="st3"
        d="M544.2,192.6c-0.5,0-1.1-0.1-1.6-0.1c0.3,0.1,0.8,0.2,1.4,0.5C544,192.8,544.1,192.7,544.2,192.6z"
      />
      <path
        class="st3"
        d="M539.7,195.6c0.2-0.1,0.4-0.2,0.7-0.3c-0.2-0.4-0.5-0.7-0.7-1.1C539.7,194.7,539.7,195.1,539.7,195.6z"
      />
      <path
        class="st3"
        d="M210.2,137.4c0,3.5,0,6.8,0,10.5c2.3,0,4.1,0,6,0c0-3.4,0-6.7,0-10.1C214.2,137.1,212.3,136.9,210.2,137.4z"
      />
      <path
        class="st3"
        d="M311.7,143.9c-2.5-0.2-4.7-0.3-7.3-0.5c0,4.3,0,8,0,11.8c2.6,0.3,4.9,0.5,7.3,0.7
		C311.7,151.8,311.7,148,311.7,143.9z"
      />
      <path
        class="st3"
        d="M311.8,156.9c-2.5-0.2-4.9-0.4-7.4-0.6c0,4.4,0,8.3,0,12.5c2.6,0.3,4.9,0.5,7.4,0.8
		C311.8,165.2,311.8,161.3,311.8,156.9z"
      />
      <path
        class="st3"
        d="M309.6,170.6C309.6,170.6,309.6,170.5,309.6,170.6c-0.5-0.1-1-0.1-1.5-0.1c0,0,0,0,0,0.1
		C308.6,170.6,309.1,170.6,309.6,170.6z"
      />
      <path
        class="st3"
        d="M303.1,143.4c-2.5-0.2-4.8-0.4-7.4-0.6c0,4.2,0,8,0,11.8c2.6,0.2,4.9,0.4,7.4,0.7
		C303.1,151.2,303.1,147.5,303.1,143.4z"
      />
      <path
        class="st3"
        d="M313.2,169.8c2.4,0.2,4.6,0.4,7,0.6c0-4.5,0-8.5,0-12.8c-2.4-0.2-4.6-0.3-7-0.5
		C313.2,161.5,313.2,165.5,313.2,169.8z"
      />
      <path
        class="st3"
        d="M309.6,141.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2-0.4-0.6-0.7-1-1h-0.1c-0.8-0.2-1.4-0.4-1.9-0.8v-4
		c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v-1.1c0,0.1,0.1,0.2,0.1,0.3
		c0.1,0,0.1,0,0.2-0.1c-0.1-0.2-0.1-0.3-0.2-0.5h-0.1v-3.6h0.1c0.6,0.3,1.2,0.6,1.8,0.9c0.1,0,0.1,0.1,0.2,0.1
		c0.4,0.2,0.8,0.4,1.2,0.6c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.1,0.2,0.1,0.4,0.2,0.6c-0.1-1.3-0.3-2.4-0.5-3.1
		c-2.2-0.2-4.4-0.3-7-0.5c-0.2,4.6-0.4,8.8,0.1,13.4c2.7,0,5,0,7.3,0c0.1-0.6,0.1-1.2,0.2-1.8C311.5,141.4,310.9,141.5,309.6,141.2z
		"
      />
      <path
        class="st3"
        d="M312,138c-0.6,0-1.2,0-1.7,0c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3l0,0l0,0
		c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.3,0.2,0.6,0.5,0.8
		c0,0,0.1,0,0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.3c0.1,0.8,0.5,1.2,1.2,1.4c0.2,0.1,0.5,0,0.8,0C312,139.2,312,138.6,312,138z"
      />
      <path
        class="st3"
        d="M320.2,144.4c-2.4-0.1-4.5-0.2-7-0.3c0,4.2,0,7.9,0,11.7c2.4,0.5,4.7,1.1,7.2,0.4
		C320.4,152.3,320.7,148.5,320.2,144.4z"
      />
      <path
        class="st3"
        d="M313.9,134.7c0,1-0.1,2.1-0.1,3.2c0,0.1,0,0.1,0,0.2c-0.2,0-0.4,0-0.6,0c0,1.6,0,3.3,0,4.9
		c2.3,0.2,4.4,0.4,7,0.6c0-4.7,0-8.9,0-13.5c-2.5,0-4.7,0-7,0c0,0.8,0,1.7,0,2.5c0.9,0,1.9-0.2,2.6,0.7c0,0.1,0.1,0.1,0.1,0.2
		c0,0-0.1,0-0.1,0.1C315.2,133.9,314.6,134.2,313.9,134.7z"
      />
      <path
        class="st3"
        d="M303.1,156.4c-2.6-0.6-4.9-0.9-7.5-0.4c0,4.1,0,7.9,0,12c2.5,0.2,4.8,0.5,7.5,0.7
		C303.1,164.6,303.1,160.6,303.1,156.4z"
      />
      <path
        class="st3"
        d="M262,152.8c-2.3-0.1-4.3-0.3-6.7-0.4c0,4.2,0,8,0,11.8c2.3,0.2,4.4,0.4,6.8,0.7
		C262.2,160.8,262.4,156.9,262,152.8z"
      />
      <path
        class="st3"
        d="M264.7,151.8c-0.3-0.6-0.6-1.1-1-1.7c-0.2,0.1-0.4,0.2-0.6,0.4c0.3,0.6,0.6,1.1,0.9,1.7
		C264.2,152,264.4,151.9,264.7,151.8z"
      />
      <path
        class="st3"
        d="M261.1,166.1c-0.5-0.1-0.6-0.1-0.7-0.1v0.1C260.5,166.1,260.6,166.1,261.1,166.1z"
      />
      <path
        class="st3"
        d="M254.1,152.5c-2.4-0.6-4.5-0.8-6.7-0.4c0,4,0,7.7,0,11.6c2.3,0.2,4.3,0.4,6.7,0.6
		C254.1,160,254.1,156.3,254.1,152.5z"
      />
      <path
        class="st3"
        d="M294.3,167.5c0-3.9,0-7.8,0-12c-1.1,0-2,0-3,0c-0.4,3.7,0.2,7.1,0.6,10.6C291.9,167.7,292.9,167.7,294.3,167.5
		z"
      />
      <path
        class="st3"
        d="M294.2,142.8c-1.7-0.1-3.1-0.2-4.9-0.3c0.6,4.1,1.2,7.7,1.8,11.7c1.1,0.1,2,0.1,3,0.1
		C294.2,150.4,294.2,146.7,294.2,142.8z"
      />
      <polygon class="st3" points="302.1,170 301.9,169.9 301.9,170 	" />
      <path
        class="st3"
        d="M263.2,153.6c0,3.7,0,7.4,0,11.4c2.2,0.3,4.2,0.5,6.9,0.9c-0.3-3.3-0.3-6-0.9-8.6
		C268.4,154.1,266.2,152.9,263.2,153.6z"
      />
      <path
        class="st3"
        d="M429.4,225.9c-0.5,1.3-1.1,2.6-1.6,4c0.3,0,0.6,0.1,0.7,0.2c0.5,0.4,1,0.4,1.6,0.4
		C430.6,227.5,430.4,226.8,429.4,225.9z"
      />
      <path
        class="st3"
        d="M340,172.3c2.8,0.3,5.4,0.5,8.5,0.8c0-4.7,0.2-8.9-0.1-13.2c-3.1,0-5.6-1.2-8.4-0.3
		C340,163.8,340,167.8,340,172.3z"
      />
      <path
        class="st3"
        d="M356.3,175.2c0.3,0,0.7,0,1,0v-0.1c-0.3,0-0.6,0-0.9,0C356.3,175.1,356.3,175.1,356.3,175.2z"
      />
      <path
        class="st3"
        d="M358.2,160.7c-2.9-0.2-5.5-0.4-8.4-0.7c0,4.5,0,8.7,0,13.3c2.8,0.2,5.5,0.4,8.4,0.6
		C358.2,169.3,358.2,165.1,358.2,160.7z"
      />
      <path
        class="st3"
        d="M329.6,171.2c0-4.3,0-8.4,0-12.8c-2.8-0.3-5.3-0.9-8.1-0.2c0,4.2-0.1,8.2,0.1,12.5
		C324.4,170.9,326.8,171,329.6,171.2z"
      />
      <path
        class="st3"
        d="M350.4,116.6L350.4,116.6c2.4,0.2,4.7,0.4,7.1,0.5c0-0.2,0-0.4,0-0.5C355.1,116.6,352.8,116.6,350.4,116.6z"
      />
      <path
        class="st3"
        d="M358,118.2c-2.6,0-5.2,0-8.1,0c0,4.2,0,8.2,0,12.6c2.9,0,5.6,0,8.4,0C358.9,127.1,358.8,120.7,358,118.2z"
      />
      <path
        class="st3"
        d="M370.6,117.3c0.6,0,1.2,0,1.8,0c0-0.1,0-0.2,0-0.3c-0.6,0-1.2,0.1-1.8,0.1
		C370.6,117.2,370.6,117.3,370.6,117.3z"
      />
      <path
        class="st3"
        d="M348.7,131.8c-3-0.2-5.7-0.4-8.8-0.6c0,4.7-0.2,9.1,0,13.6c3,0.2,5.7,0.4,8.4,0.6c0.1-1,0.3-1.6,0.3-2.2
		C348.7,139.6,348.7,135.9,348.7,131.8z"
      />
      <path
        class="st3"
        d="M358.3,147.3c-2.9-0.5-5.6-0.8-8.6-0.4c0,4,0,7.9,0,12c2.9,0.2,5.6,0.4,8.6,0.6
		C358.3,155.3,358.3,151.4,358.3,147.3z"
      />
      <path
        class="st3"
        d="M358.4,132.3c-3.1-0.2-5.7-0.3-8.6-0.5c0,4.8,0,9.1,0,13.7c2.9,0.2,5.6,0.5,8.7,0.7
		C358.6,141.4,358.7,137,358.4,132.3z"
      />
      <path
        class="st3"
        d="M352.1,174.5c0-0.1,0-0.1,0-0.2c-0.4,0-0.7,0-1.1,0.1v0.1C351.4,174.5,351.7,174.5,352.1,174.5z"
      />
      <path
        class="st3"
        d="M338.8,145.7c-2.7,0-5.3,0-7.9,0c0,3.8,0,7.7,0,11.8c2.6,0.2,5.1,0.4,7.9,0.6
		C338.8,153.7,338.8,149.9,338.8,145.7z"
      />
      <path
        class="st3"
        d="M329.7,130.6c-2.9,0-5.3,0-7.9,0c0,4.3,0,8.6,0,13c2.8,0.2,5.3,0.3,7.9,0.5
		C329.7,139.4,329.7,135.3,329.7,130.6z"
      />
      <path
        class="st3"
        d="M338.8,172.2c0-4.5,0-8.7,0-13.1c-2.7-0.2-5.1-0.4-8-0.7c-0.1,4.7-0.2,8.8,0,13.1
		C333.7,171.7,336.1,171.9,338.8,172.2z"
      />
      <path
        class="st3"
        d="M329.6,157.3c0-4.2,0-8,0-12.3c-2.6-0.1-5-0.3-7.9-0.4c0,4.2,0,8.1,0,12.1
		C324.4,156.9,326.9,157.1,329.6,157.3z"
      />
      <path
        class="st3"
        d="M348.5,146.4c-2.9-0.1-5.5-0.3-8.4-0.4c0,4.1,0,8,0,12.2c2.7,0.2,5.4,0.4,8.4,0.6
		C348.5,154.4,348.5,150.6,348.5,146.4z"
      />
      <path
        class="st3"
        d="M330.9,130.8c0,4.6,0,8.9,0,13.3c2.6,0.2,5.1,0.4,7.9,0.6c0-4.6,0-8.9,0-13.5
		C336.1,131.1,333.6,131,330.9,130.8z"
      />
      <path
        class="st3"
        d="M245.6,139.4c-1.8-0.2-3.7-0.3-6-0.5c0,4,0,7.5,0,11.2c2.3,0.2,4.3,0.4,6.3,0.6
		C246.6,147.3,246.4,142.2,245.6,139.4z"
      />
      <path
        class="st3"
        d="M338.9,117.7c-2.8-0.4-5.4-0.5-8-0.4c0,4.2,0,8.1,0,12.5c2.8,0,5.4,0,8,0C338.9,125.7,338.9,121.7,338.9,117.7
		z"
      />
      <path
        class="st3"
        d="M360.6,117.2c2.2,0,4.4,0,6.7,0c0-0.1,0-0.2,0-0.2c-2.2,0-4.4,0-6.7,0C360.6,117.1,360.6,117.2,360.6,117.2z"
      />
      <path
        class="st3"
        d="M175.1,145.8c-2.1-0.1-4-0.2-5.8-0.3c0,3.9,0,7.3,0,10.9c2.1,0.2,3.8,0.3,5.8,0.5
		C175.1,153,175.1,149.6,175.1,145.8z"
      />
      <path
        class="st3"
        d="M531.4,140.3c2.6,0.2,5.1,0.4,8,0.6c0-5.5,0-10.3,0-15.4c-2.7,0-5.3,0-8,0
		C531.4,130.5,531.4,135.2,531.4,140.3z"
      />
      <path
        class="st3"
        d="M531.1,157.5c2.7,0.3,5.2,0.8,8,0.1c0.2-5.2,0.3-10.3,0.3-15.7c-2.9-0.2-5.3-0.3-8.2-0.5
		C531.1,147.2,531.1,152.3,531.1,157.5z"
      />
      <path
        class="st3"
        d="M540.6,158.3c2.3,0.1,4.6,0.2,7.2,0.4c0-5.5,0-10.5,0-16.2c-2.3-0.1-4.6-0.2-7.2-0.3
		C540.6,147.7,540.6,152.8,540.6,158.3z"
      />
      <path
        class="st3"
        d="M239.6,162.9c2.3,0.2,4.4,0.3,6.6,0.5c0-4.1,0-7.8,0-11.9c-2.3-0.1-4.4-0.2-6.6-0.3
		C239.6,155.3,239.6,159,239.6,162.9z"
      />
      <path
        class="st3"
        d="M172.1,163.8c0.9-2,1.6-3.9,2.6-6.1c-1.8-0.2-3.5-0.4-5.3-0.5c0,2.3,0,4.3,0,6.5
		C170.5,163.7,171.3,163.8,172.1,163.8z"
      />
      <path
        class="st3"
        d="M341,116.5c2.3,0,4.6,0,6.9,0c0-0.1,0-0.2,0-0.3c-2.3,0-4.6,0-6.9,0C341,116.3,341,116.4,341,116.5z"
      />
      <path
        class="st3"
        d="M161.9,162.6c-0.1-1.8-0.3-3.7-0.4-5.5c-0.3,0-0.6,0-0.9,0C160.8,159,160,160.9,161.9,162.6z"
      />
      <path
        class="st3"
        d="M161.7,172.2c0-2.2,0-3.9,0-5.6c-0.3,0-0.5,0-0.8,0.1C160.7,168.4,160.1,170.1,161.7,172.2z"
      />
      <path
        class="st3"
        d="M532.1,124c2.5,0,4.9,0,7.6,0c0-2.8,0-5.6,0-8.6c-1,0.1-1.8,0.2-2.4,0.3C535.9,118.8,537.3,123.3,532.1,124z"
      />
      <path
        class="st3"
        d="M478,226.3c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2
		c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1
		c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5
		c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6s0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4
		c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1c1.3-0.4,2-1.3,2.3-2.4c0.1-0.3,0.1-0.7,0-1
		c-6-0.6-11.9-1.3-17.9-2c-0.8,0.6-1.3,1.5-1.2,2.5c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0.1-0.3,0.2-0.7,0.3-1.1
		c0.6-0.1,0.9,0.1,0.9,0.6c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1c-0.1,0-0.3-0.1-0.4,0
		c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2c0.2,0.3,0.5,0.5,0.8,0.8
		c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1c-0.6,0.3-1.1,0.6-1.5,1c-0.2,0.9-0.4,1.8-0.4,2.6c0.3,0.6,1,1.1,1.9,1.2
		c1.6,0.2,2.7-0.5,3.4-1.6c1.7-0.2,3.3-0.3,5-0.5c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3c-2.3-0.4-4.6,0.8-5.2,2.7c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1
		c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9
		c0-0.1,0-0.2,0-0.4C478.2,226.9,478.1,226.6,478,226.3z M463,222.6c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9
		C463.4,221.2,463.2,221.9,463,222.6z"
      />
      <path
        class="st3"
        d="M395,192.1c-0.5,0.8-0.9,1.3-1.1,1.9c-2,4.7-3.9,9.4-5.8,14.1c-0.7,1.7-1.9,3.5-1.8,5.1
		c0.3,4.2-1.3,7.9-2.9,11.5c-1,2.3-1.7,4.6-2.2,6.9c0.2,0.2,0.4,0.4,0.6,0.6l0,0c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4
		c0.3,0.3,0.5,0.5,0.8,0.8c2.4,0.8,5,0.3,7.5-1.1l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5
		c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0-0.7
		s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.3-0.7-0.4
		c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1
		c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2
		c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2
		c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9c0.4,0,0.9-0.5,1.4-0.8
		c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2
		c0.3,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8
		c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6
		c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3c-0.2,0.7-0.3,1.5-0.6,2.5
		c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3c0.9,0.2,2,0,2.8-0.5
		c0-1,0-2.1-0.2-3.1c-0.2-1.5-0.5-3-0.9-4.4c-0.3,0.2-0.6,0.4-1,0.5c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.7,0.4-1
		c-0.3-1.3-0.6-2.7-1-4c-0.8-3-1.4-5.9-0.8-9c0.2-0.9-0.1-1.9-0.3-2.9c-0.2-1-0.4-2-0.6-3.1c-0.3,0.1-0.6,0.3-0.8,0.4
		c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.5-0.3,0.9-0.5
		c-0.5-0.1-0.8-0.2-1.1-0.3c0.4-0.5,0.1-1.2,1-1.7c-0.9-3.8-1.7-7.5-2.6-11.4C397.1,192.3,396,192.2,395,192.1z"
      />
      <path
        class="st3"
        d="M541.3,115.7c0,2.8,0,5.5,0,8.6c2.5,0,4.8,0,7.2,0c0.2-3,0.5-5.7-0.1-8.6C546,115.7,543.8,115.7,541.3,115.7z"
      />
      <path
        class="st3"
        d="M421.5,223.7c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5
		c-0.2,0.4-0.3,0.8-0.6,1c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.4-0.1-0.6-0.5-0.8-0.9c0.1,1.9,0.5,3.8,1.2,5.7c1.5,4,0.5,8.2,0.4,12.3c0,1.2-0.1,2.5-0.1,3.7c0.3-0.1,0.7-0.1,1-0.3
		c0.5-0.6,1.1-1.2,1.3-1.8c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7
		c-0.1,0.4-0.2,0.8-0.3,1.2c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3
		c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1
		c0.3-0.3,0.7-0.5,1.1-0.8c0.2,0.1,0.3,0.2,0.4,0.3c0.5,1,0.7,1.2,1.3,1.2c0.1-0.8,0.3-1.5,0.5-2.2c0.3-1.1,0.6-2.1,0.8-3.2
		C423.2,223.8,422.5,223.7,421.5,223.7z"
      />
      <path
        class="st3"
        d="M536.9,201.1c0.3,0.1,0.7,0.1,1.2,0c0-2.9,0-5.9,0-9.2c-2.2,0-4.2-0.1-6.3-0.1c2,0.8,3,2.4,3.3,4.5
		c0.2,1.1,0.4,2.1,0.5,3.2c0,0.1,0.1,0.2,0.1,0.4c0.5-0.3,0.9-0.8,1.2-1.4c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8
		C537.7,200.5,537.5,200.9,536.9,201.1z"
      />
      <path
        class="st3"
        d="M540,191c1.6,0.2,3.2,0.3,4.9,0.5c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.1-0.9,0.1-1.4,0.4
		C540,190.5,540,190.7,540,191z"
      />
      <path
        class="st3"
        d="M540.3,198.7c-0.2,0-0.3,0-0.5-0.1c0,0.9,0,1.9,0,2.9c0.7,0.1,1.3,0.1,2,0.2c0-0.4,0.2-0.8,0.2-1.2
		C542.1,199.2,541.8,198.9,540.3,198.7z"
      />
      <path
        class="st3"
        d="M539.7,194c0.2-0.1,0.4-0.2,0.6-0.2c0.1-0.3,0.1-0.7,0.3-0.9c0.4-0.3,0.7-0.4,0.9-0.5c-0.6,0-1.2-0.1-1.8-0.1
		C539.7,192.8,539.7,193.4,539.7,194z"
      />
      <path
        class="st3"
        d="M541,125.6c0,5.2,0,10.1,0,15.3c2.4,0,4.7,0,6.9,0c0.7-3.9,0.8-12.5,0-14.9C545.8,125.8,543.5,125.7,541,125.6
		z"
      />
      <path
        class="st3"
        d="M209.1,124.2c-2.2,0-4,0-6.1,0c0,3.9,0,7.6,0,11.5c2.2,0,4,0,6.1,0C209.4,131.8,209.4,128.1,209.1,124.2z"
      />
      <path
        class="st3"
        d="M209.2,148.9c-2.1-0.7-4-1.1-6-0.5c0,3.7,0,7.2,0,11c2,0.2,3.8,0.4,6,0.6C209.2,156,209.2,152.5,209.2,148.9z"
      />
      <path
        class="st3"
        d="M205.1,160.8c0.3,0,0.6,0,0.9,0c0,0,0,0,0-0.1C205.6,160.8,205.3,160.8,205.1,160.8
		C205,160.8,205,160.8,205.1,160.8z"
      />
      <path
        class="st3"
        d="M201.9,148c-2-0.1-3.8-0.2-5.5-0.3c0,3.9,0,7.4,0,11.2c1.9,0.1,3.6,0.2,5.5,0.4
		C201.9,155.2,201.9,151.7,201.9,148z"
      />
      <path
        class="st3"
        d="M209.1,147.4c0-3.6,0-6.9,0-10.3c-2.1-0.2-3.9-0.3-6.1-0.5c-0.3,3.7-0.3,7.2,0,10.8
		C205.3,147.4,207.1,147.4,209.1,147.4z"
      />
      <path
        class="st3"
        d="M232,162.2c2.2,0.2,4.1,0.3,6.5,0.5c0.1-4.2,0.2-7.9-0.1-11.9c-2.4,0-4.4,0-6.4,0
		C232,154.7,232,158.3,232,162.2z"
      />
      <path
        class="st3"
        d="M210.4,160.3c2.1,0,4,0,5.9,0c0-3.7,0-7.2,0-11.1c-2-0.2-3.9-0.3-6.3-0.5C210.2,152.9,209.8,156.5,210.4,160.3
		z"
      />
      <path
        class="st3"
        d="M224.6,161.6c2.2,0.1,4,0.2,6.3,0.3c0.1-4,0.2-7.7-0.1-11.7c-2.3,0-4.2,0-6.5,0
		C224.3,154.1,224,157.8,224.6,161.6z"
      />
      <path
        class="st3"
        d="M215.9,124.6c-2.1-0.1-3.9-0.2-5.8-0.3c0,4.1,0,7.8,0,12c2.2,0,4,0,6.2,0C216.4,132.3,216.6,128.5,215.9,124.6
		z"
      />
      <path
        class="st3"
        d="M188.5,135.7c-1.4-0.1-2.6-0.3-4.1-0.4c0,3.6,0,6.8,0,10.5c1.6,0.1,2.8,0.2,4.1,0.3
		C188.5,142.4,188.5,139.2,188.5,135.7z"
      />
      <path
        class="st3"
        d="M188.6,147c-1.4,0-2.6,0-4.1,0c0,3.5,0,6.9,0,10.7c1.6,0.1,2.8,0.2,4.3,0.3C189,154.2,189.4,150.7,188.6,147z"
      />
      <path
        class="st3"
        d="M174.8,134.5c-2,0-3.8,0-5.6,0c0,3.4,0,6.5,0,10c2,0.1,3.8,0.3,6.2,0.4C175,141.2,175.8,137.9,174.8,134.5z"
      />
      <path
        class="st3"
        d="M178.5,156.9c0-3.6,0-7.1,0-10.7c-0.9,0-1.5,0-2.4,0c0,3.2-0.1,6.3,0,9.4C176.2,157,177.2,157.4,178.5,156.9z"
      />
      <path
        class="st3"
        d="M176.1,145c1,0,1.6,0,2.3,0c0-3.4,0-6.5,0-9.9c-0.8-0.1-1.5-0.1-2.3-0.2C176.1,138.3,176.1,141.5,176.1,145z"
      />
      <path
        class="st3"
        d="M200.1,160.2v-0.1c-0.4,0-0.7,0-1.1-0.1v0.1C199.4,160.2,199.8,160.2,200.1,160.2z"
      />
      <path
        class="st3"
        d="M194.9,136c-1.8-0.1-3.4-0.2-5.1-0.2c0,3.6,0,6.9,0,10.4c1.8,0.2,3.3,0.4,5.1,0.6
		C194.9,143,194.9,139.6,194.9,136z"
      />
      <path
        class="st3"
        d="M201.9,136.5c-2,0-3.8,0-5.7,0c0,3.5-0.2,6.8,0.1,10.3c2.1,0,3.8,0,5.6,0C201.9,143.3,201.9,140,201.9,136.5z"
      />
      <path
        class="st3"
        d="M195,147.4c-1.9,0-3.4,0-5.1,0c0,3.6,0,7.1,0,10.8c1.8,0.1,3.3,0.3,5.3,0.4C195.8,154.8,195.4,151.2,195,147.4
		z"
      />
      <path
        class="st3"
        d="M273.5,205.3c0.1,0.2,0.2,0.4,0.3,0.6c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.2-0.2-0.4-0.3-0.5
		C273.8,205.2,273.6,205.3,273.5,205.3z"
      />
      <path
        class="st3"
        d="M454.1,152.5c3.1,0.2,6.3,0.4,9.8,0.6c0-5.1,0-9.9,0-15.3c-3.4,0-6.6,0-9.8,0
		C453.4,141.9,453.4,150,454.1,152.5z"
      />
      <path
        class="st3"
        d="M454.1,136.2c3.3,0.2,6.6,0.4,10.1,0.6c0.1-5,0.2-9.5,0.1-14.2c-3.6-0.2-6.7-0.4-10.3-0.5
		C454.1,127,454.1,131.4,454.1,136.2z"
      />
      <path
        class="st3"
        d="M463.6,154.2c-3.3-0.2-6.4-0.4-10-0.6c0,4.7,0,9,0,13.7c3.4,0.2,6.7,0.5,10.3,0.7c0-2.6,0-4.8,0-7
		C463.8,158.8,464.2,156.6,463.6,154.2z"
      />
      <path
        class="st3"
        d="M453.5,182.9c3.3,0.3,6.5,0.6,10,0.9c0-5,0-9.7,0-14.6c-3.3-0.3-6.5-0.5-10-0.8
		C453.5,173.4,453.5,178,453.5,182.9z"
      />
      <path
        class="st3"
        d="M459.9,185c0.8,0,1.5,0,2.3,0v-0.1c-0.8,0-1.5,0-2.3,0C459.9,184.9,459.9,184.9,459.9,185z"
      />
      <path
        class="st3"
        d="M465.4,153.2c3.6,0.2,7,0.5,10.7,0.7c0-5.2,0-10.1,0-15.4c-3.7,0-7.1,0-10.7,0
		C465.4,143.4,465.4,148.2,465.4,153.2z"
      />
      <path
        class="st3"
        d="M465.7,136.9c3.5,0.2,6.9,0.4,10.7,0.6c0-4.9,0-9.5,0-14.4c-3.3-0.6-6.7-0.3-10.7-0.6
		C465.7,127.5,465.7,132.1,465.7,136.9z"
      />
      <path
        class="st3"
        d="M466.3,121.3c3.3,0.2,6.6,0.4,9.9,0.6C472.9,120.5,469.6,120.9,466.3,121.3z"
      />
      <path
        class="st3"
        d="M465.2,168.1c3.5,0.3,6.9,0.6,10.8,0.9c0-4.9,0-9.3,0-13.8c-3.6-0.7-7.1-0.8-10.8-0.7
		C465.2,159.3,465.2,163.5,465.2,168.1z"
      />
      <path
        class="st3"
        d="M452.1,120.2c-2.9,0-5.7,0-8.6,0c0,0.1,0.1,0.3,0.1,0.4c2.8,0,5.7,0,8.5,0
		C452.1,120.4,452.1,120.3,452.1,120.2z"
      />
      <path
        class="st3"
        d="M441.9,181.7c3.4,0.4,6.6,1,10.2,0.8c0.1-4.9,0.3-9.5,0.1-14.3c-3.6-0.3-6.8-0.5-10.3-0.8
		C441.9,172.3,441.9,176.8,441.9,181.7z"
      />
      <path
        class="st3"
        d="M442,166.3c3.3,0.3,6.6,0.5,10.2,0.8c0-4.7,0-9,0-13.6c-3.5-0.2-6.7-0.4-10.2-0.7
		C442,157.4,442,161.7,442,166.3z"
      />
      <path
        class="st3"
        d="M479.3,186.9c0.3,0,0.5,0,0.7,0l-0.1-0.1C479.7,186.8,479.6,186.8,479.3,186.9z"
      />
      <path
        class="st3"
        d="M359.5,125c0,2,0.1,4,0.2,6.2c2.9,0.2,5.5,0.4,8.5,0.7c0-4.7,0-8.8,0-13.3c-3,0.1-5.7-0.7-8.7,0
		C359.5,120.9,359.5,123,359.5,125z"
      />
      <path
        class="st3"
        d="M455.9,184.2c-0.4,0-0.7,0-1.1,0.1c0.4,0,0.7,0.1,1.1,0.1C455.9,184.3,455.9,184.3,455.9,184.2z"
      />
      <path
        class="st3"
        d="M454.9,120.2c0,0.2,0,0.4,0,0.7c3,0.2,5.9,0.4,8.9,0.6c0-0.2,0.1-0.4,0.1-0.7
		C460.8,120.6,457.8,120.4,454.9,120.2z"
      />
      <path
        class="st3"
        d="M466,185.6c0.9,0,1.8,0,2.8,0v-0.1c-0.9,0-1.8,0-2.8,0C466,185.6,466,185.6,466,185.6z"
      />
      <path
        class="st3"
        d="M442.4,135.6c3.4,0.2,6.6,0.4,10.1,0.6c0-4.8,0-9.3,0-14.1c-3.4-0.2-6.7-0.3-10.1-0.5
		C442.4,126.5,442.4,130.9,442.4,135.6z"
      />
      <path
        class="st3"
        d="M474,186.2L474,186.2c-0.5-0.1-1.1-0.1-1.6-0.1v0.1C473,186.2,473.5,186.2,474,186.2z"
      />
      <path
        class="st3"
        d="M477.4,155.5c0,4.6,0,9,0,13.6c3.6,0.3,7,0.6,10.9,0.9c0-4.9,0-9.4,0-14.1C484.5,156,481.1,154.8,477.4,155.5z
		"
      />
      <path
        class="st3"
        d="M515.4,122.9c0,0.1-0.1,0.2-0.1,0.3c1.5,0,3,0,4.6,0c0-0.1,0-0.2,0-0.3C518.4,122.9,516.9,122.9,515.4,122.9z"
      />
      <path
        class="st3"
        d="M478.7,121.6c0,0.1,0,0.2,0,0.3c3,0,6,0,9,0c0.1-0.1,0.2-0.2,0.3-0.3C484.9,121.6,481.8,121.6,478.7,121.6z"
      />
      <path
        class="st3"
        d="M502.9,138.8c3.2,0.2,6.5,0.3,10.3,0.5c0-5.2,0-9.8,0-14.9c-3.5,0-6.9,0-10.3,0
		C502.2,127.5,502.2,136.2,502.9,138.8z"
      />
      <path
        class="st3"
        d="M502.4,155.7c3.5,0.2,6.8,0.4,10.4,0.7c0-5.4,0.4-10.5,0.2-15.9c-3.7,0-7,0-10.6,0
		C502.4,145.4,502.4,150.3,502.4,155.7z"
      />
      <path
        class="st3"
        d="M520.3,141c-2,0-3.9,0-6,0c0,5.2,0,10.2,0,15.5c2,0,3.9,0,6,0C520.3,151.3,520.3,146.4,520.3,141z"
      />
      <path
        class="st3"
        d="M514.6,139.5c2,0,3.8,0,5.9,0c0-4.9,0-9.7,0-14.7c-1.9,0-3.7,0-5.9,0C514.6,129.7,514.6,134.5,514.6,139.5z"
      />
      <path
        class="st3"
        d="M540,189.4c0.1,0.1,0.3,0.3,0.4,0.4c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3
		v-0.1c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4l-0.1-0.1c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3
		c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3-0.7-0.7-0.8-0.5c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4
		c-0.5-0.1-0.9-0.4-1.3-0.7C540,184.3,540,186.8,540,189.4z"
      />
      <path
        class="st3"
        d="M560,176.6C560,176.6,560,176.7,560,176.6c-0.1,0-0.2,0-0.2-0.1c-0.2-0.3-0.3-0.5-0.5-0.8
		c-0.1,0-0.3,0.1-0.4,0.2c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6c-0.1,0.2-0.3,0.5-0.6,0.8
		c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1
		c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1c-0.4,0.3-0.7,0.6-1.1,0.9
		c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7v-0.1
		l0,0c0.6,0.2,1.2,0.2,1.7,0c0-1.9,0.1-3.8,0.1-5.7c-0.2,0.2-0.3,0.4-0.4,0.7C560.4,176.1,560.4,176.2,560,176.6z"
      />
      <path
        class="st3"
        d="M530.6,190.1c2.5,0.2,5,0.4,7.9,0.6l0,0c-0.3,0-0.5-0.1-0.8-0.3l0,0l0,0c0.5-0.4,0.7-0.6,0.7-0.8
		c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c0-1.9,0-3.8,0-5.7c-0.2,0.9-0.8,1.7-2.1,2.2
		c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2
		c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4
		c0,0,0,0-0.1-0.1l0,0C530.6,183.2,530.6,186.6,530.6,190.1z"
      />
      <path
        class="st3"
        d="M514,157.8c0,5,0,9.5,0,14.2c2,0.2,3.9,0.3,6.1,0.5c0-2.7,0-4.9,0-7.2c-0.1-2.3,0.6-4.7-0.1-7.2
		C518.1,158,516.3,157.9,514,157.8z"
      />
      <path
        class="st3"
        d="M477.4,153.9c4,0.4,7.4,0.9,11.1,0.6c0-5.2,0-10,0-15.3c-3.6,0-7.1,0-11,0C477.5,144,477.3,148.9,477.4,153.9z
		"
      />
      <path
        class="st3"
        d="M503.7,122.1c0,0.2,0,0.5,0,0.7c3,0.2,6.1,0.3,9.1,0.5c0-0.2,0-0.4,0-0.6C509.7,122.5,506.7,122.3,503.7,122.1
		z"
      />
      <path
        class="st3"
        d="M490.6,122.4c3.4,0,6.6,0,9.7,0c-3-0.4-6-0.5-9-0.7C491.2,121.7,491,121.9,490.6,122.4z"
      />
      <path
        class="st3"
        d="M431.8,135c3.1,0.2,6,0.4,9.2,0.5c0-4.9,0-9.3,0-14.1c-3.2,0-6.1,0-9.2,0C431.8,126,431.8,130.4,431.8,135z"
      />
      <path
        class="st3"
        d="M478.2,137.6c1.7,0.1,3.4,0.2,5.1,0.2s3.4,0,5.4,0c0-4.8,0-9.5,0-14.4c-3.7,0-7.1,0-10.7,0
		C477.3,128.2,477.4,135.2,478.2,137.6z"
      />
      <path
        class="st3"
        d="M501.3,124c-3.9-0.2-7.3-0.3-11.2-0.5c0,5.1,0,9.7,0,14.7c3.7,0.2,7.2,0.4,11,0.5
		C501,133.6,501.6,128.9,501.3,124z"
      />
      <path
        class="st3"
        d="M490,139.6c0,5.2,0,10.1,0,15.3c3.7,0.2,7.2,0.4,10.9,0.5c0-5.3,0-10.2,0-15.7
		C497.2,139.8,493.7,139.3,490,139.6z"
      />
      <path
        class="st3"
        d="M489.8,170.1c3.6,0.3,7.1,0.6,10.9,0.9c0-4.9,0-9.4,0-14.2c-3.4-0.2-6.9-0.5-10.9-0.8
		C489.8,160.9,489.8,165.4,489.8,170.1z"
      />
      <path
        class="st3"
        d="M442.2,151.7c3.5,0.4,6.8,0.5,10.2,0.6c0-5.2,0-9.9,0-15c-3.4-0.2-6.6-0.3-10.2-0.5
		C442.2,142,442.2,146.7,442.2,151.7z"
      />
      <path
        class="st3"
        d="M421.5,118.9c0,0.1,0,0.3,0,0.4c2.7,0.2,5.5,0.4,8.2,0.6c0-0.2,0-0.4,0-0.6C427,119.2,424.2,119.1,421.5,118.9
		z"
      />
      <path
        class="st3"
        d="M380.1,176c1.4,0,2.5,0,3.7,0c-0.6-3-0.9-3.3-3.5-3.3C380.3,173.7,380.2,174.7,380.1,176z"
      />
      <path
        class="st3"
        d="M440,119.6c-2.5,0-5.1,0-7.6,0c0,0.1,0,0.2,0,0.3c2.5,0,5.1,0,7.6,0C440,119.8,440,119.7,440,119.6z"
      />
      <path
        class="st3"
        d="M378.8,162.7c0,1.4,0,2.8,0,4.5c2.4-0.3,4.7-0.6,7.1-0.9C384.2,162.4,383.8,162.2,378.8,162.7z"
      />
      <path
        class="st3"
        d="M411,118.9c0,0.1,0,0.2,0,0.3c2.5,0,5.1,0,7.6,0c0-0.1,0-0.2,0-0.3C416.1,118.9,413.5,118.9,411,118.9z"
      />
      <path
        class="st3"
        d="M407.4,118.4c-2.2,0-4.4,0-6.6,0c0,0.1,0,0.2,0,0.2c2.2,0,4.4,0,6.6,0C407.4,118.6,407.4,118.5,407.4,118.4z"
      />
      <path
        class="st3"
        d="M409.7,133.9c3.4,0.2,6.4,0.4,9.6,0.6c0-4.7,0-9.1,0-13.7c-3.1-0.2-6.1-0.4-9.7-0.6
		C409.6,125,409.4,129.3,409.7,133.9z"
      />
      <path
        class="st3"
        d="M394.9,148.5c1.1,0,2.1,0,3.3,0c0-4.7,0-9.2,0-14c-2.8-0.2-5.4-0.3-8.2-0.5C391.7,139,393.3,143.7,394.9,148.5
		z"
      />
      <path
        class="st3"
        d="M409.7,149.5c3.3,0.2,6.3,0.4,9.6,0.6c0-5.1,0-9.7,0-14.6c-3.1-0.2-6.1-0.4-9.6-0.6
		C409.7,140.1,409.7,144.6,409.7,149.5z"
      />
      <path
        class="st3"
        d="M431.5,136.4c0,4.9,0,9.5,0,14.4c3.1,0.6,6.1,0.6,9.3,0.5c0-5,0-9.6,0-14.7
		C437.6,136.5,434.6,136.1,431.5,136.4z"
      />
      <path
        class="st3"
        d="M384.2,154.8c-1.1-0.3-1.9-0.5-2.9-0.7c-1,2.4-1.8,4.5-2.7,7c1.6,0.2,2.8,0.4,4.4,0.7
		C383.4,159.3,383.8,157.1,384.2,154.8z"
      />
      <path
        class="st3"
        d="M367.8,147.8c-2.6-0.2-5.3-0.3-8.1-0.5c0,4.3,0,8.2,0,12.4c2.3,0.2,4.6,0.4,7,0.7
		C367.7,156,368.8,152.2,367.8,147.8z"
      />
      <path
        class="st3"
        d="M369.4,131.8c1.9,0,3.4,0,5.1,0c-0.5-4.5-1-8.7-1.5-12.8c-1.2,0-2.3,0-3.7,0
		C369.4,123.4,369.1,127.5,369.4,131.8z"
      />
      <path
        class="st3"
        d="M359.4,174.1c2.1,0,3.8,0,5.9,0c0.4-4.2,0.9-8.4,1.3-12.7c-2.6-0.4-4.8-0.8-7.2-0.2
		C359.4,165.6,359.4,169.7,359.4,174.1z"
      />
      <path
        class="st3"
        d="M368.3,132.8c-3-0.2-5.6-0.3-8.6-0.5c0,4.8,0,9.2,0,13.8c2.9,0.2,5.5,0.5,8.5,0.7
		C368.3,142,368.5,137.5,368.3,132.8z"
      />
      <path
        class="st3"
        d="M376.8,169.8c1.1-1.9,0.8-3.6,0.5-5.5c-2.4,3.1-3.3,6.9-4.4,11c1.2,0,1.9,0,2.4,0
		C375.8,173.3,375.9,171.3,376.8,169.8z"
      />
      <path
        class="st3"
        d="M395.8,150.1c0.6,1.6,1.2,3.2,1.8,5C399.1,151.3,398.6,149.8,395.8,150.1z"
      />
      <path
        class="st3"
        d="M375.1,136.8c0.3-1,0.2-2.2,0.3-3.6c-2.3,0-4,0-6,0c0,4.6,0,9,0,13.3c1.6,0.8,2.1,0,2.6-1.2
		C373,142.4,374.2,139.6,375.1,136.8z"
      />
      <path
        class="st3"
        d="M370.3,148.5c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2,0.4-0.4,0.8-0.6,1.2c0.1,0.1,0.3,0.2,0.4,0.2
		C369.9,149.2,370.1,148.9,370.3,148.5z"
      />
      <path
        class="st3"
        d="M429.9,166.5c-3.2-0.3-6.3-0.5-9.6-0.8c0,4.9,0,9.3,0,14.2c3.2,0.3,6.3,0.6,9.6,0.9
		C429.9,175.8,429.9,171.3,429.9,166.5z"
      />
      <path
        class="st3"
        d="M423.5,181.7c1.1,0,2.3,0,3.4,0c0-0.1,0-0.1,0-0.2c-1.1,0-2.3,0-3.4,0C423.5,181.6,423.5,181.7,423.5,181.7z"
      />
      <path
        class="st3"
        d="M409.4,163.6c3.3,0.3,6.3,0.5,9.4,0.8c0.8-3.5,0.7-10.6,0-13.2c-2.9-0.2-5.9-0.4-9.4-0.7
		C409.4,155.2,409.4,159.3,409.4,163.6z"
      />
      <path
        class="st3"
        d="M420.3,164.6c3.3,0.2,6.3,0.5,9.7,0.7c0-4.7,0-8.9,0-13.2c-3.2-0.3-6.2-0.5-9.6-0.8
		C420.2,155.8,420.2,160.1,420.3,164.6z"
      />
      <path
        class="st3"
        d="M420.8,134.5c3.4-0.1,6.4,0.7,9.5,0.3c0-4.8,0-9.1,0-13.8c-3.3,0-6.3,0-9.5,0
		C420.8,125.5,420.8,129.8,420.8,134.5z"
      />
      <path
        class="st3"
        d="M431.4,165.4c3,0.3,5.9,0.5,9.2,0.8c0-4.7,0-9,0-13.5c-3.1-0.2-6.1-0.4-9.2-0.7
		C431.4,156.7,431.4,161,431.4,165.4z"
      />
      <path
        class="st3"
        d="M431.3,166.6c0,4.9,0,9.5,0,14.4c3.1,0.2,5.9,0.4,8.7,0.6c0.8-4.1,0.7-12.1,0-14.4
		C437.2,167,434.4,166.8,431.3,166.6z"
      />
      <path
        class="st3"
        d="M411.3,179c2.4,0.2,4.9,0.4,7.7,0.6c0-4.8,0-9.3,0-14.1c-3.2-0.2-6.2-0.5-9.4-0.7
		C408.4,170.7,409,175.4,411.3,179z"
      />
      <path
        class="st3"
        d="M420.7,150.3c3.2,0.2,6.2,0.4,9.5,0.5c0-5,0-9.7,0-14.8c-3.2,0-6.3,0-9.5,0
		C420.7,140.7,420.7,145.4,420.7,150.3z"
      />
      <path
        class="st3"
        d="M399.4,162.9c3.2,0.3,5.9,0.7,8.8,0.5c0-4.5,0-8.5,0-12.9c-2.9-0.2-5.7-0.4-8.8-0.6
		C399.2,154.5,399.2,158.6,399.4,162.9z"
      />
      <path
        class="st3"
        d="M397.1,123.4c-2.3,0.4-2.8,2.4-3.7,4.1c-0.9,1.7-3.4,2.6-2.8,5.4c2.5,0,4.9,0,7.6,0c0.8-5.5,0.6-11.4-0.7-13.2
		C397.3,121,397.2,122.1,397.1,123.4z"
      />
      <path
        class="st3"
        d="M416.9,181.1c0.4,0,0.8,0,1.2,0c0-0.1,0-0.1,0-0.2c-0.4,0-0.8,0-1.2,0C416.9,181,416.9,181,416.9,181.1z"
      />
      <path
        class="st3"
        d="M403.1,177c-0.1,0.3-0.1,0.5-0.2,0.8c1,0.2,2.1,0.4,3.7,0.7C405.6,175.7,404.1,177.8,403.1,177z"
      />
      <path
        class="st3"
        d="M406.3,179.8v-0.1c-0.4,0-0.8-0.1-1.2-0.1v0.1C405.5,179.8,405.9,179.8,406.3,179.8z"
      />
      <path
        class="st3"
        d="M408,164.5c-2.4,0-4.6,0-6.7,0c1.3,0.9,2.7,1.6,3.7,2.6c1.1,1.1,1.9,2.6,3,4.2C408,168.8,408,166.8,408,164.5z
		"
      />
      <path
        class="st3"
        d="M414.2,180.5c0-0.1,0-0.1,0-0.2c-0.6,0-1.2,0-1.8,0c0,0.1,0,0.1,0,0.2C413,180.5,413.6,180.5,414.2,180.5z"
      />
      <path
        class="st3"
        d="M399.7,133.4c2.8,0,5.6,0,8.3,0c0.7-3,0.7-10.7-0.1-13.2c-2.6,0-5.3,0-8.2,0
		C399.7,124.5,399.7,128.8,399.7,133.4z"
      />
      <path
        class="st3"
        d="M399.5,148.8c3,0.2,5.7,0.4,8.7,0.7c0-5.1,0-9.6,0-14.5c-2.9-0.2-5.5-0.4-8.7-0.6
		C399.5,139.4,399.5,144,399.5,148.8z"
      />
      <path
        class="st3"
        d="M223.5,161.3c0.1-4,0.3-7.7-0.2-11.6c-2.1-0.1-3.8-0.2-6-0.3c0,4.1-0.3,7.7,0.2,11.6
		C219.6,161,221.3,161.1,223.5,161.3z"
      />
      <path
        class="st3"
        d="M331.3,116c0.9,0,1.8,0,2.7,0l0,0c0-0.1-0.1-0.2-0.1-0.2c-0.9,0-1.7,0-2.6,0
		C331.3,115.8,331.3,115.9,331.3,116z"
      />
      <path
        class="st3"
        d="M336.4,115.7c-0.3,0.1-0.5,0.1-0.8,0.2c0.8,0,1.5,0,2.3,0v-0.1c-0.1-0.1-0.2-0.1-0.3-0.2
		C337.1,115.7,336.8,115.7,336.4,115.7z"
      />
      <path
        class="st3"
        d="M326.2,115.9c0.8,0,1.7,0,2.5,0c0-0.1,0.1-0.2,0.1-0.3c-0.3,0-0.5,0-0.8,0c-0.1,0.1-0.2,0.1-0.4,0.2
		c0-0.1-0.1-0.2-0.1-0.2c-0.5,0-0.9,0-1.4,0C326.2,115.7,326.2,115.8,326.2,115.9z"
      />
      <path
        class="st3"
        d="M348.2,117.8c-2.3,0-4.7,0-7.3,0c0,0,0,0,0,0.1c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.8,0.9
		c0,3.7,0,7.2,0,11c2.9,0,5.6,0,8.2,0C349,126.9,348.9,120.4,348.2,117.8z"
      />
      <path
        class="st3"
        d="M357.8,96.4c0.1-1.4-0.8-2.4-2-3.2c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.7,2.1c-0.2,0.4-0.3,0.8-0.4,1.2
		c-0.2,1-0.8,1.8-1.7,2.3c-0.3,0.2-0.5,0.3-0.7,0.5c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.5-0.1,2.3c0,0.1,0,0.2,0,0.2
		c4.7,0.1,9.5,0.3,14.2,0.4c0-0.1,0-0.1-0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4
		c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1C357.9,96.9,357.8,96.7,357.8,96.4z"
      />
      <path
        class="st3"
        d="M209.2,118.7c-0.2-0.1-0.4-0.1-0.7-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,0.3-1,0.6-1.5,0.8c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.2-0.2-0.5-0.4-0.7-0.5c0,0.9,0,1.9,0,2.8c2.1,0,3.9,0,6.1,0C209.1,121.6,209.2,120.2,209.2,118.7z"
      />
      <path
        class="st3"
        d="M201.2,122.6h0.1c0-0.1,0.1-0.1,0.1-0.2s0.1-0.1,0.1-0.2c0-0.6,0-1.3,0-1.9c-0.5,0.1-1,0.3-1.1,0.4
		C200.1,121.3,200.4,122,201.2,122.6z"
      />
      <path
        class="st3"
        d="M329.6,117c-2,0-3.9,0-5.9,0c-0.6,0.4-1.1,0.9-1.4,1.5c-0.4,0.7-0.5,1.5-0.6,2.3v0.1c0,0.3,0.1,0.7,0.2,1
		c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1c-0.2-0.3-0.4-0.5-0.6-0.7
		c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4s0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c0-0.2,0-0.3-0.1-0.4c0,1,0,2.1,0,3.1
		c2.7,0.1,5.2,0.3,7.9,0.4C329.6,125.2,329.6,121.2,329.6,117z"
      />
      <path
        class="st3"
        d="M368.7,104.2c1.1,0,2.2,0.1,3.3,0.1c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3
		S368.7,104.1,368.7,104.2z"
      />
      <path
        class="st3"
        d="M341.7,102.8c0.1,0.3,0.3,0.5,0.5,0.7c0.5,0,1.1,0,1.6,0c-0.1-0.2-0.2-0.5-0.3-1
		C342.9,102.6,342.3,102.7,341.7,102.8z"
      />
      <path
        class="st3"
        d="M287.4,132c0.5-0.1,0.9-0.1,1.3-0.3c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1
		c0.3,1-0.1,2.2-0.2,3.5c-1-0.4-1.8-1.1-2.5-1.6c0.1,1.7,0.5,3.4,1.6,5c1.9,0,3.5,0,5.3,0c0-4,0-7.9,0-11.9c-0.5-0.2-1-0.2-1.5-0.2
		s-1.1,0.2-1.6,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3
		c-0.1-0.5-0.3-0.8-0.6-1.1c-0.6,0-1.3-0.1-2-0.1C287.5,129.7,287.5,130.8,287.4,132z"
      />
      <path
        class="st3"
        d="M296.7,115.7c-0.4,0.1-0.9,0.2-1.3,0.3c0,1.1,0,2.2,0,3.2C296.8,118.6,297.5,117,296.7,115.7
		C296.8,115.8,296.8,115.7,296.7,115.7z"
      />
      <path
        class="st3"
        d="M286.1,128.5c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2c0.1,0.2,0.3,0.3,0.5,0.4
		C286.1,130.7,286.1,129.6,286.1,128.5z"
      />
      <path
        class="st3"
        d="M292.4,123.7c-1.5,0.9-2,1.6-1.7,2.7c0.3,0.8,0.9,1.2,2.1,1.3c0.4-0.1,0.9-0.2,1.3-0.3c0-2.4,0-4.7,0-7.1
		c-0.2-0.2-0.4-0.3-0.6-0.5c0.2-0.1,0.4-0.1,0.6-0.2c0-1.3,0-2.7,0-4c-0.9,0-1.7,0-2.6,0c-0.7,0.8-0.9,1.7-0.4,2.6s1.2,1.7,1.9,2.5
		C294,121.8,293.8,123,292.4,123.7z"
      />
      <path
        class="st3"
        d="M303.3,123.9c-0.3,0-0.5,0.1-0.7,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3
		c0.1,0.3,0.4,0.6,0.8,0.7c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.1,0,0.2,0,0.3,0C303.3,126.3,303.3,125.1,303.3,123.9z"
      />
      <path
        class="st3"
        d="M319.1,122.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3c-0.7-0.2-1.4-0.1-2.5,0.3
		c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.1,0.4-0.2,0.6-0.4,0.7c0,2.3,0,4.5,0,6.9
		c2.4,0.1,4.7,0.2,7.1,0.3c0-1.8,0-3.4,0-5.1c-0.2-0.3-0.4-0.7-0.7-1C319.4,122.9,319.3,122.8,319.1,122.6z M313.6,122.5
		L313.6,122.5l0.1-0.1L313.6,122.5z"
      />
      <path
        class="st3"
        d="M309.5,121.9c-0.4,0.1-0.8,0.3-1.2,0.4c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.4-0.3,0.6v0.3v0.2c-0.6,0-1.1,0-1.6-0.4
		c-0.1-0.1-0.3-0.1-0.4-0.1c0.1,1.3,0.2,2.5,0.4,3.4c0.2-0.1,0.5-0.2,0.7-0.4c-0.2,0.3-0.4,0.5-0.6,0.8c0.1,0.2,0.1,0.5,0.2,0.7
		c2.2,0,4.5,0,6.8,0c0.3-2,0.4-4.2,0.4-6.3c-0.3,0-0.6,0-0.9-0.1c-0.5-0.1-1-0.4-1.2-1.1C309.7,121.4,309.6,121.7,309.5,121.9z
M305.8,126.7c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.3,0,0.4,0C305.9,126.5,305.8,126.7,305.8,126.7z"
      />
      <path
        class="st3"
        d="M303.1,130.2c-0.3,0.8-0.4,1.6-0.4,2.5c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1
		c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4
		c-0.7-0.1-1-0.6-1.3-1.1c-1.3-0.1-2.7-0.1-4,0.1c0,4.3,0,8.4,0,12.8c2.5,0.1,4.8,0.2,7.5,0.4C303.1,138.1,303.1,134.2,303.1,130.2z
		"
      />
      <path
        class="st3"
        d="M295.6,127.9c0.7,0,1.5,0.1,2.2,0.1c-0.2-0.1-0.3-0.3-0.5-0.5c-0.4-0.5-0.7-1.1-1.1-1.7
		c-0.3-0.4-0.6-0.9-0.8-1.3C295.4,125.6,295.5,126.7,295.6,127.9z"
      />
      <path
        class="st3"
        d="M185.1,127.3c-0.2,0.4-0.5,0.6-0.8,0.9c0,2.1,0,4.1,0,6.2c1.5,0,2.7,0,4.1,0c0-1.1,0-2.2,0-3.3
		c-0.6,0-1-0.3-1.4-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1
		C186,126.5,185.4,126.7,185.1,127.3z"
      />
      <path
        class="st3"
        d="M138.4,101.5c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2
		c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8
		c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2
		c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1
		c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1
		c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2
		c0-0.4-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6
		c0.5,0.1,0.6,0.3,0.6,0.6c0,0.3-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8
		c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6
		c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2c0,0.3,0,0.6,0,1
		c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2
		c0,0,0-0.1,0.1-0.1l0,0c0.9,0,1.7,0.4,2.6-0.2c0-1.6,0-3.1-0.1-4.7c0,0,0,0-0.1,0.1c0-0.1,0-0.2,0-0.3l0,0
		c-0.1-5.6-0.2-11.3-0.2-16.9c-0.2,0-0.3,0.1-0.5,0.1c0-0.8,0-1.5-0.1-2.2c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4
		c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.7-0.7c-1.5,0.3-2.4-0.1-3.2-1.2c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5
		C140,102.3,139.3,101.9,138.4,101.5z M151.6,129.3v0.1V129.3L151.6,129.3z"
      />
      <path
        class="st3"
        d="M88,244.4c-0.8-0.1-1.2,0-1.4,0.3c-5.2,5.3-10.5,10.7-15.7,16.1c-0.8,0.8-1.2,2-1.7,2.8
		c2.9,4.4,8.8,6,13.6,4.1c2.1-0.8,4.3-1.1,6.4-1.6c0.1-0.3,0.2-0.6,0.3-0.9c-3.3-1.6-7.3-0.7-10.6-3c0.6-3.6,3.2-6,4.7-8.9
		C85.1,250.4,86.5,247.4,88,244.4z"
      />
      <path
        class="st3"
        d="M77.4,230.9c-0.6-1.1-0.9-1.7-1.4-2.5c-0.4,0.8-0.7,1.3-1,1.8C75.6,230.4,76.2,230.6,77.4,230.9z"
      />
      <path
        class="st3"
        d="M98.1,272.2c-0.7,0.1-1.4,0.2-2.1,0.2C96.7,272.8,97.6,272.8,98.1,272.2z"
      />
      <path
        class="st3"
        d="M196.6,125.3c-0.1-0.1-0.3-0.1-0.4-0.1c0,3.5,0,6.7,0,10c2.1,0.2,3.8,0.3,5.5,0.5c0-3.9,0-7.5,0-11.4
		c-0.1,0-0.3,0.1-0.4,0.1c-0.8,0.3-1.5,0.6-1.8,1.5C198.6,125.8,197.5,125.8,196.6,125.3z"
      />
      <path
        class="st3"
        d="M127.6,291.6c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2
		c-1-0.2-1.6,0.3-2.4,0.9c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6
		c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5
		c-0.2,0.4-0.3,0.8-0.6,1c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6
		c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0
		c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3c0-0.1,0.1-0.1,0.1-0.2c-1.7,0.1-3.4,0.2-5.1,0.4c-1.6,0.2-3.1,0.7-4.6,1.1
		c-0.7,0.2-1.5,0.3-2.2,0.3c-6.6,0-13.2,0-19.9-0.1c4.3-0.3,8.5-0.7,12.8-1c-1.1-1.2-2.4-0.8-3.5-0.6c-1.5,0.3-2.7,0-4-0.8
		c-2.2-1.4-4.4-2.7-6.6-4.1c-1.5-0.9-1.7-1.7-0.7-3.3c0.6-1,1.3-2,2.2-2.8c4.2-4.3,7.6-9.3,10.2-14.7c2.1-4.3,5.4-7.3,9.3-9.8
		c0.5-0.3,1.1-0.7,2.2-1.3c-3.2-1.2-4.6-4.4-8-4.7c-0.3,0-0.6-0.7-0.9-1.1c-0.4-0.5-0.9-0.9-1.2-1.4c-2.2-3.3-4.6-6.5-6.6-10
		c-2.6-4.6-3.5-9.4-0.2-14.1c1.5-2.2,3-4.5,4.7-6.6c1.1-1.4,1.7-2.8,1.1-4.5c-0.7-1.9,0.3-3.1,1.6-4.2c2.6-2.1,5.3-4.2,8-6.3
		c-0.5,0-1,0-1.5,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.7,0-0.9-0.1c-0.1,0-0.2-0.1-0.1-0.4l0,0
		c0-0.2,0.1-0.4,0.1-0.5v-0.1c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4c-0.1-0.1-0.2-0.2-0.2-0.3
		c-0.2-0.5-0.6-0.8-1-1c-0.7-0.3-1.6-0.1-2.4,0.6c-0.5,0.5-0.8,1.1-1.8,0.8c0.1,0.5,0.2,0.8,0.3,1.3c0.5-0.1,1-0.1,1.8-0.2
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6c-0.4-0.5-0.7-1-1.1-1.6
		c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2
		c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0
		c-0.2-0.8-0.7-1.4-1.4-1.6c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1
		c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3s0.5-0.2,0.8-0.3c0.1,0,0.3-0.1,0.4-0.1l0,0c0.2-0.2,0.5-0.7,0.6-0.7
		c1.1,0.2,1.4-0.7,2.2-1.1c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5
		c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2c-0.8-0.9-2.1-1.2-3.3-1.4l0,0
		c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.2-0.8-0.4-0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4
		c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1c-0.1-0.2-0.2-0.5-0.2-0.8c0.1-1.4-0.8-2.4-2-3.2
		c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.7,2.1c-0.2,0.4-0.3,0.8-0.4,1.2c-0.2,1-0.8,1.8-1.7,2.3c-0.3,0.2-0.5,0.3-0.7,0.5
		c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.5-0.1,2.3c0,0.1,0,0.2,0.1,0.3l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3
		c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6c-0.5,1-0.2,2,0.7,3c-1.5,0-2.7,0.3-3.5,1.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1c-0.6-0.5-1.4-0.2-1.7,0.5c-0.1,0.2-0.1,0.4-0.1,0.6
		l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1c0.2,0.5,0.6,1,1.3,1.3
		c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.9,0.9
		c-0.3-0.6-0.8-1.1-1-1.7c-0.8-2.2-1.9-2.5-4.5-1.2c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.3-0.5-0.5-0.8
		c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.4-0.1-0.7,0.3-1.1c0.3-0.3,0.3-0.8,0.4-1.2c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1
		c-0.3,0.5-0.7,0.9-0.9,1.4c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1
		c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2
		c-0.4,0.8-1,1.3-1.7,1.8c-0.8,0.5-1.6,1.2-2,1.9s-0.5,1.6-0.6,2.3c0,0.3,0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3
		c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1
		c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1c-0.2-0.1-0.3-0.4-0.4-0.6
		c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3c-0.7-0.2-1.4-0.1-2.5,0.3
		c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9c-0.3,0-0.7-0.1-1-0.1
		c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-1,0.3-1.9,0.6-2.7,0.9c-0.3,0.3-0.3,0.7-0.6,1v0.3v6.7c1.1,0.6,2.2,1.1,3.2,1.7
		c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8c0.9,0.2,2.2-0.4,3,0.7
		c0,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.2,0.7-1.9,1.1c0,1-0.1,2.1-0.1,3.2c0,0.1,0,0.1,0,0.2c-0.5,0-1.1,0-1.6,0
		c-0.6,0-1.3,0-1.9,0c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1
		c-0.1,0.1-0.2,0.2-0.3,0.3s-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.3,0.2,0.6,0.5,0.8c0.6,0.4,1.2,0.6,1.9,0.4
		c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4c-0.2,0.2-0.3,0.3-0.4,0.4
		c-0.2-0.4-0.6-0.7-1-1c-0.8-0.2-1.5-0.5-2-0.9v2.5v2.1v0.7v3v82.1c0.5,0.3,1.1,0.6,2,0.2c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1
		c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2
		c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0
		c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8
		c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3
		c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0
		c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6
		c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3
		c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2c0.4,0.2,0.7,0.4,1,0.3s0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.3
		c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5
		c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9
		c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2
		c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.7-0.4,1-0.7
		c0.3-0.3,0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1
		c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.2,0.1,0.5,0.1,0.7,0.1
		c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8c0.2,0.8,0.7,1.7,0.4,2.7c-2.6,0.2-3.6,0.7-3.9,2.1c-0.2,0.8,0.1,1.4,0.8,1.9
		c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5
		c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1
		c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3
		c0.3,0.2,0.6,0.3,0.9,0.5c0.8,0.3,1.6,0.5,2.7,0.3c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7
		c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4s2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2
		c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1
		c0.5-0.2,0.9-0.3,1.3-0.5c1.7-0.7,2.4-2.2,1.7-3.6c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0
		c0.3,0.3,0.7,0.6,1,1c0.5-0.5,1-1,1.6-1.5c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7
		c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0
		c0.2-0.7,0.4-1.4,0.4-2c0-0.3,0-0.6,0-0.9s-0.1-0.7-0.1-1c0.2-0.3,0.4-0.6,0.6-0.9s0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8
		c0.3,0.4,0.7,0.8,1.1,1.2l0,0c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8c2.4,0.8,5,0.3,7.5-1.1
		l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3
		c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6s0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0
		c-0.2-0.1-0.4-0.3-0.6-0.4s-0.5-0.3-0.7-0.4c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0
		c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1
		c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5
		c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9
		c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2
		c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.5,0.5,0.9,0.7s0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3
		c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2
		c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3
		c-0.2,0.7-0.3,1.5-0.6,2.5c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3
		c1.1,0.3,2.6-0.1,3.4-0.9c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2c0.5-0.6,1.1-1.2,1.3-1.8
		c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7c-0.1,0.4-0.2,0.8-0.3,1.2
		c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2
		c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1c0.3-0.3,0.7-0.5,1.1-0.8
		c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1
		c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.8-0.1,1.5-0.1,2.2-0.2c-0.2-0.4-0.5-0.7-0.8-1.2c0.8-0.3,1.5-0.7,2.2-0.9
		c-0.5-0.2-1-0.3-1.4-0.6c-0.4-0.3-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3
		c0.1-0.1,0.1-0.4-0.1-0.5C128.2,292,127.9,291.8,127.6,291.6z M61.2,173.3L61.2,173.3L61.2,173.3L61.2,173.3z M60.4,182.2
		c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.6-0.6,1-0.8,1.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.4l0,0
		C59.9,182.4,60.2,182.3,60.4,182.2z M34.7,184.4C34.7,184.4,34.7,184.3,34.7,184.4L34.7,184.4C34.8,184.4,34.8,184.4,34.7,184.4z
M7.4,189.8L7.4,189.8l0.1-0.1L7.4,189.8z M41.6,291.2c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1
		C43.1,290.8,43,291,41.6,291.2z M102.9,293c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2
		c-0.3,0.3-0.7,0.5-1.2,0.7c0.1-0.3,0.2-0.6,0.3-0.9c0.2-0.5,0.3-1,0.5-1.5c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0
		C101.6,291.7,102.1,292,102.9,293c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1C103.1,292.8,103,292.9,102.9,293z"
      />
      <path
        class="st3"
        d="M203,259.3l0.1,0.1l0.1-0.1C203.1,259.3,203,259.3,203,259.3z"
      />
      <path
        class="st3"
        d="M90,207.2c-0.3-0.2-0.5-0.5-0.8-0.7c-0.1,0.1-0.4,0.4-0.3,0.4c0.2,0.3,0.4,0.6,0.6,0.8
		C89.7,207.5,89.9,207.3,90,207.2z"
      />
      <path
        class="st3"
        d="M91.5,229.3c0.8,1.8,1.3,2.9,2,4.3c1.1-1,1.8-1.7,3-2.8C94.6,230.2,93.4,229.9,91.5,229.3z"
      />
      <path
        class="st3"
        d="M97,208.6c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.1,0.2,0.2,0.2
		C96.9,209,96.9,208.8,97,208.6z"
      />
      <path
        class="st3"
        d="M163.2,117.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.2c0,0.3,0,0.6,0,0.9
		C162.8,117.5,163,117.3,163.2,117.2z"
      />
      <path
        class="st3"
        d="M247.2,120.6c0,0.3,0,0.7,0,1c0.1,0.1,0.3,0.1,0.5,0.2c0.2-0.1,0.4-0.2,0.4-0.4c-0.2-0.3-0.3-0.6-0.5-1
		C247.5,120.5,247.4,120.6,247.2,120.6z"
      />
      <path
        class="st3"
        d="M164.4,120.6c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.3,0-0.6,0.1-0.9,0.1
		c0.3,9.1,0.6,18.3,0.8,27.4c0.1,5.1,0.2,10.2,0.3,15.3c0,1-0.3,2.3,1.9,2.3c0.1-14-0.2-27.9-0.4-41.8
		C165,121.2,164.4,120.9,164.4,120.6z"
      />
      <path
        class="st3"
        d="M192.4,129.2c-0.4-1.6-0.4-1.9,1.1-5.7c-0.1,0-0.2,0-0.4,0c-0.2,0.1-0.4,0.2-0.4,0.3c-0.2,0.5-0.2,1-0.4,1.5
		s-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6c-0.1,0.1-0.2,0.1-0.3,0.2
		c0,1.3,0,2.7,0,4.1c1.9,0.1,3.5,0.2,5.1,0.3c0.5-3.1,0.5-7,0.1-9.7c-0.3,0.2-0.6,0.5-0.8,0.9s-0.3,0.9-0.5,1.3
		C193.2,128.1,192.8,128.5,192.4,129.2z"
      />
      <path
        class="st3"
        d="M371.2,192.3c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2,0-0.2,0C371.2,192.2,371.2,192.3,371.2,192.3z"
      />
      <path
        class="st3"
        d="M176.1,133.6c0.9,0,1.6,0,2.3,0c0-0.9,0-1.7,0-2.5c-0.3,0.3-0.6,0.5-0.9,0.7c-0.5,0.3-0.9,0.6-1.3,1
		C176.1,133.1,176.1,133.4,176.1,133.6z"
      />
      <path
        class="st3"
        d="M170.3,120.1c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.2-0.2-0.5c-0.3,0.2-0.5,0.4-0.8,0.6c0,0.3,0,0.6,0,1
		c0.6,0,1.2,0,1.8,0C170.8,120.8,170.7,120.5,170.3,120.1z M169.7,120.8l-0.3-0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.1,0.3-0.1
		c0,0.1,0.1,0.2,0.1,0.2C169.9,120.6,169.8,120.7,169.7,120.8z"
      />
      <path
        class="st3"
        d="M169.9,126.6c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1
		c0.1-0.5,0.2-0.9,0.7-1.3c-0.1-0.3,0-0.7,0.1-1c-0.5,0-1,0-1.5,0c0,3.7,0,7.2,0,11c2,0.1,3.8,0.2,5.8,0.4c0.1-0.4,0.1-0.7,0.2-1.1
		l0,0l0,0c0.2-1.2,0.2-2.3,0.1-3.4c-0.3,0-0.6,0-0.9,0c0.1-0.2,0.1-0.4,0.2-0.5c0.2-0.1,0.5-0.2,0.7-0.3c0-0.1,0-0.2,0-0.3
		c-0.3-0.1-0.5-0.3-0.9-0.5c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9c-0.3-0.1-0.6-0.2-1.2-0.3
		c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.3,0.3-0.6,0.7-1c0-0.1,0-0.1,0-0.2
		c-0.9,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2C170.8,126.4,170.4,126.5,169.9,126.6z"
      />
      <path
        class="st3"
        d="M246.1,128c0-0.1,0-0.2,0-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.2,0,0.3,0C246.1,129.2,246.1,128.6,246.1,128z"
      />
      <path
        class="st3"
        d="M231.5,118.8c0-0.1,0.1-0.2,0.1-0.3c0.4-0.1,0.9-0.2,1.5-0.3l0,0c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6
		c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.1,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4-0.1-0.6c-1.7-0.1-3.4-0.2-5.2-0.3
		C231.6,115,231.5,116.9,231.5,118.8z"
      />
      <path
        class="st3"
        d="M222.9,116.3c-0.7,0.4-1.3,0.9-1.7,1.5l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6
		c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2s-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1
		c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.5,0.2-0.9,0.6-1.4,0.8c0,1.7,0,3.4,0,5.1c2,0,3.7,0,5.7,0
		C222.9,121.2,222.9,118.8,222.9,116.3z"
      />
      <path
        class="st3"
        d="M216,123.7c0-1.7,0-3.3,0-4.9h-0.1v-0.1c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1l0,0c0,2.2,0,4.3,0.3,6.5
		C212.3,123.5,214.1,123.6,216,123.7z"
      />
      <path
        class="st3"
        d="M236,111.8c-1,0-2,0-3,0c0,0.1-0.1,0.1-0.1,0.2c1.1,0,2.2,0,3.3,0C236.1,112,236,111.9,236,111.8z"
      />
      <path
        class="st3"
        d="M229.5,111.8c-0.2,0-0.5,0-0.7,0c-0.1,0.1-0.2,0.2-0.3,0.3c0.3,0,0.6,0,0.9,0
		C229.4,111.9,229.5,111.8,229.5,111.8z"
      />
      <path
        class="st3"
        d="M253.7,117.9c-0.1,0.1-0.3,0.2-0.4,0.2c0,0.2,0,0.3,0.1,0.5C253.4,118.3,253.5,118.1,253.7,117.9z"
      />
      <path
        class="st3"
        d="M238,124.5c0-0.4,0-0.8,0-1.2c-0.8,0-1.6,0.3-2.4,0.5c-0.1,0.2-0.2,0.5-0.4,0.7
		C236.1,124.5,237.1,124.5,238,124.5z"
      />
      <path
        class="st3"
        d="M239.9,124.8c0.2-0.5-0.1-0.8-0.5-1c0,0.4,0,0.7,0,1.1C239.6,124.9,239.7,124.9,239.9,124.8L239.9,124.8z"
      />
      <path
        class="st3"
        d="M230.5,121.2h-0.1c0-0.1,0.1-0.2,0.1-0.2c0-2.7,0-5.2,0-7.9c-1,0-1.9,0-2.8,0c-0.5,0.6-1.2,1.2-2.1,1.3
		c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3c-0.2,0-0.4,0-0.6,0
		c-0.4,0-0.7,0-1,0c-0.6,0-1.1,0-1.7,0.2c0,2.6,0,5.2,0,8c2.2,0.2,4.2,0.4,6.4,0.6C230.5,123.4,230.5,122.3,230.5,121.2z"
      />
      <path
        class="st3"
        d="M231.6,121.6c0,1,0.1,2,0.2,3c1.1,0,2.1,0,3.1,0c-0.6-0.8-1.1-1.6-1.9-2.3
		C232.6,121.9,232.1,121.7,231.6,121.6z"
      />
      <path
        class="st3"
        d="M543.3,176.4c0.2,0.1,0.3,0.2,0.5,0.3c0.9,0.4,2,0,2.5-0.8c-1.3-0.1-2.5-0.2-3.9-0.3
		C542.7,175.9,543,176.2,543.3,176.4z"
      />
      <path
        class="st3"
        d="M610.2,56.6c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3c0.1,0.3,0.4,0.6,0.8,0.7
		c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6c-0.4,0.5-0.7,1-1.1,1.4
		c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1
		c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-1.3-0.2-1.2-1.9-2.7-2c-0.4,0-0.8-0.4-1-0.7
		c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6
		c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7
		c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2c-0.5,0-1.1,0.2-1.6,0.5
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3c-0.3-1.1-1-1.6-2.4-1.6
		c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0c-0.3,0.3-0.6,0.5-0.8,0.8c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2
		c0.2,0.3,0.5,0.5,0.8,0.7c0.9,0,1.6-0.1,2.3-0.4c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1
		c0.3,1-0.1,2.2-0.2,3.5c-2-0.7-2.8-2.5-5-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6
		c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.3-0.5-0.4-1-0.4-1.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		c-0.9-0.1-1.6-0.8-2.7-1.3c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7
		c0.1,0.1,0.2,0.3,0.4,0.4c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1
		c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.4-1.1
		c-0.3,0.3-0.5,0.4-0.8,0.8c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0,0,0,0,0-0.1
		s-0.1-0.1-0.2-0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1
		c0.3,0.1,0.6,0.2,1,0.3c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6v-0.1h-0.1
		c0,0,0,0,0,0.1c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0
		c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.2,0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3
		c0.2-0.5,0.4-0.9,0.6-1.4c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7
		c0,0,0.1,0,0.1-0.1c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1
		c0,0.4,0.5,0.9-0.1,1.2c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3
		c-0.8,0.1-1.1-0.3-1.5-0.6l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0
		c0.1-0.1,0.3-0.2,0.5-0.3c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3
		c-0.3,0.4-0.7,0.7-1,1.1c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1
		c0.5,0.5,1,1,1.5,1.5c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1
		c-0.1-0.3-0.3-0.9-1.4-0.7c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6
		c-0.3-0.4-0.6-0.3-1.6-0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3
		l0,0l0,0c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7
		c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.6-0.6-1-1.7-0.8c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1
		c-0.3,0.6-0.6,1.1-0.8,1.6c-0.1,0.2,0.1,0.7,0.3,0.8s0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4
		c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6
		c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1
		c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4
		c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1
		c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2
		c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3
		c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2
		c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.3,0.6-0.4,1.2,0.2,1.8c-0.8,0.4-1.4,0.8-2.1,1.2c0.1,0.1,0.1,0.2,0.2,0.3
		c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.3,0.8-0.6,1.3-0.8c0.9-0.4,1.5-0.9,1.8-1.8c0.8,0,1.7,0.3,2.3-0.6
		c0.7,0.5,1.4,0.9,2,1.3c0.1-0.4,0.3-0.5,0.7-0.5c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7c0.3,0.3,0.5,0.5,0.7,0.8
		c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4c-0.5-0.1-1-0.4-1.5-0.6
		c0,0.6,0,1.2,0,2.2c-0.6-0.6-0.9-0.8-1.1-1.1c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.5,0,1.2-1,1.3c-0.2-0.3-0.4-0.5-0.6-0.8
		c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1
		c-0.6-0.3-0.6-0.8-0.2-1.3c-1-1.1-2.6-0.8-4-0.9c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4
		c0.1-0.2,0.2-0.4,0.4-0.5c-0.3-0.1-0.6-0.3-0.8-0.5c-0.7-0.6-0.7-1.6-0.9-2.6c-1.1,0-2.6,0.8-2.7-1c-0.4,0.4-0.6,0.6-1,0.8
		c-0.2-0.2-0.4-0.4-0.6-0.6c-2,0.6-2.1,0.6-3.4,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3
		c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2
		c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4c0.2,0.3,0.4,0.6,0.6,0.9c0.5,0.8,1.1,1.5,1.6,2.2c0.8-0.2,0.8-1,1.2-1.4
		c0.1-0.2,0.3-0.3,0.7-0.2c0.5,0.5,0.6,1,0.7,1.6v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8
		c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0
		c-0.6,0-1.3,0.1-1.7,0.5c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.5-0.1-1-0.3-1.5-0.5c-0.3-0.1-0.6-0.2-0.8-0.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-1,0.1-1.4,0.2c-0.9,0.2-1.7,0.3-2.6-0.4
		c1.2-0.4,2.4-0.9,2.8-1.9c0.2-0.5,0.2-1.2,0.1-1.6c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1
		c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1
		c1.3,0.6,2.5,1.1,4,0.4c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0
		c2-0.1,3.3-1.1,4.3-2.6c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4
		c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7
		c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0
		c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4
		c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9
		c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3
		c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4
		c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1
		c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1
		c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,0.3-1,0.6-1.5,0.8
		c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9
		l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0
		c0.2,0.1,0.5,0.1,0.6,0.2c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6
		s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6c-0.4-1.6-0.4-1.8,1.2-6c-0.4,0.3-0.8,0.4-0.9,0.6
		c-0.2,0.5-0.2,1-0.4,1.5c-0.2,0.5-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6
		c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0
		c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1
		c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2
		c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5
		c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9
		c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3
		c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.3-0.2-0.5c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6
		c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1
		c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1
		c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2
		c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2
		c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5c-0.8-0.4-1.5-0.7-2.4-1.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0
		c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4
		c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1
		c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1
		c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9
		c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1
		c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9
		c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2s-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4
		c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6c0.5,0.1,0.6,0.3,0.6,0.6s-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9
		c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2
		c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2
		c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1
		c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2c0,0.3,0,0.6,0,1c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3
		c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3
		c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4
		c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5s0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.8,0.7,1.3
		c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2
		c0,0.2-0.2,0.4-0.3,0.5c-0.6-0.2-1.1-0.4-1.8-0.7c-0.3-0.4,0.4-1.3-0.4-1.8c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4
		c0.1,0.4,0.2,0.9,0.5,1.8c2,0,3.9-0.7,5.9-0.3c0.5,1.1,0.5,1.1-1.3,2.3c0.5,0.2,0.9,0.4,1.3,0.6c-0.3,1.4-1.6,0-2.2,0.9
		c0.3,0.2,0.7,0.4,1,0.6c-0.5,0.5-1,1.1-1.6,1.7c-0.5,0.1-1.1,0.1-2.2,0.2c0.5-0.5,0.7-0.7,1-0.9c0.3-0.1,0.7-0.1,0.9-0.3
		c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-1.3-1.3-1.3-1.3-2.9-0.6c0-0.1,0-0.2,0-0.3
		c0-0.1,0-0.2,0-0.4c0-0.2,0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1
		c-0.1-0.5-0.3-1-0.4-1.5c0.7-0.5,1.1-1,0.8-1.8c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5
		c0.1-0.1-0.3-0.7-0.6-1.2h-0.1c-0.4-0.1-1,0.8-1.5,0.2c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3
		c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4
		c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1c-0.6,0.2-1.4,1.4-1.8,2.4c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.2,0,0.5,0,0.6
		c0.7,1.4,1.1,2.8,2.4,3.9c0.5,0.4,0.7,1,1,1.5c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4
		c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8
		c-0.3-0.2-0.7-0.4-1-0.7c-0.7,0.7-1.3,1.3-2,1.9c-1.3-0.3-2.6-0.5-2.7-2c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5
		s-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2
		c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.4,0.1-0.7,0.1-1.1
		c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7
		c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3
		c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1
		c-0.1-0.4-0.4-0.8-1-1.1c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c-0.1,2-0.1,4-0.2,6.1c-1.2,0.4-2.2,1.1-2.2,2.3
		c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6
		c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2c0,1.1-0.1,2.1-0.3,3.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8
		c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4
		c-0.8,0.2-1.3,0.7-1.3,1.2c0,0.1,0,0.1,0,0.2c0,0.5-0.1,1-0.2,1.4c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0.1,0.4,0.2,0.7
		c-1.2,0-2.5-1-3.5,0.5c-0.3-0.1-0.7-0.2-1-0.2s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2s-0.5,0.3-0.7,0.6c-0.1,0.1-0.1,0.1-0.1,0.2
		c-0.5,0.6-0.3,1.2,0.4,2c-0.3,0.9-0.7,1.7-0.6,2.5c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1
		c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3c-0.2,0-0.3,0-0.5,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8
		c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.2,0.3-0.3,0.4c0,0.1,0.1,0.1,0.1,0.2l0,0c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.5,0.4c-0.1,0-0.2,0-0.2,0
		c-0.1,0.2-0.3,0.5-0.5,0.7c0.4,0.2,0.9,0.3,1.3,0.4c-0.1,0.2-0.2,0.4-0.3,0.6c0.6,0,1.2,0,2,0c-1.3,0.8-2.4,1.4-3.4,2.1
		c0,0.2,0.1,0.4,0.1,0.7c1.1,0.1,2.3,0.2,3.4,0.2c20.2,0.5,40.4,1,60.6,1.6c23.1,0.6,46.3,1.3,69.4,2c3.2,0.1,6.5-0.3,9.5,1.5
		c0.3,0.2,0.9,0.1,1.3,0.1c7.1,0.2,14.1,0.4,21.2,0.6c0.5,0,1-0.1,1.8-0.2c0.1-1.8,0.2-3.5,0.2-5.2c0.2-4.1,0.4-4.4,4.6-5.3
		c-0.3-5-0.6-10.2-0.9-15.6c3.6-0.3,6.8-0.2,10.3-0.1c0,3.1,0.4,5.8-0.5,8.8c-0.7,2.2-0.5,4.6-0.7,7.2c1,0.1,1.6,0.2,2.2,0.3
		c1.3,0.1,2,0.8,2.1,2.1c0.1,1.3,0.3,2.6,0.2,3.9c-0.4,17.6-0.8,35.2-1.2,52.8c-0.1,4.9-0.2,9.8-0.3,14.6c0.1,0.1,0.2,0.1,0.4,0.2
		c-0.1,0.1-0.3,0.2-0.4,0.3c0,0.4,0,0.8,0,1.1c0.3-0.2,0.5-0.4,0.7-0.5c0.3-0.1,0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9
		c0.2,0.5,0.5,0.8,0.9,1.1s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4
		c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4
		c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2
		c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1
		c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1
		c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0
		c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6h-0.1c0,0,0,0,0,0.1
		c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5L593,175
		c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1
		c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1
		c0-0.5,0.1-0.9,0.5-1.3c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2
		c-0.3,0.3-0.5,0.6-0.7,1c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4
		c1.4,0.6,3,0.6,4.4,0.1v-8.4c-0.8-0.1-1.6-0.2-2.4-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3c0.5-1,0.6-1.9,0.3-2.6
		c-0.2-0.5-0.6-1-1.2-1.4c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1c-1.3-0.1-2.2,0.9-3.3,0.4c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6
		c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3
		c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2
		c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5
		c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6
		c-0.4-0.6-0.4-1.1-0.3-1.5c0.1-0.4,0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9h0.1V74
		V57.1c-0.5,0-1-0.1-1.4-0.4C610.6,56.6,610.4,56.5,610.2,56.6z M589.9,72.1L589.9,72.1C589.9,72,589.9,72,589.9,72.1
		C589.9,72,589.9,72.1,589.9,72.1z M572.8,57.5c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1C572.6,57.6,572.7,57.5,572.8,57.5z M556.5,63.8c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C556.5,63.6,556.5,63.8,556.5,63.8z M565.9,54.6L565.9,54.6h0.2H565.9z M567.7,70.1
		L567.7,70.1L567.7,70.1L567.7,70.1z M541.2,57.6c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1C541.1,57.7,541.1,57.6,541.2,57.6z
M457.6,62L457.6,62h0.1H457.6z M457.8,59.9c0-0.1,0-0.2,0-0.3c0.1,0,0.1,0.1,0.2,0.1C458,59.7,457.9,59.8,457.8,59.9z M398.3,99
		c0.1,0,0.3-0.1,0.4-0.1c0,0.1,0,0.2,0.1,0.2C398.6,99,398.4,99,398.3,99z M468.4,75.8l-0.1-0.1c0.1,0,0.2-0.1,0.3-0.1
		c0,0,0.1,0,0.1,0.1C468.6,75.7,468.5,75.8,468.4,75.8z M475.8,53c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1C475.6,53.2,475.7,53.1,475.8,53z M535.1,79.4C535.1,79.4,535.1,79.3,535.1,79.4
		C535.2,79.3,535.2,79.3,535.1,79.4C535.2,79.3,535.1,79.4,535.1,79.4z M542.6,70.7c0-0.2-0.1-0.4-0.1-0.5
		C542.9,70.3,543.1,70.4,542.6,70.7z M568.6,70.8c0.1-0.5,0.1-0.7,0.1-1s-0.2-0.5-0.5-1c0.7,0.1,1.2,0.2,1.6,0.3
		c-0.7,0.6,0.1,0.4,0.5,0.6C569.8,70,569.3,70.3,568.6,70.8z M600.6,170.2c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.1-0.4-0.2-0.5C600.5,170.3,600.5,170.3,600.6,170.2z M611.7,59.2c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2
		c-0.1,0.1-0.3,0.1-0.4,0.2C611.6,59.4,611.6,59.3,611.7,59.2z"
      />
      <path
        class="st3"
        d="M286.1,135.8c-0.3-0.1-0.6-0.2-0.9-0.3c0.3,0.4,0.6,0.8,0.9,1.2C286.1,136.4,286.1,136.1,286.1,135.8z"
      />
      <path
        class="st3"
        d="M530.6,177.2c0.6,0.2,0.8,0.6,0.8,1.3c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9
		c0.2-0.3,0.5-0.6,0.9-0.9c-1-0.1-2-0.1-3.1-0.2C530.6,175.5,530.6,176.4,530.6,177.2z"
      />
      <path
        class="st3"
        d="M553.8,166.6c0.1,0,0.2,0,0.3,0c1.3-0.1,1.9-0.5,2.9-2.1c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7
		s0,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1
		c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8c0.1,0,0.1,0,0.2,0c0-1.9,0.1-3.8,0.1-5.8c-0.1,0-0.2,0-0.3,0
		c0.1-0.3,0.2-0.5,0.3-0.8c0.2-16.1,0.5-32.2,0.7-48.3c-2.5,0-4.6,0-6.8,0C554.8,117.8,554.1,143.6,553.8,166.6z M560.8,168.3
		L560.8,168.3L560.8,168.3C560.8,168.2,560.8,168.3,560.8,168.3z M560.9,166L560.9,166c0,0.1,0,0.1-0.1,0.1c0,0,0,0-0.1-0.1
		C560.8,166,560.8,165.9,560.9,166z"
      />
      <path
        class="st3"
        d="M540.3,168.4c1.1,0.7,0.8,1.6,0.3,2.8c-0.1,0-0.2,0.1-0.3,0.1c0,0.9,0,1.9,0,2.8c2.1,0.2,4.1,0.4,6.4,0.6
		c0-0.5-0.2-1-0.7-1.3c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7c-0.2-0.3-0.5-0.6-0.7-0.9
		c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8c0.7-0.5,1.6-0.9,2.3-1.3c0-0.4-0.1-0.8,0.1-1
		c0.1-0.2,0.6-0.1,0.9-0.2c0.4-0.1,0.8-0.2,1.2-0.3c0-1.2,0-2.5,0-3.7c-0.3,0-0.5,0.2-0.6,0.5c-0.2,0.5-0.2,1.1-0.3,1.7
		c-0.9,0.2-1.7,0.4-2.9,0.6c0.9-0.9,1.5-1.5,2.1-2.1c0.4-0.7,1-1,1.7-1.3c0-0.8,0-1.6,0-2.4c-2.4-0.2-4.8-0.3-7.3-0.5
		C540.3,162.5,540.3,165.5,540.3,168.4z"
      />
      <path
        class="st3"
        d="M537.7,171.5c-0.1,0.3-0.3,0.8,0.4,0.5c0,0.2-0.1,0.5-0.1,0.7c0.1,0.5,0.2,0.8,0.3,1.2c0.2,0,0.4,0,0.6,0
		c0-0.8,0-1.5,0-2.2c-0.2,0.1-0.5,0.2-0.7,0.3C538.2,171.7,538.2,171.4,537.7,171.5z"
      />
      <path
        class="st3"
        d="M530.9,173.4c1.8,0.1,3.5,0.2,5.3,0.3c0-0.8,0-1.5,0-2.3c0.5,0,1.1,0,1.6,0c-0.5-0.4,0.8-0.9,0.1-1.3
		c0.4-0.4,0.7-0.8,1.1-1.3c0.1,0,0.1,0,0.2,0c0-0.8,0-1.7,0-2.5c0-2.3,0.3-4.7-0.2-7.1c-2.7-0.2-5.1-0.3-7.9-0.5
		C530.9,163.8,530.9,168.4,530.9,173.4z"
      />
      <path
        class="st3"
        d="M239.5,136.4c0,0.6,0,1.2,0,1.8c2.3,0.1,4.4,0.2,6.7,0.3c0-0.6,0-1.2,0-1.8c-1,0.2-2,0.5-2.1-1
		c-0.4,0.4-0.6,0.6-1,0.8c-0.2-0.2-0.4-0.4-0.6-0.6C240.7,136.4,240.4,136.5,239.5,136.4z"
      />
      <path
        class="st3"
        d="M254.1,151.1c0-3,0-5.9,0-8.9c-0.6,0.3-1.2,0.6-1.9,0.9c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1
		c-0.6-0.3-0.6-0.8-0.2-1.3c-1-1.1-2.6-0.8-4-0.9c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4
		c0.1-0.2,0.2-0.4,0.4-0.5c0,0,0,0-0.1,0c-0.3,0-0.7,0-1-0.1c0,3.9,0,7.4,0,11.2C249.6,150.7,251.8,151.6,254.1,151.1z"
      />
      <path
        class="st3"
        d="M240.1,271.7c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4c-0.5-0.2-0.4-1.1-1.4-0.7
		c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.1-0.1,0.2-0.2,0.3-0.3c-9.5-2-19.1-3.9-28.6-5.9c-0.3,0.2-0.6,0.3-0.9,0.5c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5
		c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5
		c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5c0.2,0.1,0.3,0.3,0.4,0.5c0.7,0.7,1.1,0.7,2,0.1c0.5-0.4,0.9-0.6,1.7-0.8
		c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7
		c-0.2,0.4,1.2,0.1,0.5,0.8c0.7,0.1,0.8,0.6,1,1.1c0.1,0.3,0.3,0.6,0.7,0.6c1.1,0,0.8-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4
		c0.1,0.2,0.3,0.3,0.4,0.5c0.6-0.3,1.1-0.5,1.6-0.7c0,0,0,0,0-0.1c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.2,0.7-0.4,1.3-0.6
		c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9
		c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1
		c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1c0.2-0.1,0.7-0.5,0.9-0.5c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6c0.2,0.2,0.7,0.1,1.2,0.1
		C241.6,272.7,241.3,271.9,240.1,271.7z M211.4,262.1c0.3-0.3,0.5-0.6,0.7-0.9C212.5,262,212.5,262,211.4,262.1z M221,268
		c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.2,0.4-0.3,0.5-0.5c0.1,0.1,0.2,0.1,0.2,0.2C221.4,267.7,221.2,267.8,221,268z"
      />
      <path
        class="st3"
        d="M255.6,136.5c0.3,0.2,0.7,0.4,1,0.6c-0.3-0.7-0.5-1.5-0.8-2.2c-0.2,0.8-0.4,1.3-0.5,1.8
		C255.5,136.7,255.6,136.6,255.6,136.5z"
      />
      <path
        class="st3"
        d="M248,124.3c0.3,0.2,0.4,0.5,0.4,0.9c0.5,0,0.9,0,1.6,0c-0.4-0.8-0.8-1.6-1.1-2.3
		C248.6,123.3,248.3,123.8,248,124.3z"
      />
      <path
        class="st3"
        d="M250.5,126.6c-0.6,0-1.2,0-1.9,0c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.4,0.4-0.8,0.6c0,0.6,0,1.2,0,1.9
		c1.1,0.5,1.9-0.7,3-0.7c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2
		c-0.3,0.2,0,0.8-0.9,0.6c-0.1,0-0.3,0-0.4,0.1c0,0.7,0,1.4,0,2c0.1,0.1,0.2,0.2,0.3,0.3c-0.1,0.3-0.2,0.6-0.3,0.9
		c0,0.2,0,0.4,0,0.6l0,0c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2
		c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.3,0.6-0.4,1.2,0.2,1.8c-0.7,0.4-1.3,0.7-1.9,1.1c0.5,0,1.1,0.1,1.6,0.1l0,0
		c0.9-0.4,1.5-0.9,1.8-1.8c0.3,0,0.6,0,0.9,0C254.8,133,253,129.7,250.5,126.6z M250.3,131.1c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C250.4,130.9,250.3,131.1,250.3,131.1z"
      />
      <path
        class="st3"
        d="M248.4,122.6c0.1,0,0.2,0,0.3,0.1c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1,0.1-0.3,0.2-0.4,0.3
		C248.2,122.5,248.3,122.5,248.4,122.6z"
      />
      <path
        class="st3"
        d="M258.7,141.9c-0.6-1.2-1.4-1.8-2.6-1.6c0.1,0.4-0.1,0.9-0.8,1.1c0,3.3,0,6.5,0,9.9c2.2,0.3,4.3,0.5,6.7,0.7
		c0.4-2.7,0.4-4.7-1.1-6.6C260,144.4,259.3,143.1,258.7,141.9z"
      />
      <path
        class="st3"
        d="M230.1,141.2c0.3,0.4,0.5,0.7,0.8,1.1c0-0.9-0.1-1.7-0.1-2.6c-0.4,0.2-0.9,0.4-1.3,0.7
		C229.7,140.7,229.9,141,230.1,141.2z"
      />
      <path
        class="st3"
        d="M238.2,138c0-0.2,0-0.4,0-0.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-1-0.2-1.8,0.1c0.9,0.1,1.7,0.1,2.6,0.2c0-0.1-0.1-0.3-0.1-0.4
		c0.4,0.1,0.6,0.2,0.3,0.4C237.1,137.9,237.7,138,238.2,138z"
      />
      <path
        class="st3"
        d="M224.4,132.1c0.6-0.3,1.2-0.7,1.6-1.2l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0
		c0.2,0,0.4-0.1,0.5-0.1c0-0.9,0-1.8,0-2.7c-2.2,0-4.1,0-6.2,0C224.4,127.6,224.4,129.8,224.4,132.1z"
      />
      <path
        class="st3"
        d="M217.3,136.7c0.8,0.1,1.6,0.1,2.4,0.2c0-0.2,0-0.5,0.3-0.7c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2
		c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1c0.9,0.4,1.9,0.8,2.9,0.7c0-2.6,0-5,0-7.6c-2,0-3.7,0-5.7,0
		C217.3,128.8,217.3,132.5,217.3,136.7z"
      />
      <path
        class="st3"
        d="M231.8,127.7c1.1-0.4,1.9-1.2,2.5-2.1c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.1,0,0.2,0,0.3,0
		c0,0,0,0,0-0.1c-2.2-0.2-4.1-0.4-5.9-0.6C232.1,126,231.9,126.8,231.8,127.7z"
      />
      <path
        class="st3"
        d="M239.5,126.1C239.5,126.2,239.5,126.2,239.5,126.1c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.1,0-0.2,0
		C239.5,125.9,239.5,126,239.5,126.1z"
      />
      <path
        class="st3"
        d="M233.7,139c-0.1,0-0.2,0-0.3,0c-0.5,0-1,0.1-1.4,0.3c0,1.4,0,2.8,0,4.1c0.6-0.3,0.7-0.9,1-1.3
		c0.1-0.2,0.3-0.3,0.7-0.2c0.5,0.5,0.6,1,0.7,1.6v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8
		c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0
		c-0.2,0-0.4,0-0.6,0.1c0,1.2,0,2.5,0,3.7c2.2,0.2,4.2,0.4,6.4,0.6c0-3.8,0-7.3,0-11c-1.6-0.1-3.1-0.3-4.6-0.4
		C233.7,138.7,233.7,138.8,233.7,139z"
      />
      <path
        class="st3"
        d="M230.8,146.2c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.5-0.1-1-0.3-1.5-0.5c-0.3-0.1-0.6-0.2-0.8-0.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.2,0-0.4,0-0.6,0c0,2,0,3.9,0,5.9
		c2.1,0.2,4.1,0.4,6.5,0.6c0-1.2,0-2.3,0-3.4C230.8,146.1,230.8,146.2,230.8,146.2z M229,146.7C229,146.7,229,146.6,229,146.7
		C229,146.6,229,146.6,229,146.7C229,146.6,229,146.7,229,146.7z"
      />
      <path
        class="st3"
        d="M220.2,137.7h-0.1l0,0c-0.9-0.1-1.7-0.1-2.6-0.2c0,3.8,0,7.1,0,10.8c2,0.1,3.9,0.3,5.7,0.4c0-2,0-3.8,0-5.6
		c-0.7,0.1-1.4,0.1-2.1-0.5c0.8-0.2,1.5-0.5,2.1-1c0-1.2,0-2.3,0-3.5l0,0c-0.2-0.1-0.4-0.1-0.6-0.2
		C221.7,137.8,220.9,137.8,220.2,137.7z"
      />
      <path
        class="st3"
        d="M240.9,119.2c0.2,0.1,0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4
		c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.5,0-1,0-1.4
		c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.6-0.6-1-1.7-0.8c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4
		c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.6-0.6,1.1-0.8,1.6C240.6,118.6,240.7,119.1,240.9,119.2z"
      />
      <path
        class="st3"
        d="M509,189.4C509,189.5,509,189.5,509,189.4C509,189.5,509,189.5,509,189.4c0.3,0.1,0.5,0.1,0.8,0.1
		c0,0,0-0.1-0.1-0.1C509.4,189.4,509.2,189.4,509,189.4z"
      />
      <path
        class="st3"
        d="M501.9,164.2c0,2.2,0,4.4,0,6.9c1.6,0.1,3.1,0.2,4.6,0.3c0-0.2,0-0.4,0.1-0.5c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0
		h-0.1c0.4,0.1,0.7,0.3,0.9,0.5c0.6,0,1.2,0.1,1.8,0.1c0-4.8,0-9.4,0-14.2c-3.4-0.5-6.7-0.6-10.6-0.7
		C501.9,159.7,501.9,162,501.9,164.2z"
      />
      <path
        class="st3"
        d="M507.1,177c-0.1,0-0.2-0.1-0.2-0.1c-0.1-1.4-0.6-2.8-0.5-4.3c-1.5-0.1-3-0.2-4.5-0.3c0,0.6,0,1.1,0,1.7
		c0.1,0,0.2,0,0.3,0.1c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2c0.1,0.9,0,1.1-0.9,1.5
		c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1c0.3,0.3,0.6,0.4,0.9,0.6c0.8,0.1,1.6,0.1,2.5,0.2c0.6-0.2,1.1-0.6,1.7-1.3
		c0.1-0.1,0.2-0.2,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8c-0.5-0.5-0.4-1.1-0.2-1.7c0.2-0.6,0.4-1.1,0.6-1.7
		c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3C507.7,176.5,507.4,176.8,507.1,177z"
      />
      <path
        class="st3"
        d="M517.2,190.1c-0.4,0-0.7,0-1.1,0c0,0.1,0.1,0.1,0.1,0.2c0.3,0,0.6,0,0.9,0
		C517.1,190.2,517.1,190.1,517.2,190.1z"
      />
      <path
        class="st3"
        d="M512.2,174.2c0-0.4,0-0.7,0-1.1c-0.4,0-0.8-0.1-1.2-0.1c0,0.3,0.1,0.6,0.2,0.9
		C511.5,174,511.9,174.2,512.2,174.2z"
      />
      <path
        class="st3"
        d="M514.7,180.6c-0.6,0.2-0.8-0.2-0.9-0.6c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.6,0,1.3,0,1.9c1-0.8,1.7,0.1,2.7,0
		c-0.2-0.2-0.4-0.4-0.8-0.7c1.1-0.4,2-0.7,3.4-1.2c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1c0.6-0.3,1.2-0.6,1.7-0.9
		c0-2.3,0-4.5,0-6.8c-1.9-0.1-3.7-0.2-5.4-0.3c-0.1,0.3-0.2,0.6-0.2,1c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.7,0.4,0.3,0.7
		c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1C515.4,180.1,515,180.5,514.7,180.6z"
      />
      <path
        class="st3"
        d="M480.8,203c0.3,1.4,1.8,2.3,3.5,2.2c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4
		c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.4,0.2-0.8,0.2-1.2c-2.4-0.3-4.8-0.5-7.2-0.8C480.7,201.7,480.7,202.4,480.8,203z"
      />
      <path
        class="st3"
        d="M499,176c-0.6-0.4-0.8-0.8,0-1.2c0.5-0.3,1-0.6,1.6-0.8c0-0.6,0-1.2,0-1.8c-3.9-0.3-7.3-0.6-11-0.9
		c0,5.2,0,9.9,0,14.9c0.2,0,0.4,0,0.6,0.1c0.3-0.3,0.6-0.6,0.9-1c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2
		c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9c0.5,0.4,1,0.7,1.5,1.1c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8
		c0.5,0.1,0.8,0.2,1.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.5,0-1,0-1.5C500.2,175.5,499.8,175.6,499,176z"
      />
      <path
        class="st3"
        d="M465.1,183.7c4.9,1,7.6,1.2,10.2,0.6c0.2-0.6,0.3-1.2,0.4-1.9l0,0c0-4,0-8,0-12.3c-3.5-0.3-6.9-0.5-10.7-0.8
		C465.1,174.5,465.1,179.1,465.1,183.7z"
      />
      <path
        class="st3"
        d="M477.2,170.3c-0.1,4-0.2,7.9-0.2,11.7c0.2-0.1,0.3-0.1,0.5-0.2c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1
		c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5v0.1c3.7,0.3,7,0.6,10.8,0.9
		c0-5.4,0.4-10.1,0.1-14.9C484.4,170.9,480.9,170.6,477.2,170.3z"
      />
      <path
        class="st3"
        d="M408.5,193.4c-0.2,3.9-0.5,7.4-0.7,10.9c0.1,0.2,0.3,0.3,0.4,0.4c-0.1,0.2-0.3,0.3-0.5,0.5
		c-0.1,1-0.1,1.9,0,2.9c0.6,0.3,1.2,0.5,2.2,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.2,0.1,0.3,0.1,0.5,0.2
		c0.2,0.1,0.4,0.2,0.7,0.3c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9
		c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9c-0.3,0.2-0.6,0.4-0.8,0.6
		c-0.4,0.5-0.5,1-0.2,1.4c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3c0.1,0,0.1,0.4,0.1,0.5
		c-0.2,0.8-0.1,1.5,0.8,1.8c0.9,0.4,1.7,0,2.3-0.5c0-0.5,0-1,0.1-1.5c0.1-2.5,1.1-4.3,3.6-5.3c1.8-0.7,3.3-2,5-3
		c-0.4-2.6-0.7-4.9-1.1-7.5C424.2,195.1,416.5,194.3,408.5,193.4z"
      />
      <path
        class="st3"
        d="M450.4,198.6c-0.2-0.3-0.4-0.6-0.7-0.8c-1.2-0.1-2.4-0.2-3.6-0.3c-0.8,2.6-3.9,3.3-4.6,5.8c0.4,0,0.9,0,1.3,0
		l0,0c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,1.1-1.1,2.1-0.8c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7
		C450.6,200.8,450.9,199.6,450.4,198.6z"
      />
      <path
        class="st3"
        d="M519.7,182.4c-0.1,0.2-0.2,0.4-0.5,0.5c-0.9,0.4-1.3,1.1-1.7,1.8c-0.5,0.7-0.9,1.2-1.9,1.4
		c0.5,0.5,0.8,0.8,1.2,1.2c-0.2,0.4-0.5,0.9-0.8,1.4c1.2,0.1,2.4,0.3,3.8,0.4C519.7,186.8,519.7,184.6,519.7,182.4z"
      />
      <path
        class="st3"
        d="M291.8,241.7c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.8-0.2,1.6,0.1,2.4
		c0.8-0.7,1.7-1.4,2.7-2.1c1.5-1,3-2.1,4.5-3.2C293,241.9,292.4,241.8,291.8,241.7z"
      />
      <path
        class="st3"
        d="M382.4,205c0.7-4.6,1.3-9.2,1.9-14.1c-1.3-0.2-2.5-0.3-3.8-0.5c0,0.8,0,1.3,0,2.2c-1-0.7-1.7-1.3-2.5-1.9
		c-1.7,1-1.7,1-3.3,5.4c-0.1-1-0.2-2.1-0.3-3.6c-0.9,1.3-1.5,2.4-2.3,3.6c-0.5-1.4-0.8-2.5-1.2-3.6c0,0,0,0,0.1,0
		c-0.1-0.8-0.2-1.7-0.3-2.9c-1.8-0.2-3.9-0.4-6.1-0.7c0,1.9,0,3.5,0,5.1c-3.8,1.5-5.7,0-6.9-5.8c-22.9-2.4-46-4.9-69.5-7.4
		c0,1.5,0,2.6,0,3.6c-0.2,3.6-0.2,7.2-0.6,10.7c-0.1,1.4-1,2.8-1.4,4.2c-0.9,3-1.7,6.1-2.4,9.1c-0.8,3.3-2.5,5.5-6.2,6.3
		c-3.9,0.8-7.7,2.2-11.6,3.3c-4.5,1.3-9,2.6-13.5,3.8c-5.5,1.5-10.3,4-13.4,9.1c-0.3,0.5-0.6,1.1-0.8,1.7c0.5-0.5,0.9-0.9,1.3-1.3
		c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3c-0.6-0.5-0.9-0.8-1.2-1c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7
		c-0.7,0.2-1.5,0.3-2.5,0.5c-0.2,0.4-0.3,0.8-0.5,1.2c-0.5,1-1.1,2-2,3.7c-0.5-1.4-1-2.1-0.9-2.7c0.5-3.1,1.1-6.1,1.7-9.2
		c0.3-1.9,0.6-3.9,1-5.8c0.3-1.6,0.7-3.1,1.1-5c1.4,0.3,2.5,0.3,3.3,0.8c2.4,1.3,4.7,1.2,7.1-0.1c4.7-2.5,9.5-4.8,13.9-8.3
		c-0.7-0.3-1.2-0.8-1.7-0.8c-9.3-1.2-18.4-3.1-27.9-2.4c-2.8,0.2-5.3,0.8-7.7,2.4c-2.6,1.8-5.6,1.9-8.7,1.7
		c-0.2-2.7,1.4-4.2,3.1-5.2c3.2-2.2,5.7-5,7.8-8.1c0.3-0.4,0.8-0.7,1.5-1.4c1,0.7,2.1,1.4,3,2.2c1.6,1.5,3.4,2.3,5.6,2.1
		c3.8-0.3,7.6-0.4,11.3-1.1c4.8-0.9,9.3-0.6,13.8,1c0.4,0.1,0.8,0.2,1.6,0.4c-0.6-2.6,0.3-5-1.4-7.3c-0.6-0.8-0.3-2.5,0-3.7
		c0.8-2.8,1.8-5.5,2.9-8.6c-0.9-0.2-1.7-0.4-2.5-0.5c-18.2-1.9-36.3-3.9-54.5-5.8c-11-1.2-22-2.4-33-3.7c-3.3-0.4-6.6-1.1-9.9-1.7
		c-0.6-0.1-1.3,0-2.2,0c-0.1,1.1-0.2,2.2-0.2,3.3c0.2,18.7,0.4,37.4,0.5,56.1c0,4.9-0.3,9.8-0.6,14.6c-0.1,0.9-0.3,2-0.8,2.8
		c-1.7,2.6-1.7,4.4,0,6.9c-2.6,0-5.1,0-7.6,0c1.3-2.4,1.7-4.5-0.3-6.8c-0.9-1-1-2.8-1.2-4.3c-0.4-4.9-0.7-9.8-0.7-14.6
		c-0.3-19-0.6-38-0.9-57c-0.1-7.2-0.2-14.4-0.3-21.6c-0.3,0.3-0.8,0.4-1.4,0.6c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.5-0.3-1-0.4-1.5
		c0.7-0.5,1.1-1,0.8-1.8c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1
		c-0.4-0.1-1,0.8-1.5,0.2c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6
		c0.1,0.6,0.2,0.9,0.3,1.2c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1
		c-0.6,0.2-1.4,1.4-1.8,2.4c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.2,0,0.5,0,0.6c0.7,1.4,1.1,2.8,2.4,3.9c0.5,0.4,0.7,1,1,1.5
		c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3
		c-0.1,0.3-0.3,0.6-0.4,0.8c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8c-0.3-0.2-0.7-0.4-1-0.7c-0.7,0.7-1.3,1.3-2,1.9
		c-1.3-0.3-2.6-0.5-2.7-2c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5s-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6
		c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3
		c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8
		c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7
		c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4
		c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1c-0.1-0.4-0.4-0.8-1-1.1c0,0.3,0.1,0.6,0.1,0.8
		c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2
		c0,0.2,0,0.4,0,0.6c-0.1,2-0.1,4-0.2,6.1c-1.2,0.4-2.2,1.1-2.2,2.3c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7
		c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2
		c0,1.1-0.1,2.1-0.3,3.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1
		c-1.7-0.5-3.6-0.1-5.4-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4c-0.7,0.2-1.3,0.7-1.3,1.2c0,0.1,0,0.1,0,0.2
		c0,0.5-0.1,1-0.2,1.4c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0.1,0.4,0.2,0.7c-1.2,0-2.5-1-3.5,0.5c-0.3-0.1-0.7-0.2-1-0.2
		s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.3-0.7,0.6c-0.1,0.1-0.1,0.1-0.1,0.2c-0.5,0.6-0.3,1.2,0.4,2
		c-0.3,0.9-0.7,1.7-0.6,2.5c0,0.1,0.1,0.2,0.1,0.3s0.1,0.2,0.1,0.3s0.1,0.2,0.2,0.3c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1
		c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.2,0-0.3,0-0.5,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.2,0.3-0.2,0.5c0,0.1,0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3
		c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1c0.2,0.3,0.2,0.5,0.3,0.8
		c-0.3,0.4-0.6,0.8-1,1.2c0.2,0.1,0.4,0.3,0.7,0.5c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9
		c-0.3,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.5,0.7,0.4,1.5,0.5,2.3c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7
		c-0.9-0.3-1.5-0.3-1.9-0.1c-0.3,0.2-0.6,0.5-0.9,1.1c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-0.9,0.3
		c-0.3,0.2-0.5,0.4-0.5,0.7c-0.1,0.5-0.3,0.6-0.8,0.9c-0.7,0.4-0.8,1.1-0.5,1.9c0.1,0,0.2-0.1,0.2-0.1c0.9-0.4,1.8-0.5,2.5-0.1
		c1.6-1.2,3.1-2.5,4.6-3.7l0,0v-0.1c0,0,0,0,0.1,0c3.8-3.2,7.8-5.1,13.4-4.1c-0.5-1.3-0.6-2.2-1.1-2.9c-1.6-2.2-1-4.5-0.6-6.9
		c0.1-0.6,0.5-1.2,0.9-1.7c2-2.5,4.7-2.4,7.5-2c2.4,0.4,4.7,1.2,5.5,3.9c0.7,2.2,1.3,4.5,2,6.9c-0.3,1.8-0.7,3.8-1.1,6
		c-3.5,0.7-5.9,3.3-8.7,5.5c-1.4,1.1-1.9,2.5-2.5,4c-1,2.6-2.2,5.2-3.6,7.6c-1.2,2.2-2.8,4.1-5.3,5.1c-0.5,0.2-0.9,0.6-1.3,0.9
		c-1.6,1.4-1.4,2.6,0.7,3.1c3.4,0.8,5.5,2.7,6.4,6.1c-2.9,1.5-5.3-0.3-7.8-0.9c0.3,0.4,0.5,1,0.9,1.3c5.6,4.3,7.9,11.2,12.3,16.5
		c1.8,2.1,1.3,4.7-0.5,7.1c-5.1,6.9-10.2,13.8-15.3,20.7c-1.6,2.1-1.4,3.2,0.6,5c1.7,1.5,3.4,2.6,5.9,2.2c0.9-0.1,1.8,0.2,3.1,0.3
		c-0.8,1.9-2,2.3-3.4,2.6c-2.1,0.4-4.2,0.8-6.3,1.1c0.3,1.4,1.5,1.2,2.6,1.3c3.8,0.2,7.8-0.1,11.3,0.9c3.6,1,7.1,0.9,11.4,1.3
		c-1.2,0.2-1.6,0.3-2,0.3s-0.9,0-1.3,0c-3.3,0.4-6.5,0.5-9.8,1.4c0.2,0.2,0.4,0.4,0.6,0.6c-0.6,0.8-1.9,1.3-1.7,2.4
		c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6
		c0.2,0.1,0.3,0.1,0.5,0.2s0.4,0.2,0.7,0.3c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2
		c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3
		c0.1,0,0.1,0.4,0.1,0.5c-0.2,0.8-0.1,1.5,0.8,1.8c1,0.4,1.9-0.1,2.6-0.8c2.6,1.3,4-0.8,5.7-1.8c1,0.8,1.7,1.6,0.8,2.9
		c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.2c0.7,1.4,0.5,3,0.7,4.8c1.1-0.9,1.1-1.8,0.8-2.7c-0.4-1.1-0.9-2.2-1-3.4
		c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2c1.1-0.3,2.2-0.5,3.4-1.1c-0.4,0-0.8,0-1.3-0.1c0-0.1-0.1-0.2,0-0.2
		c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0
		c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,1.1-1.1,2.1-0.8c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7c1-0.8,1.3-2,0.8-3
		c-0.4-0.9-1.2-1.3-2.3-1.5c-0.3-0.1-0.9,0-1-0.2c-0.1-0.3-0.2-0.5-0.4-0.6c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1H138
		c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2c-0.5,0.1-0.9,0.2-1.3,0.3c-0.8-0.6-1.1-1.3-0.6-2.1c-0.3-0.3-0.6-0.5-1-0.6
		c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.3l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0c0.2-0.2,0.5-0.4,0.7-0.6
		c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9-0.2-1.5c0.9,0.2,1.5,0.5,2.2,0.5
		s1.5-0.2,2.1-0.5c0.1,0,0.3-0.1,0.3-0.1c0.2-0.2,0.2-0.3-0.3-0.5c0-0.2,0-0.4,0.1-0.8c0.1,0.1,0.3,0.1,0.4,0.2
		c0.4,0.2,0.9,0.3,1.2,0.5c0.6,0.3,1.1,0.7,1.3,1.4c-0.5,0.2-1,0.3-1.4,0.5c-0.5,0.2-0.8,0.6-0.4,1c0.3,0.4,0.2,0.6-0.1,1
		c-0.7,0.9-0.6,1.8,0.1,2.6c0.6,0.6,1.8,0.8,2.7,0.5c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2c0.5,0.1,0.9,0.3,0.7,0.8
		c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9c-0.6-0.6-0.4-1.7-1.6-2.1
		c-0.1,0.2-0.2,0.4-0.2,0.6c0.1,1.3,1.3,2.3,1.1,3.7c-0.1,0.4,0.8,0.5,1.4,0.2c0.2-0.1,0.4-0.4,0.6-0.7c0.3,0.1,0.7,0.2,1,0.4
		c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0c0.7-2.1,2.1-3,4-2.5
		c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3c-1.7,0.5-2.7,1.8-2.5,3.2
		c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6c0,0.8,0.1,1.5,0.1,2.4
		c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5
		c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1
		c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6c1.6,0.2,2.7-0.5,3.4-1.6c1.7-0.2,3.3-0.3,5-0.5c0.1,0.7,0.1,1.5,0.2,2.3
		c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3c-2.3-0.4-4.6,0.8-5.2,2.7
		c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5
		c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0
		c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.2,0-0.4c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.2-0.5-0.4-0.7
		c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0
		c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-1-1.2-1.7-1.6
		c-1.3-0.8-2.7-0.9-4.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7
		c0.1-0.5,0.3-1,0.4-1.6c0.1-0.6,0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8
		c1.6-0.4,3.1-0.7,4.6-1.1c1.3-0.4,2-1.3,2.3-2.4s-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1
		c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1
		c0.5-0.1,0.9-0.4,1.3-0.7c0.4-0.3,0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6
		c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3
		c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8
		c-0.3,0.3-0.6,0.4-0.8,0c0.7-0.8,1.9-1.1,2.5-2.1c0.5-0.8,1.2-1.6,1.5-2.5c0.4-0.8,0.4-1.7,0.7-2.7c0.2-0.1,0.3-0.1,0.5-0.2
		c0.4-0.1,0.8-0.3,1.2-0.4c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6
		c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1
		c0.5,0.3,1.1,0.5,1.8,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1
		c0,0.5,0,1,0.1,1.5c0.2,0.7,0.5,1.3,1.3,1.8c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4c-1.3,0.7-2.1,2.1-1.8,3.4
		c0.3,1.4,1.8,2.3,3.5,2.2c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3
		c0.3-0.5,0.3-1.1,0.2-1.8c-0.1-0.2-0.1-0.4-0.2-0.5c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2
		c-0.7-1-1-2,0-3.4c0.2-0.1,0.6-0.3,1-0.5c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c0.9-0.6,0.9-1.2,0.7-1.9
		c-2.1-0.4-4.1-0.8-6.2-1.3c0-0.2,0.1-0.4,0.1-0.6c1.9,0.3,3.9,0.6,5.8,1c0-0.1,0-0.1,0-0.2c0.6-0.6,1.1-1.1,1.6-1.6
		c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9
		c0.5,0.4,1,0.7,1.5,1.1c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5
		c-0.4-0.4-0.7-0.4-2,0.2c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9
		c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1
		c1.1,0.9,2.1,1.2,2.9,1c-0.5,1.3-0.3,1.8,0.5,2.1l0,0c0.8,0.3,1.3,0.5,1.7,0.7c0.8,0.2,1.7,0.3,2.5,0.5c0.1-1.1-0.2-2-1.3-2.7
		c0,0.3,0.1,0.6,0.1,0.9c0,0.1-0.3,0.3-0.5,0.5c-0.3-0.5-0.6-1.1-0.9-1.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2
		c-0.3-0.2-0.6-0.5-1-0.9c0.7-0.2,1.3-0.7,2-1.4c0.1-0.1,0.2-0.3,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8
		c-0.5-0.5-0.4-1.1-0.2-1.7c0.2-0.6,0.4-1.1,0.6-1.7c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3c-0.5,0.4-0.8,0.7-1.1,0.9
		c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-6c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3
		c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1
		c0,0.3-0.4,0.7-0.7,0.8c-0.6,0.2-0.8-0.2-0.9-0.6c-0.7,0.7-0.8,1.4-0.3,2.2c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7
		c1.1-0.4,2-0.7,3.4-1.2c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4
		c0.1,0.3,0.2,0.9,0.1,0.9c-0.7,0.2-0.6,1-1.2,1.2c-0.9,0.4-1.3,1.1-1.7,1.8c-0.5,0.7-0.9,1.2-1.9,1.4c0.5,0.5,0.8,0.8,1.2,1.2
		c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.9,0.2-1.3,1-2.3,1
		c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.3,0.2-0.4,0.2c9.3,1.9,18.7,3.8,28,5.7c0.2-0.2,0.3-0.4,0.5-0.7
		c0.4,0.3,0.7,0.5,0.8,0.7c0.1,0.1,0.2,0.2,0.2,0.2c1.6,0.3,3.2,0.7,4.9,1c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2
		c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3
		c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9c1.1-0.8,1.1-0.7,3.4,0c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4
		c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6c-0.7,0.3-1.3,0.5-1.8,0l0,0l0,0c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3
		c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c1.1,0,1.1,1,1.9,1.4c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8
		c0.6-0.2,1.1-0.8,1.2-1.3v-0.1c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4l-0.1-0.1c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9
		c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3-0.7-0.7-0.8-0.5c-0.3,0.9-1.5,0.6-2,1.2
		c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4
		c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2
		c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4
		c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1
		c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4
		c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3v-0.1c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2
		c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4
		c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9
		c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3
		c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8c-0.7,0.2-1.6,0.5-2.5,0.8c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5
		c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3
		c1,0.4,2.3,0,2.7-1.1c0.4-0.9,0.3-1.7-0.5-2.2c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7
		c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8c0.7-0.5,1.6-0.9,2.3-1.3
		c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7
		c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3
		c1.2-0.9,1.9-1.2,3.3-1.4c1.3-0.1,1.9-0.5,2.9-2.1c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9
		c0,0.1-0.1,0.2-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1
		c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8c0.3-0.2,0.6-0.5,0.9-0.7l0,0
		c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1c0,0,0.3-0.3,0.5-0.5c0.1,0.2,0.1,0.5,0.3,0.6c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3
		c0-0.2-0.4-0.3-0.6-0.5c0.1-0.3,0.2-0.7,0.3-1.1c1.3,0.2,2.5-0.1,3.3-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1c1.6,0.5,3,1.1,4.9-0.3
		c-0.2,0.8-0.3,1.3-0.4,1.8c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1.2-0.2,2.4,1.6,3.5
		c-0.4,0.3-0.8,0.6-1.1,0.8c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3
		c-1.1,0.2-1.8,0.7-2.4,1.4c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2,0,0.6,0.2,0.8l0,0
		c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.8,1.6,1.5,3.2,1.4c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4
		c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5c-0.3-0.5-1-0.8-1.6-0.7
		c-0.8,0.1-1.2,0.6-1.3,1.2c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		c-0.1,0-0.3,0.1-0.4,0.2c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6c-0.1,0.2-0.3,0.5-0.6,0.8
		c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1
		c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1c-0.4,0.3-0.7,0.6-1.1,0.9
		c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7v-0.1
		l0,0c1.4,0.5,2.5-0.2,3.6-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.1,0.7,0.3,1.1,0.4
		c0.1,0,0.2,0.1,0.4,0.1c0.8,0.3,1.6,0.3,2.4,0.1c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2
		c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9
		c0.2-0.6,0.3-1.3,0.1-2c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7c-0.3,0.3-0.6,0.5-0.8,0.7
		c-0.1,0.2-0.1,0.5-0.1,1.1c0.6-0.4,0.9-0.7,1.2-0.8c0.3-0.1,0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1
		s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3
		c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3
		c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3
		c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8
		c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2
		c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3
		c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0l0,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5
		c1,0.5,1,1.1,0.9,1.7c1.4-1.1,2.8-2.2,4.2-3.2c-0.3,0.1-0.7,0.1-1-0.1c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6
		c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3
		c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2
		c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5
		c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6
		c-0.4-0.6-0.4-1.1-0.3-1.5s0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9
		c0.1,0,0.2,0,0.3,0v1.6c0.1,0.1,0.3,0.2,0.5,0.3s0.3,0.1,0.5,0.1c0.3,0,0.7,0,1.1-0.2c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1
		c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0,0,0,0.1,0.1,0.1c0.6-5.1,7.4-7.6,11.8-4.4
		c2.9,2.1,4.4,5,3.7,8.8c-0.2,0.8-0.3,1.7-0.5,2.5c0.3,0.3,0.5,0.6,0.3,1.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2
		c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9
		c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2
		c0.4,0.2,0.7,0.4,1,0.3c0.3-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.3c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5
		c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1
		c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7
		c-0.1,0.1-0.3,0.2-0.4,0.3s-0.3,0.2-0.4,0.3s-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5
		c-0.3-0.1-0.6-0.2-1-0.2c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2
		c0.4-0.2,0.7-0.4,1-0.7s0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5
		c0.1,0,0.1-0.1,0.2-0.1h0.1c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8
		c0.2,0.1,0.5,0.1,0.7,0.1c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8c0.2,0.8,0.7,1.7,0.4,2.7c-2.6,0.2-3.6,0.7-3.9,2.1
		c-0.2,0.8,0.1,1.4,0.8,1.9c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1
		c-0.3-0.2-0.5-0.4-0.8-0.5c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3
		c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2
		c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.3,0.9,0.5c0.8,0.3,1.6,0.5,2.7,0.3c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0
		c0,0.6,0.1,1.1,0.1,1.7c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4c0.6,1.1,2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3
		c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5c1.7-0.7,2.4-2.2,1.7-3.6c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0c0.3,0.3,0.7,0.7,1,1c0.5-0.5,1-1,1.6-1.5c0.2,0.3,0.4,0.5,0.6,0.7
		c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4
		c0.2,0,0.5,0.1,0.7,0.1c0.4-1.2,0.7-2.5,0.7-3.8c0.1-1.1,0.2-2.2,0.3-3.2c0.1-3,0-6.1,0.4-9.1c0.3-2.5,1.3-5,2-7.5
		C381.4,209.9,382,207.5,382.4,205z M92.1,166.3c0.1,0,0.3-0.1,0.4-0.1c0,0.1,0,0.2,0.1,0.2C92.4,166.3,92.2,166.3,92.1,166.3z
M130.7,275.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0v0.1C130.8,275.9,130.8,275.9,130.7,275.9z M156.9,289.9c-1.1,0-2.2,0.1-3.2,0.1
		c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9C157.2,288.5,157,289.2,156.9,289.9z M163.8,257c0.4-0.5,0.7-0.3,1-0.1
		C164.5,257,164.1,257,163.8,257z M175.5,253.5l-0.2-0.1h0.3L175.5,253.5z M214,247.5L214,247.5c0-0.1,0.1-0.1,0.1-0.1
		C214.1,247.5,214,247.5,214,247.5z M243.5,232l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2C243.7,232,243.6,232,243.5,232z M254.6,235.6
		L254.6,235.6C254.6,235.6,254.6,235.5,254.6,235.6C254.6,235.5,254.6,235.6,254.6,235.6z M254.6,233.4
		C254.6,233.4,254.6,233.3,254.6,233.4c0-0.1,0-0.1,0.1-0.1l0.1,0.1C254.7,233.4,254.7,233.4,254.6,233.4z M255.7,233.1
		C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1z M258.1,234.5
		c0-0.6,0-1.1,0.1-1.8c0.7-0.5,1.2-0.3,1.5,0.3C259.1,233.6,258.6,234.1,258.1,234.5z M261.7,227.1c-1.6,0.5-2.2,1.5-2.1,2.9
		c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2c0.3-1,0.5-2,2-2.4
		c0.7-0.2,1.3-0.8,1.9-1.3c0.6-0.6,1.1-1.3,1.7-2c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.3,0.9-0.2,1.4-0.2
		C262.3,226.5,262.3,227,261.7,227.1z M294.5,237.5c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5
		C294.3,237.6,294.4,237.6,294.5,237.5z M347.8,223.9c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1
		C349.3,223.5,349.2,223.7,347.8,223.9z"
      />
      <path
        class="st3"
        d="M612,20.2c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2.2,0-4.4,2.1-3.9,4.2
		c0.1,0.3,0.2,0.6,0.4,0.8c0.6,0.9,1.5,1.4,2.7,1.5c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0v0.1c0,0.5-0.1,1-0.1,1.5
		c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1.1,0.1,2.2,1.2,2.7
		c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-0.9,0.5-1.8,0.3-2.7c1.3,0.3,2.6,0.7,4.4,0.2c-0.6,1.4-0.3,2.5,0.3,3.5
		c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.9,0.5,2.9,0.3v-4v-3.2v-4.3v-1v-1.7v-6.5V22v-1.4L612,20.2C612.1,20.1,612,20.1,612,20.2z"
      />
      <path
        class="st3"
        d="M405.9,238.5c0.1-0.6,0.1-1.2,0.1-1.8c-0.2,0.2-0.4,0.3-0.5,0.4C405,237.7,405.1,238.5,405.9,238.5
		L405.9,238.5z"
      />
      <path
        class="st3"
        d="M409.8,234.2c-0.2,0.1-0.5,0.2-0.7,0.3c0,1.4-0.1,2.7,0,4.1c0,0.5,0.1,1.1,0.2,1.6c0,0,0,0,0.1,0
		c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6c0.3,1.4,1.8,2.3,3.4,2.2l0,0c0-0.1-0.1-0.2-0.1-0.4
		c1-1,2.1-2.3,3.4-3.4c0.2-0.2,0.3-0.3,0.5-0.5c-0.5-1.5-2.1-2.3-4-1.9c-0.1,0-0.1,0-0.2,0.1c-0.4,0.1-0.7,0.2-1.1,0.3
		c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.1-0.9-0.2-1.5-0.2
		c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1c1.2,0.1,2.2-0.3,2.9-1
		c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5c-0.5,0.1-0.9,0.3-1.3,0.4
		c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6C409.5,233.2,409.7,233.7,409.8,234.2z"
      />
      <path
        class="st3"
        d="M393,254c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9l-0.1-0.1
		c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2c-1.3,1.2-1.3,1.2-0.5,2.5
		c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6
		c0.7-0.3,0.5-0.8,0.4-1.2C393.2,255,393.1,254.5,393,254z"
      />
      <path
        class="st3"
        d="M476.6,203.8c-2.4,0.6-3.5,2-3.1,4c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		s-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9C477.7,203.6,477.1,203.6,476.6,203.8z"
      />
      <path
        class="st3"
        d="M485.9,211.1c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C486.1,211.6,486,211.3,485.9,211.1z"
      />
      <path
        class="st3"
        d="M404,241.8c0.7-0.2,1.2-0.6,1.5-1.3h-0.1C404.9,240.8,404.4,241.3,404,241.8z"
      />
      <path
        class="st3"
        d="M401.8,243L401.8,243c-0.2,0.1-0.4,0.3-0.7,0.4c-0.4-0.3-0.7-0.6-1.1-0.7c-0.1,0-0.2-0.1-0.4-0.1
		c-0.6,0.1-1.1,0.4-1.7,0.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.6,0.1,1.2,0.7,1.5c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.1,0.3-0.3,0.5-0.5C406.1,243.9,404,243.9,401.8,243z"
      />
      <path
        class="st3"
        d="M454.2,270c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C457.3,270.6,455.8,269.8,454.2,270z"
      />
      <path
        class="st3"
        d="M553.7,172.1l0.1,0.1c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5
		c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7s0.5-0.8,0.4-1.6c-0.6-0.1-1.2-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0
		c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.5,0.1-0.9,0.2-1.4,0.5C553.7,170.9,553.7,171.5,553.7,172.1z"
      />
      <path
        class="st3"
        d="M539,227.6c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C537.1,229.5,538.5,228.8,539,227.6z"
      />
      <path
        class="st3"
        d="M496.4,186.9c0.1-0.5,0-1.1-0.4-1.5c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9c-0.1,0.3-0.2,0.7-0.3,1
		C492.6,186.6,494.5,186.7,496.4,186.9z"
      />
      <path
        class="st3"
        d="M532.1,227.2c-0.2-0.1-0.5-0.3-0.7-0.3c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7
		c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2
		c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4C533.4,228.9,533,227.8,532.1,227.2z"
      />
      <path
        class="st3"
        d="M397.9,240.8c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6c0.2-0.4,0.2-0.7,0.2-1.1
		c-0.2-1.2-1.6-2-3.1-1.7s-2.5,1.4-2.4,2.7C397.6,240.2,397.7,240.5,397.9,240.8z"
      />
      <path
        class="st3"
        d="M396.2,232.6c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C395.7,231.5,395.8,232.1,396.2,232.6z"
      />
      <path
        class="st3"
        d="M396.8,247c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.3-0.8-0.7-1.2-1.1-1.5
		c-0.4,0.2-0.8,0.4-1.3,0.7c-0.2,0.1-0.4,0.2-0.6,0.3c-0.5,0.5-1,1-1.4,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9
		c0.8,0.3,1.6,0.1,2.9-0.8c1.3,1,1.8,1.1,2.6,0.6C397.1,248.2,397.3,247.5,396.8,247z"
      />
      <path
        class="st3"
        d="M578,181.4c0.1,0,0.3-0.1,0.4-0.1c0.7-0.3,1.2-0.9,1.4-1.5c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5
		c-0.2-0.8-0.9-1.4-1.8-1.7C578,178.6,578,180,578,181.4z"
      />
      <path
        class="st3"
        d="M396.1,229.7C396.1,229.7,396.1,229.8,396.1,229.7C396.1,229.8,396.1,229.8,396.1,229.7
		C396.1,229.7,396.2,229.7,396.1,229.7L396.1,229.7z"
      />
      <path
        class="st3"
        d="M394.8,228.6c-0.1-0.4-0.1-0.9-0.3-1.3c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0
		c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7C395.8,228.9,395.3,228.7,394.8,228.6z"
      />
      <path
        class="st3"
        d="M555.5,197.6c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1,0-2.1-0.1-3.1-0.1c0,1.1,0,2.2,0,3.1c0.3-0.1,0.5-0.1,0.8-0.2
		C555,198.3,555.3,198.1,555.5,197.6z"
      />
      <path
        class="st3"
        d="M414.1,244.4c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3
		c0.3,1.1,1.5,1.6,2.8,1.3c1.2-0.3,1.9-1.3,1.7-2.3C414.4,244.9,414.3,244.6,414.1,244.4z"
      />
      <path
        class="st3"
        d="M555.9,215.2c0.5-0.2,1-0.4,1.5-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,0.8-1.2,0.6-1.8
		c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7C554.6,215.5,555.3,215.4,555.9,215.2z"
      />
      <path
        class="st3"
        d="M584.4,201.2c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C583.7,201.2,584.1,201.2,584.4,201.2z"
      />
      <path
        class="st3"
        d="M319.4,233.6c-0.3,0-0.6,0.1-0.9,0.3c0.7,0.1,1.4,0.3,2.1,0.5c0-0.2-0.1-0.4-0.1-0.6
		C320.1,233.6,319.8,233.6,319.4,233.6z"
      />
      <path
        class="st3"
        d="M471.1,236.5c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C473.4,236.8,472.1,236.2,471.1,236.5z"
      />
      <path
        class="st3"
        d="M601.7,187.1L601.7,187.1c0.6-0.1,1.1-0.4,1.4-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C599.9,186.8,600.8,187.3,601.7,187.1z"
      />
      <path
        class="st3"
        d="M559.9,182.7c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.6,0.3
		c0.1,0,0.2,0,0.3,0c0-1.2,0-2.4,0.1-3.5c-0.1,0.1-0.3,0.2-0.4,0.3C560.3,182.3,560.1,182.5,559.9,182.7z"
      />
      <path
        class="st3"
        d="M499,181.2c-0.4,1.7-0.2,2.1,1.4,2.3c0-1,0-2.1,0.1-3.1c-0.4,0.1-0.8,0.3-1.2,0.6
		C499.1,181,499,181.1,499,181.2z"
      />
      <path
        class="st3"
        d="M501.9,180.6L501.9,180.6c0,1.1,0,2.2,0,3.3c0.3,0.2,0.5,0.2,0.6,0.2c0.2,0,0.4-0.2,0.7-0.8
		c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.3C502.8,181.5,502.7,181,501.9,180.6z"
      />
      <path
        class="st3"
        d="M589.5,181.9c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C589.9,183,589.9,182.3,589.5,181.9z"
      />
      <path
        class="st3"
        d="M553.6,177.4l0.1-0.1c0.2-0.2,0.5-0.3,0.7-0.5s0.4-0.3,0.6-0.5c-0.3-0.7-0.5-1.5-0.8-2.1
		c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.3-0.3-0.5-0.6-0.6C553.7,174.7,553.6,176,553.6,177.4z"
      />
      <path
        class="st3"
        d="M553.5,188.1c0.3-0.1,0.6-0.1,0.9-0.2c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1
		c-0.4-0.8-0.6-1-1.1-1.2C553.5,186.7,553.5,187.4,553.5,188.1z"
      />
      <path
        class="st3"
        d="M347.4,265c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C349.5,265.2,348.5,264.8,347.4,265z"
      />
      <path
        class="st3"
        d="M342.8,271c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C344.8,271.4,343.8,270.8,342.8,271z"
      />
      <path
        class="st3"
        d="M314.6,230.8c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0,0.2,0.1,0.4,0.2,0.6
		c0.9,0,1.8,0.1,2.7,0.2c0,0,0,0,0.1,0c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C315.2,231.3,315,231,314.6,230.8z"
      />
      <path
        class="st3"
        d="M482.4,222.5c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C482.4,223,482.5,222.8,482.4,222.5L482.4,222.5z"
      />
      <path
        class="st3"
        d="M582.6,188.4c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C583,186.8,582.4,187.6,582.6,188.4z"
      />
      <path
        class="st3"
        d="M528.4,208.7c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5c0.8,0.1,1.3-0.3,1.1-1
		c-0.1-0.4-0.5-0.8-0.4-1.1c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3c-0.4-0.2-0.8-0.4-1.2-0.6
		C528.5,208.6,528.5,208.7,528.4,208.7z"
      />
      <path
        class="st3"
        d="M526.8,233.8c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C527.5,233.7,527.1,233.7,526.8,233.8z"
      />
      <path
        class="st3"
        d="M579.1,197.4c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5s-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C578.4,197,578.7,197.3,579.1,197.4z"
      />
      <path
        class="st3"
        d="M592.6,220.9c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C591.9,222.5,592.7,221.6,592.6,220.9z"
      />
      <path
        class="st3"
        d="M519.2,248c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C517.8,249,518.5,248.6,519.2,248z"
      />
      <path
        class="st3"
        d="M584.5,222.1c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C586.2,222.3,585.4,221.9,584.5,222.1z"
      />
      <path
        class="st3"
        d="M417.8,247.4c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1
		c0.5-0.1,0.9-0.4,1.1-0.8c0.1-0.3,0.1-0.6,0.2-0.8c0,0,0,0,0-0.1C419.6,247.6,418.7,247.2,417.8,247.4z"
      />
      <path
        class="st3"
        d="M517.9,249.8c-0.8,0.2-1.3,0.9-1.2,1.6c0.1,0.7,1,1.2,1.9,1s1.4-1,1.3-1.7
		C519.6,249.9,518.8,249.5,517.9,249.8z"
      />
      <path
        class="st3"
        d="M602.2,189.6c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C603.5,189.9,603,189.6,602.2,189.6z"
      />
      <path
        class="st3"
        d="M546.2,186.5c-0.5-0.5-1.3-0.6-1.9-0.1c-0.5,0.4-0.6,0.8-0.2,1.3c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5
		c0.2,0.2,0.3,0.3,0.5,0.3c0.3,0.1,0.6,0.1,0.9-0.1c0.7-0.3,0.8-0.8,0.7-1.4C546.6,187,546.5,186.7,546.2,186.5z"
      />
      <path
        class="st3"
        d="M319.1,226.5c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4c0.1,0.7,0.9,1.1,1.7,0.9
		C318.7,227.8,319.2,227.2,319.1,226.5z"
      />
      <path
        class="st3"
        d="M324,269.6C323.9,269.6,323.9,269.6,324,269.6c-0.2,0.1-0.3,0.1-0.4,0.1c-0.5,0.6-1,1.3-1.4,2
		c0,0.1,0.1,0.3,0.1,0.4h0.5h0.3c0.6-0.2,1-0.4,1.2-0.7C324.6,271,324.5,270.4,324,269.6L324,269.6z"
      />
      <path
        class="st3"
        d="M584.5,218.4c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C583.7,219.9,584.3,219.4,584.5,218.4z"
      />
      <path
        class="st3"
        d="M592.9,225.1c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7s1.1-0.8,1-1.3
		C594.3,225.3,593.5,225,592.9,225.1z"
      />
      <path
        class="st3"
        d="M518.5,238c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C519.8,238.2,519.2,237.9,518.5,238z"
      />
      <path
        class="st3"
        d="M522.5,245c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		S522.9,244.8,522.5,245z"
      />
      <path
        class="st3"
        d="M489.4,206.7c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2S490.1,206.5,489.4,206.7z"
      />
      <path
        class="st3"
        d="M589.5,198.6c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1
		C589.5,198.8,589.5,198.7,589.5,198.6z"
      />
      <path
        class="st3"
        d="M464.1,242c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C465.6,242.2,464.8,241.9,464.1,242z"
      />
      <path
        class="st3"
        d="M392.1,252.2c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C390.7,252,391.4,252.4,392.1,252.2z"
      />
      <path
        class="st3"
        d="M611.5,218.4c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C611.9,218.4,611.7,218.4,611.5,218.4z"
      />
      <path
        class="st3"
        d="M495.9,181.5c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C496.9,180.7,496.4,181.2,495.9,181.5z"
      />
      <path
        class="st3"
        d="M539.8,218.1c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C540.6,217.9,540.1,217.9,539.8,218.1z"
      />
      <path
        class="st3"
        d="M539,206.6c0.1-0.1,0.3-0.2,0.3-0.3c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.1-1.5-0.1c0.1,0.1,0.2,0.3,0.3,0.4
		C538.3,206.6,538.7,206.6,539,206.6z"
      />
      <path
        class="st3"
        d="M396.9,240.7c-0.5,0.2-0.9,0.3-1.3,0.5c-0.3,0.1-0.5,0.2-0.8,0.4c0,0-0.1,0-0.1,0.1c0.7,0,1.3,0.1,2,0.1
		C396.9,241.5,397,241.2,396.9,240.7z"
      />
      <path
        class="st3"
        d="M474,233.8c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C473.3,234.7,473.7,234.3,474,233.8z"
      />
      <path
        class="st3"
        d="M554.9,253.9c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C554.9,252.9,554.7,253.1,554.9,253.9z"
      />
      <path
        class="st3"
        d="M535.4,206.5c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0-0.3,0C535.3,206.3,535.3,206.4,535.4,206.5z"
      />
      <path
        class="st3"
        d="M509.6,176c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C508.3,175.8,508.3,175.8,509.6,176z"
      />
      <path
        class="st3"
        d="M380.8,259.6c1-0.6,1.8-1.1,2.7-1.6C381.9,257.4,381.3,257.7,380.8,259.6z"
      />
      <path
        class="st3"
        d="M522,227.6c0,0.5,0.5,0.8,1.1,0.7s0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8C522.3,226.8,522,227.1,522,227.6z"
      />
      <path
        class="st3"
        d="M523.9,211c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C524.4,212,524.4,211.4,523.9,211z"
      />
      <path
        class="st3"
        d="M557.8,215.9c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C557.9,215.8,557.9,215.8,557.8,215.9z"
      />
      <path
        class="st3"
        d="M538.3,230.9c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C539.4,231.5,538.9,231.3,538.3,230.9z"
      />
      <path
        class="st3"
        d="M533.7,206.2c-0.4,0-0.8,0-1.2,0c-0.2,0-0.3,0-0.5,0c0.4,0.1,0.8,0.3,1.3,0.5
		C533.5,206.5,533.7,206.3,533.7,206.2z"
      />
      <path
        class="st3"
        d="M539.7,212.5c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C540.8,212.2,540.3,212.3,539.7,212.5z"
      />
      <path
        class="st3"
        d="M421.6,243.9c0.2-0.2,0.3-0.5,0.3-0.9c-0.2,0.2-0.4,0.4-0.4,0.6C421.5,243.6,421.5,243.8,421.6,243.9z"
      />
      <path
        class="st3"
        d="M336.2,235.6c-0.1,0.3-0.1,0.7-0.2,1c0.4-0.2,0.5-0.5,0.4-0.8C336.4,235.7,336.3,235.7,336.2,235.6z"
      />
      <path
        class="st3"
        d="M459,236.8c-0.3,0.2-0.7,0.6-0.6,0.8s0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C460,236.9,459.4,236.6,459,236.8z"
      />
      <path
        class="st3"
        d="M593.4,208.5c0.6,0.6,0.6,1.5,2.1,1.2C594.8,208.3,594.8,208.3,593.4,208.5z"
      />
      <path
        class="st3"
        d="M380.6,249.7c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C380.5,249.8,380.6,249.8,380.6,249.7z"
      />
      <path
        class="st3"
        d="M526.5,205.8c0,0.2,0.1,0.4,0.4,0.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2c0.1-0.3,0.2-0.5,0.2-0.7
		C527.2,205.9,526.9,205.8,526.5,205.8z"
      />
      <path
        class="st3"
        d="M541.6,214.8c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C542.7,215.8,542.3,215.3,541.6,214.8z"
      />
      <path
        class="st3"
        d="M539.4,212.1C539.4,212.1,539.5,212.1,539.4,212.1c0.2,0,0.3-0.4,0.2-0.5c-0.3-0.4-0.7-0.7-1.3-1.2
		c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.6,0.2,0.9,0.5,1.2C538.8,212.2,539.2,212.1,539.4,212.1z"
      />
      <path
        class="st3"
        d="M546.6,196c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C547.3,196.9,546.1,196.5,546.6,196z"
      />
      <path
        class="st3"
        d="M511.1,186.2c0.1,0,0.3,0,0.4-0.1c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		C510.5,185.9,510.6,186.2,511.1,186.2z"
      />
      <path
        class="st3"
        d="M555.3,167.5c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C556.1,167.8,555.8,167.7,555.3,167.5z"
      />
      <path
        class="st3"
        d="M384.8,264.2c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C385.5,264.4,385.1,264.3,384.8,264.2z"
      />
      <path
        class="st3"
        d="M611.2,162.9c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C612,163,611.7,162.7,611.2,162.9z"
      />
      <path
        class="st3"
        d="M514,183.5c-0.1,0-0.3-0.1-0.4-0.1c0,0.2,0,0.4,0,0.5C513.7,183.8,513.8,183.7,514,183.5z"
      />
      <path
        class="st3"
        d="M385.3,258.4c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C384.9,258.8,385.3,258.6,385.3,258.4z"
      />
      <path
        class="st3"
        d="M558.2,174c-0.8,1-1.3,1.7-1.2,2.5C557.5,175.9,558.4,175.4,558.2,174z"
      />
      <path
        class="st3"
        d="M533.3,212.6c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C534,212.9,533.6,212.7,533.3,212.6z"
      />
      <path
        class="st3"
        d="M538.5,179l-0.1,0.1h0.1C538.5,179.1,538.5,179.1,538.5,179z"
      />
      <path
        class="st3"
        d="M540,178.1c0,0.2,0,0.5,0,0.7l0,0c0.1-0.2,0.1-0.4,0.2-0.6C540.2,178.2,540.1,178.2,540,178.1z"
      />
      <path
        class="st3"
        d="M352.3,260.1c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C352.9,260.2,352.6,260.1,352.3,260.1z"
      />
      <path
        class="st3"
        d="M532.8,223.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C532.2,223.3,532.4,223.4,532.8,223.6z"
      />
      <path
        class="st3"
        d="M420.5,234.3c-0.2,0.4-0.6,0.7-0.5,0.9s0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C421.1,234.8,420.8,234.6,420.5,234.3z"
      />
      <path
        class="st3"
        d="M583.5,205.5c0.5,0.4,0.3,1.1,1.3,1.3C584.7,205.5,584.7,205.5,583.5,205.5z"
      />
      <path
        class="st3"
        d="M535,175c-0.2,0-0.4,0-0.6,0c-0.3,0.2-0.5,0.4-0.8,0.6c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C535.2,175.9,535.1,175.5,535,175z"
      />
      <path
        class="st3"
        d="M396.6,249.9c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C397.7,249.1,397.2,249.5,396.6,249.9z"
      />
      <path
        class="st3"
        d="M554.8,178c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C555.4,178.8,555,178.4,554.8,178z"
      />
      <path
        class="st3"
        d="M511.9,253.8c0,0.7,0.2,1.1,1,1.7C513,254.5,512.7,254.1,511.9,253.8z"
      />
      <path
        class="st3"
        d="M537.1,177c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C537.7,176.9,537.3,176.9,537.1,177L537.1,177z"
      />
      <path
        class="st3"
        d="M518.4,221c0.2-0.2,0.5-0.5,0.6-0.7c0-0.1-0.3-0.3-0.6-0.5c-0.3,0.4-0.5,0.6-0.6,0.9
		C517.8,220.7,518.2,220.9,518.4,221z"
      />
      <path
        class="st3"
        d="M388,261.3c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C388.4,260.8,388.2,261.1,388,261.3z"
      />
      <path
        class="st3"
        d="M595.2,203.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C595,203.6,595.3,203.4,595.2,203.3z"
      />
      <path
        class="st3"
        d="M558.5,193.9c-0.2-0.7-0.3-1.2-1.2-1.2C557.2,193.3,557.6,193.6,558.5,193.9z"
      />
      <path
        class="st3"
        d="M611.8,174c0.1,0,0.2,0,0.3,0v-1c0,0,0,0-0.1,0C612,173.3,611.9,173.6,611.8,174z"
      />
      <path
        class="st3"
        d="M540.8,207.6c0.1-0.1,0.2-0.2,0.3-0.4c-0.3-0.5-0.7-0.7-1.6-0.4C540,207.1,540.4,207.3,540.8,207.6z"
      />
      <path
        class="st3"
        d="M353.3,270.5c0.2-0.5,0.4-1,0.7-1.6C352.9,269.7,352.9,269.7,353.3,270.5z"
      />
      <path
        class="st3"
        d="M579.4,184c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C579,184.5,579.2,184.2,579.4,184z"
      />
      <path
        class="st3"
        d="M522.2,205.5c-0.2,0-0.4,0-0.5,0c0.1,0.4,0.2,0.5,0.6,0.6c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6
		C522.3,205.6,522.3,205.5,522.2,205.5z"
      />
      <path
        class="st3"
        d="M546.8,168.4c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		C547.4,168.7,547.1,168.6,546.8,168.4z"
      />
      <path
        class="st3"
        d="M336.9,235.1L336.9,235.1c-0.1,0.2-0.2,0.3-0.2,0.4c0.1,0.2,0.4,0.3,0.7,0.3c0.2,0,0.3-0.3,0.6-0.6
		c-0.4-0.2-0.7-0.3-1-0.4C337,234.9,337,235,336.9,235.1z"
      />
      <path
        class="st3"
        d="M380.8,261.6c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C381.4,261.7,381,261.5,380.8,261.6z"
      />
      <path
        class="st3"
        d="M514.7,187.8c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C514.3,187,514.3,187,514.7,187.8z"
      />
      <path
        class="st3"
        d="M515.8,208.7c0.1,0,0.3,0,0.4,0c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1
		C515.9,207.9,515.9,208.3,515.8,208.7z"
      />
      <path
        class="st3"
        d="M539.1,228.6c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4
		C540,229.1,539.8,228.7,539.1,228.6z"
      />
      <path
        class="st3"
        d="M395.8,253.5c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C396.3,253.8,396.1,253.7,395.8,253.5z"
      />
      <path
        class="st3"
        d="M488.4,213.8c0.6-0.2,1.1-0.5,0.7-1.3C488.8,213.1,488.6,213.5,488.4,213.8z"
      />
      <path
        class="st3"
        d="M509.3,171.7c0.2,0,0.5,0,0.7,0.1c-0.1-0.1-0.2-0.3-0.3-0.4C509.5,171.4,509.4,171.5,509.3,171.7z"
      />
      <path
        class="st3"
        d="M508.3,173.9c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C507.8,174.6,508.2,174.6,508.3,173.9z"
      />
      <path
        class="st3"
        d="M499.2,184.7c0.4,0.1,0.8,0.2,1.2,0.3c0-0.1,0-0.3,0-0.4C500.1,184.4,499.7,184.4,499.2,184.7z"
      />
      <path
        class="st3"
        d="M519.7,222.4c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C519.8,221.7,519.7,222.1,519.7,222.4z"
      />
      <path
        class="st3"
        d="M558.9,187.1c0.7-0.1,1.1-0.1,1.9-0.2C560,186.7,559.5,186.4,558.9,187.1z"
      />
      <path
        class="st3"
        d="M486.4,220.9c0.3-0.5,0.4-0.8,0.6-1.1C486.4,220,486,220.3,486.4,220.9z"
      />
      <path
        class="st3"
        d="M501.9,185.2c0.2-0.1,0.2-0.2,0.2-0.4c0-0.1,0-0.2-0.1-0.3c-0.1,0.1-0.1,0.2-0.2,0.3
		C501.9,184.9,501.9,185.1,501.9,185.2z"
      />
      <path
        class="st3"
        d="M598.4,170.5L598.4,170.5c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C598.9,170.4,598.6,170.2,598.4,170.5z"
      />
      <path
        class="st3"
        d="M522.4,208.4c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.2,0.7-0.7
		C522.9,208.4,522.6,208.4,522.4,208.4z"
      />
      <path
        class="st3"
        d="M351.1,253c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C351.5,253.1,351.2,253,351.1,253z"
      />
      <path
        class="st3"
        d="M560.7,189.5c0.1,0,0.1,0,0.2,0.1c0-0.2,0-0.4,0-0.6c-0.1-0.1-0.3-0.3-0.6-0.3
		C560.1,189.1,560.2,189.3,560.7,189.5z"
      />
      <path
        class="st3"
        d="M596,188.8c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C595.6,188.3,595.8,188.5,596,188.8z"
      />
      <path
        class="st3"
        d="M384.1,252.3c0.3,0.1,0.5,0.3,0.7,0.2s0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3
		C384.5,251.8,384.3,252,384.1,252.3z"
      />
      <path
        class="st3"
        d="M556.9,178.5c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C556.2,179.2,556.6,178.8,556.9,178.5z"
      />
      <path
        class="st3"
        d="M373.6,256.2c-0.3-0.3-0.5-0.5-0.7-0.7C372.7,256.2,372.7,256.2,373.6,256.2z"
      />
      <path
        class="st3"
        d="M578.5,197.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C578.9,198.3,578.7,198.1,578.5,197.8C578.5,197.9,578.5,197.8,578.5,197.8z"
      />
      <path
        class="st3"
        d="M398.7,225c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C398.6,225.2,398.7,225.1,398.7,225z"
      />
      <path
        class="st3"
        d="M527.7,244.2c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C528,243.9,527.8,244.1,527.7,244.2z"
      />
      <path
        class="st3"
        d="M343.1,238.8c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C342.8,239.1,342.9,239,343.1,238.8z"
      />
      <path
        class="st3"
        d="M388.8,267.2c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C389.2,267.4,389,267.3,388.8,267.2z"
      />
      <path
        class="st3"
        d="M510,182.8c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4c-0.1,0.2-0.3,0.3-0.4,0.5l0,0l0,0
		c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8C509.7,183,509.9,182.9,510,182.8L510,182.8L510,182.8z"
      />
      <path
        class="st3"
        d="M512.2,175.3c-0.2-0.1-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.3-0.3,0.5l0.2,0.1C512,175.6,512.1,175.4,512.2,175.3
		L512.2,175.3z"
      />
      <path
        class="st3"
        d="M558.7,189.6c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C559.2,189.2,558.9,189.4,558.7,189.6z"
      />
      <path
        class="st3"
        d="M399.2,250.5c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C399.4,250.2,399.2,250.4,399.2,250.5z"
      />
      <path
        class="st3"
        d="M609.2,214.6c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C609.5,214.3,609.4,214.4,609.2,214.6z"
      />
      <path
        class="st3"
        d="M316.1,228.7c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4
		C316.3,228.5,316.2,228.6,316.1,228.7z"
      />
      <path
        class="st3"
        d="M506.6,211c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C506.7,210.5,506.6,210.7,506.6,211z"
      />
      <path
        class="st3"
        d="M605.6,205.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C606,205.2,605.8,205.2,605.6,205.1z"
      />
      <path
        class="st3"
        d="M544.2,178.2c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5C544.1,178.4,544.1,178.3,544.2,178.2z"
      />
      <path
        class="st3"
        d="M541.6,179.2c-0.3,0.2-0.6,0.3-0.9,0.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.2,0.9-0.3
		C541.6,179.5,541.6,179.3,541.6,179.2z"
      />
      <path
        class="st3"
        d="M520.6,213.3c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C520.6,212.8,520.6,213,520.6,213.3z"
      />
      <path
        class="st3"
        d="M611.2,169.7c0,0.3,0,0.6,0,0.9C611.6,170.3,611.7,170,611.2,169.7z"
      />
      <path
        class="st3"
        d="M611.2,170.6C611.2,170.6,611.1,170.6,611.2,170.6c-0.1,0.1-0.1,0.1-0.1,0.1
		C611.1,170.7,611.1,170.7,611.2,170.6L611.2,170.6z"
      />
      <path
        class="st3"
        d="M331.6,262.6c0.1,0.2,0.2,0.5,0.3,0.7c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C331.7,262.5,331.7,262.6,331.6,262.6z"
      />
      <path
        class="st3"
        d="M505.6,184.1c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C505.8,184.2,505.7,184.1,505.6,184.1z"
      />
      <path
        class="st3"
        d="M389.8,249.7c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1
		C389.9,250.1,389.8,249.9,389.8,249.7z"
      />
      <path
        class="st3"
        d="M507.2,263.5c0.2,0.2,0.4,0.4,0.6,0.6C507.8,263.8,508.1,263.5,507.2,263.5z"
      />
      <path
        class="st3"
        d="M507.8,264.1C507.7,264.1,507.7,264.2,507.8,264.1c0,0.1,0.1,0.1,0.1,0.1C507.8,264.2,507.8,264.2,507.8,264.1
		L507.8,264.1z"
      />
      <path
        class="st3"
        d="M398.7,234.2c0,0.1,0.2,0.1,0.4,0.1l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.4C398.9,234,398.7,234.1,398.7,234.2z"
      />
      <path
        class="st3"
        d="M535.3,247.1c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C535.4,246.9,535.3,247,535.3,247.1z"
      />
      <path
        class="st3"
        d="M609.3,167.7c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C609.4,167.5,609.3,167.6,609.3,167.7z"
      />
      <path
        class="st3"
        d="M519.9,211.4c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C519.7,211.6,519.8,211.5,519.9,211.4z"
      />
      <path
        class="st3"
        d="M612.1,165v-0.5c-0.1,0.1-0.2,0.2-0.3,0.3C611.9,164.9,612,164.9,612.1,165z"
      />
      <path
        class="st3"
        d="M610.8,165.9c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C610.6,165.8,610.7,165.9,610.8,165.9z"
      />
      <path
        class="st3"
        d="M511,213.4c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0C511.1,212.9,511.1,213.2,511,213.4z
		"
      />
      <path
        class="st3"
        d="M490.1,216c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C490.3,216.2,490.1,216.1,490.1,216z"
      />
      <path
        class="st3"
        d="M519.2,211.3L519.2,211.3c-0.1-0.1-0.1-0.1-0.1-0.1L519.2,211.3C519.2,211.3,519.2,211.3,519.2,211.3z"
      />
      <path
        class="st3"
        d="M519,210.7c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C519.2,210.7,519.1,210.7,519,210.7z"
      />
      <path
        class="st3"
        d="M504.2,207.1l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C504.3,206.8,504.3,206.9,504.2,207.1z"
      />
      <path
        class="st3"
        d="M554.6,184.2c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4S554.7,184.2,554.6,184.2z
		"
      />
      <path
        class="st3"
        d="M397.1,244.8c-0.1,0-0.2-0.1-0.4-0.1l-0.1,0.2c0.1,0.1,0.2,0.1,0.4,0.2C397,245.1,397,245,397.1,244.8z"
      />
      <path
        class="st3"
        d="M509.8,173.9c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C510.1,174.1,509.9,174,509.8,173.9z"
      />
      <path
        class="st3"
        d="M544.8,223.3l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C544.9,223.2,544.9,223.2,544.8,223.3z"
      />
      <path
        class="st3"
        d="M597.1,188.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C597.2,188.3,597.1,188.3,597.1,188.2z"
      />
      <path
        class="st3"
        d="M364.8,245.2C364.8,245.2,364.8,245.3,364.8,245.2c-0.1,0.1-0.1,0.1-0.1,0.2h0.1
		C364.8,245.3,364.8,245.2,364.8,245.2z"
      />
      <path
        class="st3"
        d="M364.9,244.8c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C365.1,244.8,365,244.8,364.9,244.8z"
      />
      <path
        class="st3"
        d="M544.4,179.3C544.4,179.3,544.4,179.2,544.4,179.3c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C544,179.5,544.2,179.4,544.4,179.3z"
      />
      <path
        class="st3"
        d="M603.7,169.3c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C603.6,168.9,603.6,169,603.7,169.3z"
      />
      <path
        class="st3"
        d="M436.1,267.7c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C436.2,267.8,436.1,267.7,436.1,267.7z"
      />
      <path
        class="st3"
        d="M415.1,209.8c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C415.3,209.9,415.2,209.8,415.1,209.8z"
      />
      <path
        class="st3"
        d="M373.3,243.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C373.4,243.3,373.4,243.4,373.3,243.5z"
      />
      <path
        class="st3"
        d="M553.6,184.1C553.6,184.2,553.6,184.2,553.6,184.1c0.2,0,0.4-0.2,0.8-0.6c-0.5,0.2-0.7,0.2-0.8,0.3
		C553.6,183.9,553.6,184,553.6,184.1z"
      />
      <path
        class="st3"
        d="M598.7,188.8c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C598.7,188.9,598.7,188.9,598.7,188.8z"
      />
      <path
        class="st3"
        d="M611.1,170.7c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C611,171.1,611,170.9,611.1,170.7z"
      />
      <path
        class="st3"
        d="M468.4,243.4C468.4,243.4,468.4,243.5,468.4,243.4c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C468.5,243.3,468.4,243.3,468.4,243.4z"
      />
      <path
        class="st3"
        d="M557.7,186.9C557.7,186.9,557.8,186.9,557.7,186.9c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0
		c-0.1-0.1-0.1-0.2-0.2-0.2C557.9,186.8,557.7,186.8,557.7,186.9z"
      />
      <path
        class="st3"
        d="M368.7,253.7c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C368.9,253.4,368.8,253.6,368.7,253.7z"
      />
      <path
        class="st3"
        d="M501.9,205.6c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C501.8,205.4,501.8,205.5,501.9,205.6z"
      />
      <path
        class="st3"
        d="M604.1,188.2c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C604.3,188.2,604.2,188.2,604.1,188.2z"
      />
      <path
        class="st3"
        d="M598.1,189.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C598.2,189.8,598.2,189.7,598.1,189.7z"
      />
      <path
        class="st3"
        d="M599.9,215.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C600,215.1,600,215.3,599.9,215.4z"
      />
      <path
        class="st3"
        d="M555.2,199c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C555,198.9,555.1,198.9,555.2,199z"
      />
      <path
        class="st3"
        d="M555.4,173c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L555.4,173z"
      />
      <path
        class="st3"
        d="M346.1,243.9c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C346.2,244.1,346.2,244,346.1,243.9z
		"
      />
      <path
        class="st3"
        d="M508,264.6c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C507.9,264.4,507.9,264.5,508,264.6z"
      />
      <path
        class="st3"
        d="M537.4,176C537.4,176.1,537.4,176.1,537.4,176c0,0.1,0.1,0.1,0.1,0.1L537.4,176C537.6,176,537.5,176,537.4,176
		z"
      />
      <path
        class="st3"
        d="M534.4,176.3L534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3
		C534.5,176.3,534.5,176.3,534.4,176.3z"
      />
      <path
        class="st3"
        d="M534.1,176.6c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C534,176.5,534,176.6,534.1,176.6z"
      />
      <path
        class="st3"
        d="M559.6,169l0.1,0.1c0.1,0,0.1,0,0.2,0C559.8,169.1,559.8,169,559.6,169C559.8,169,559.7,169,559.6,169z"
      />
      <path
        class="st3"
        d="M504.2,180.1c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C504.1,180.2,504.1,180.2,504.2,180.1
		C504.2,180.2,504.2,180.1,504.2,180.1z"
      />
      <path
        class="st3"
        d="M498.8,181c0,0,0.1,0.1,0.1,0.2l0,0l0,0C498.9,181.1,498.9,181,498.8,181z"
      />
      <path
        class="st3"
        d="M420.8,229.6l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C420.6,229.7,420.7,229.6,420.8,229.6z"
      />
      <path
        class="st3"
        d="M507,173.5l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C507.3,173.5,507.1,173.5,507,173.5z"
      />
      <path
        class="st3"
        d="M450.3,225.3c0.1,0,0.1,0.1,0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C450.5,225.2,450.4,225.3,450.3,225.3z"
      />
      <path
        class="st3"
        d="M428,230.5c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C428.1,230.5,428,230.5,428,230.5z"
      />
      <path
        class="st3"
        d="M510.5,242.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C510.5,242.7,510.5,242.8,510.5,242.8z"
      />
      <path
        class="st3"
        d="M487.4,218.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C487.5,218.5,487.5,218.5,487.4,218.6z"
      />
      <path
        class="st3"
        d="M532,209.8c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4C532.1,209.8,532,209.8,532,209.8z"
      />
      <path
        class="st3"
        d="M394.4,240.4c0-0.1,0.1-0.2,0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C394.2,240.3,394.3,240.3,394.4,240.4z"
      />
      <path
        class="st3"
        d="M542.2,208.4c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C542.3,208.2,542.2,208.3,542.2,208.4z"
      />
      <path
        class="st3"
        d="M560.5,192.3c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C560.7,192.4,560.7,192.3,560.5,192.3
		C560.6,192.2,560.6,192.3,560.5,192.3z"
      />
      <path
        class="st3"
        d="M536.2,211.5c0,0,0,0.1,0.1,0.1C536.3,211.7,536.3,211.7,536.2,211.5c0.1,0.1,0.1,0.1,0.1,0.1
		S536.3,211.5,536.2,211.5C536.3,211.5,536.3,211.5,536.2,211.5L536.2,211.5z"
      />
      <path
        class="st3"
        d="M546.4,194.8c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0
		C546.5,194.7,546.5,194.7,546.4,194.8C546.4,194.7,546.4,194.8,546.4,194.8z"
      />
      <path
        class="st3"
        d="M501.4,204.9c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C501.5,204.7,501.4,204.8,501.4,204.9z
		"
      />
      <path
        class="st3"
        d="M468.1,242.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S468,242.7,468.1,242.8z"
      />
      <path
        class="st3"
        d="M522.5,216.4c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C522.5,216.5,522.5,216.4,522.5,216.4z"
      />
      <path
        class="st3"
        d="M544.3,222.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C544.4,222.5,544.4,222.5,544.3,222.6z"
      />
      <path
        class="st3"
        d="M584,178.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L584,178.4z"
      />
      <path
        class="st3"
        d="M528.7,215.5v-0.1h-0.1C528.6,215.4,528.6,215.4,528.7,215.5C528.6,215.5,528.7,215.5,528.7,215.5z"
      />
      <path
        class="st3"
        d="M529.2,216.1c-0.1,0-0.2,0-0.3,0C529,216.1,529,216.1,529.2,216.1C529.1,216.2,529.2,216.1,529.2,216.1z"
      />
      <path
        class="st3"
        d="M357,254.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0C357.1,254.5,357.1,254.6,357,254.6z"
      />
      <path
        class="st3"
        d="M558.4,185.1L558.4,185.1c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C557.8,185.3,557.9,185.2,558.4,185.1
		L558.4,185.1z"
      />
      <path
        class="st3"
        d="M358.9,229.2c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C358.9,229.2,358.9,229.2,358.9,229.2z"
      />
      <path
        class="st3"
        d="M580.2,181c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C580.4,180.9,580.3,180.9,580.2,181z"
      />
      <path
        class="st3"
        d="M580.6,181.3C580.6,181.2,580.6,181.2,580.6,181.3C580.6,181.2,580.6,181.3,580.6,181.3L580.6,181.3
		L580.6,181.3C580.7,181.3,580.7,181.3,580.6,181.3L580.6,181.3z"
      />
      <path
        class="st3"
        d="M585.8,205.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C586.1,205.6,586,205.6,585.8,205.7
		C585.8,205.6,585.8,205.7,585.8,205.7z"
      />
      <path
        class="st3"
        d="M580.7,181.6c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C580.7,181.4,580.6,181.5,580.7,181.6z"
      />
      <polygon class="st3" points="366.3,255 366.4,255 366.3,254.9 	" />
      <path
        class="st3"
        d="M403.3,246.8c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C403.4,246.8,403.4,246.8,403.3,246.8
		C403.4,246.8,403.3,246.7,403.3,246.8z"
      />
      <path
        class="st3"
        d="M395.7,225c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C395.8,225.1,395.8,225.1,395.7,225z"
      />
      <path
        class="st3"
        d="M351.2,228.7c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2h0.1C351.2,228.7,351.2,228.7,351.2,228.7z"
      />
      <polygon class="st3" points="546.3,184 546.4,183.9 546.2,183.9 	" />
      <path
        class="st3"
        d="M578.2,176.6c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.1,0-0.2C578.4,176.5,578.3,176.5,578.2,176.6z"
      />
      <path
        class="st3"
        d="M578.8,176.1L578.8,176.1C578.8,176,578.7,176.1,578.8,176.1c-0.1,0.1-0.2,0.2-0.3,0.4l0,0l0,0l0,0
		C578.6,176.3,578.7,176.2,578.8,176.1z"
      />
      <path
        class="st3"
        d="M578.8,175.8c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1S578.9,175.9,578.8,175.8z"
      />
      <polygon class="st3" points="597,185.4 597,185.5 597.1,185.4 	" />
      <polygon class="st3" points="610.6,167.2 610.6,167.1 610.5,167.1 	" />
      <path
        class="st3"
        d="M546.9,197.6c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C546.8,197.5,546.9,197.6,546.9,197.6z"
      />
      <polygon class="st3" points="315.1,230.2 315.2,230.2 315.2,230.1 	" />
      <path
        class="st3"
        d="M506.1,206.7l0.1,0.1l0.1-0.1l-0.1-0.1C506.2,206.6,506.1,206.6,506.1,206.7z"
      />
      <path
        class="st3"
        d="M352.1,240.6c0,0.1,0,0.1,0,0.2l0.1-0.1C352.2,240.6,352.2,240.6,352.1,240.6z"
      />
      <polygon class="st3" points="506.6,207.2 506.7,207.3 506.7,207.2 	" />
      <path
        class="st3"
        d="M596.6,187.8c-0.1,0-0.2,0-0.3,0C596.4,187.9,596.5,187.9,596.6,187.8c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C596.9,188,596.7,187.9,596.6,187.8z"
      />
      <path
        class="st3"
        d="M514.5,186.2L514.5,186.2C514.6,186.2,514.6,186.2,514.5,186.2C514.6,186.3,514.6,186.2,514.5,186.2
		C514.5,186.2,514.5,186.2,514.5,186.2z"
      />
      <path
        class="st3"
        d="M510.6,187.1L510.6,187.1L510.6,187.1c0-0.1,0-0.2,0-0.2C510.6,186.9,510.5,187,510.6,187.1
		C510.5,187.1,510.6,187.1,510.6,187.1z"
      />
      <polygon class="st3" points="602.5,166.7 602.4,166.6 602.4,166.7 	" />
      <polygon class="st3" points="348.4,242.8 348.5,242.8 348.5,242.7 	" />
      <path
        class="st3"
        d="M596.4,189.2L596.4,189.2C596.5,189.2,596.5,189.2,596.4,189.2c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C596.1,189,596.3,189.1,596.4,189.2z"
      />
      <path
        class="st3"
        d="M515.4,185.5C515.5,185.4,515.5,185.4,515.4,185.5L515.4,185.5C515.5,185.4,515.4,185.4,515.4,185.5z"
      />
      <path
        class="st3"
        d="M546.7,200.2l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C546.6,200.1,546.7,200.2,546.7,200.2z"
      />
      <path
        class="st3"
        d="M540.2,178.9c0,0-0.1-0.1-0.2-0.1l0,0l0,0C540.1,178.9,540.2,178.9,540.2,178.9z"
      />
      <path
        class="st3"
        d="M555.4,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C555.4,198.5,555.4,198.6,555.4,198.6z"
      />
      <path
        class="st3"
        d="M558.8,170L558.8,170c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L558.8,170z"
      />
      <path
        class="st3"
        d="M546.1,172.7l0.1-0.1l-0.1-0.1l-0.1,0.1C546.1,172.7,546.1,172.7,546.1,172.7z"
      />
      <path
        class="st3"
        d="M507.4,179.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C507.5,179.3,507.4,179.4,507.4,179.4z"
      />
      <path
        class="st3"
        d="M559.6,167.8l0.1-0.1C559.7,167.7,559.6,167.7,559.6,167.8C559.6,167.7,559.6,167.8,559.6,167.8z"
      />
      <path
        class="st3"
        d="M559.7,167.7L559.7,167.7c0.1-0.1,0.1-0.1,0.1-0.1C559.8,167.6,559.8,167.6,559.7,167.7L559.7,167.7z"
      />
      <polygon class="st3" points="509.8,177.4 509.8,177.3 509.7,177.4 	" />
      <path
        class="st3"
        d="M526.9,206.5l0.1,0.1C526.9,206.6,526.9,206.5,526.9,206.5L526.9,206.5z"
      />
      <path
        class="st3"
        d="M527,206.7C527,206.7,527,206.6,527,206.7L527,206.7c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C527.2,206.6,527.1,206.7,527,206.7z"
      />
      <path
        class="st3"
        d="M420.9,230.3l-0.1,0.1l0.1,0.1l0.1-0.1C421,230.4,421,230.4,420.9,230.3z"
      />
      <polygon class="st3" points="391.5,238.7 391.4,238.7 391.4,238.8 	" />
      <polygon class="st3" points="486,219.5 486.1,219.5 486.1,219.4 	" />
      <polygon class="st3" points="487.9,219.4 488,219.4 488,219.3 	" />
      <path
        class="st3"
        d="M541.9,207.8l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C541.8,207.8,541.9,207.8,541.9,207.8z"
      />
      <path
        class="st3"
        d="M598.2,198.4l0.1,0.1l0.1-0.1l-0.1-0.1C598.2,198.3,598.2,198.3,598.2,198.4z"
      />
      <polygon class="st3" points="376.1,247.5 376.2,247.4 376.1,247.4 	" />
      <path
        class="st3"
        d="M598.8,199l-0.1,0.1l0.1,0.1l0.1-0.1C598.9,199.1,598.8,199,598.8,199z"
      />
      <polygon class="st3" points="543.9,211.7 544,211.7 544,211.6 	" />
      <polygon
        class="st3"
        points="478.3,234.9 478.4,235 478.4,234.9 478.4,234.9 478.4,234.9 	"
      />
      <path
        class="st3"
        d="M584.1,216.2c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C584.3,216.2,584.2,216.2,584.1,216.2z"
      />
      <path
        class="st3"
        d="M350.2,267.4c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C350.3,267.3,350.3,267.4,350.2,267.4z"
      />
      <path
        class="st3"
        d="M531.1,231.3L531.1,231.3c0.1-0.1,0.1-0.1,0.1-0.1l0,0L531.1,231.3z"
      />
      <path
        class="st3"
        d="M603.1,221.6c0,0.1,0,0.2-0.1,0.3C603.1,221.7,603.1,221.7,603.1,221.6c0.1,0,0.1-0.1,0.1-0.1
		C603.1,221.5,603.1,221.5,603.1,221.6L603.1,221.6z"
      />
      <path
        class="st3"
        d="M509.9,248.8l0.1,0.1l0.1-0.1C510,248.7,510,248.7,509.9,248.8C509.9,248.7,509.9,248.7,509.9,248.8z"
      />
      <path
        class="st3"
        d="M535.5,246.4l-0.1-0.1l-0.1,0.1l0.1,0.1C535.5,246.5,535.5,246.5,535.5,246.4z"
      />
      <polygon class="st3" points="500,266.3 500.1,266.3 500.1,266.2 	" />
      <path
        class="st3"
        d="M363.9,76.8c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5
		c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C362.6,75.6,363.3,76.2,363.9,76.8z"
      />
      <path
        class="st3"
        d="M426.6,68c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0c1.2-0.3,1.7-1.2,1.3-2.9
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6
		c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8
		c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0
		c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1C425.9,66.7,426,67.3,426.6,68z"
      />
      <path
        class="st3"
        d="M314.9,116.4L314.9,116.4c-0.4,0-0.9-0.1-1.4-0.1C313.9,116.5,314.3,116.5,314.9,116.4z"
      />
      <path
        class="st3"
        d="M319.5,115.3c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1,0-0.2,0l0,0C319.4,115.1,319.4,115.2,319.5,115.3L319.5,115.3z"
      />
      <path
        class="st3"
        d="M313.8,115.3c1.3,0,2.7,0,4,0c0.1-0.1,0.2-0.2,0.4-0.2c-1.5,0-2.9,0-4.4,0
		C313.8,115.1,313.8,115.2,313.8,115.3z"
      />
      <path
        class="st3"
        d="M389,54.7c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C390,51,388.6,53,389,54.7z"
      />
      <path
        class="st3"
        d="M499.4,42.5c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2s0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.7-0.3-2.1c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C499,41.8,499.1,42.2,499.4,42.5z"
      />
      <path
        class="st3"
        d="M487,42.7c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8s0.9,1,1.9,0.7c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C486.9,41.7,486.7,42.2,487,42.7z
M497.4,56.3c-0.5-0.4-0.6-0.9-0.8-1.4C497.2,55.4,497.2,55.4,497.4,56.3z"
      />
      <path
        class="st3"
        d="M402,57.9c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C402.7,57.9,402.3,57.9,402,57.9z"
      />
      <path
        class="st3"
        d="M370.7,75.4c-2.1,0.5-3.4,2.1-3,3.8c0.3,1.7,2.2,2.7,4.3,2.3c2-0.4,3.5-2.1,3.2-3.8
		C374.8,76,372.8,75,370.7,75.4z"
      />
      <path
        class="st3"
        d="M537.5,68.9c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1
		c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2l-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5
		c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0
		c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3C537.3,69.3,537.4,69.1,537.5,68.9z"
      />
      <path
        class="st3"
        d="M402.9,56.4c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C402.1,54.3,402.1,55.5,402.9,56.4z"
      />
      <path
        class="st3"
        d="M603.9,43.3c-0.6,0.4-1.1,0.9-1.3,1.6c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4
		c0.1-0.9-0.5-1.5-0.7-2.3c-0.5-0.2-0.9-0.4-1.4-0.5C605.9,42.5,604.8,42.8,603.9,43.3z"
      />
      <path
        class="st3"
        d="M608.3,43.3C608.4,43.3,608.4,43.4,608.3,43.3C608.4,43.4,608.4,43.3,608.3,43.3
		C608.4,43.3,608.4,43.3,608.3,43.3L608.3,43.3z"
      />
      <path
        class="st3"
        d="M404.1,67.8c1-0.2,1.9-0.8,2.4-1.6c0.3-0.5,0.5-1.1,0.4-1.7c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.2-2.1-1.8-3.6-1.5
		c-1.8,0.4-3,1.9-2.6,3.4C400.7,67.2,402.5,68.1,404.1,67.8z"
      />
      <path
        class="st3"
        d="M413.9,59.6c-0.3-1.5-2-2.4-3.8-2c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2
		C413.1,62.5,414.2,61.1,413.9,59.6z"
      />
      <path
        class="st3"
        d="M526.5,48.9c1.7-0.4,2.8-1.9,2.5-3.3c-0.3-1.4-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.1,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C523,48.4,524.8,49.3,526.5,48.9z"
      />
      <path
        class="st3"
        d="M397,72.5c1-0.2,1.9-0.9,2.3-1.7c0.3-0.5,0.4-1,0.2-1.6c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0
		c-0.5,0.1-1,0.3-1.4,0.6c-0.9,0.6-1.4,1.6-1.1,2.6c0.2,0.8,0.8,1.4,1.6,1.7C395.5,72.6,396.3,72.6,397,72.5z"
      />
      <path
        class="st3"
        d="M344.9,94.3c0.6,0.6,1.1,0.9,1.6,1.1s1,0.1,1.5-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6
		s-0.1-0.3-0.2-0.5c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9
		c-0.9,0.4-1.5,1.4-1.2,2.3C342,94.1,342.9,94.5,344.9,94.3z"
      />
      <path
        class="st3"
        d="M416,63.6c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6c-0.9,0.4-2.1,0.5-2,1.5
		c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2c1.1-0.4,1.7-1.2,1.7-2.2
		c0-0.6-0.3-1.2-0.7-1.5C417.5,63.7,416.8,63.5,416,63.6z"
      />
      <path
        class="st3"
        d="M531.6,43.7c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8
		C529.9,42.1,530.5,43.3,531.6,43.7z"
      />
      <path
        class="st3"
        d="M331.5,68.4c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9c-0.2-1.2-1.8-2-3.2-1.7
		C332.5,65.9,331.3,67.2,331.5,68.4z"
      />
      <path
        class="st3"
        d="M404.3,76.1c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.2h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2s0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0
		C402.9,77.7,403.9,77.1,404.3,76.1z"
      />
      <path
        class="st3"
        d="M411.4,71.3c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1s-0.6,0.2-0.8,0.3
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5c0.3-0.1,0.6-0.2,0.8-0.3
		C410.7,72.2,411.1,71.8,411.4,71.3z"
      />
      <path
        class="st3"
        d="M341.2,76.4c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C338,76.3,339.7,77,341.2,76.4z"
      />
      <path
        class="st3"
        d="M365.4,66.6c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C362.6,66.1,363.9,66.9,365.4,66.6z"
      />
      <path
        class="st3"
        d="M552.3,7.7c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C552.1,6,552.1,6.9,552.3,7.7z"
      />
      <path
        class="st3"
        d="M602.2,54.4c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1.2-1.5-2-3-1.7
		c-1,0.2-1.7,0.8-2.1,1.5C602.2,53.7,602.2,54.1,602.2,54.4z"
      />
      <path
        class="st3"
        d="M517,37.1c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C516.7,38.4,517.1,37.8,517,37.1z"
      />
      <path
        class="st3"
        d="M408.4,79.6c-0.4-0.2-0.8-0.4-1.3-0.6c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3
		c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2
		s1.3,0.8,2.2,0.7c0.9-0.2,1.5-0.7,1.8-1.5C409.4,80.7,409.1,80.1,408.4,79.6z"
      />
      <path
        class="st3"
        d="M325.6,96.8c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1s-0.4-0.7-0.6-1.1
		c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3c-0.9,0.9-1,1.8-0.5,2.7
		C323.3,97.4,324.5,97.6,325.6,96.8z"
      />
      <path
        class="st3"
        d="M537.7,37.1c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C538.4,34.9,537.5,36,537.7,37.1z"
      />
      <path
        class="st3"
        d="M557.6,32.1c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.4-0.3-0.5
		C557.4,33,557.5,32.6,557.6,32.1z"
      />
      <path
        class="st3"
        d="M416.2,75.7c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1
		c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5c0.1-0.1,0.3-0.3,0.4-0.4
		s0.1-0.2,0.2-0.2C416.3,76.5,416.3,76.1,416.2,75.7z"
      />
      <path
        class="st3"
        d="M544.5,44.2c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C543.2,43.5,543.8,44,544.5,44.2z"
      />
      <path
        class="st3"
        d="M572.7,21.7c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6s1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C574.1,21.6,573.4,21.5,572.7,21.7z"
      />
      <path
        class="st3"
        d="M432.2,42.7c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C431.4,42.2,431.6,42.6,432.2,42.7z"
      />
      <path
        class="st3"
        d="M371.3,60.9c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C368.7,60.6,370,61.2,371.3,60.9z"
      />
      <path
        class="st3"
        d="M388.4,50.2c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C386,49.8,387.2,50.4,388.4,50.2z"
      />
      <path
        class="st3"
        d="M592.6,58.8c-0.8-0.6-1.6-0.1-2.5,0.1c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1c0.8,0.7,1.6,1.3,2.3,2
		c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1C592.9,60.1,593.4,59.4,592.6,58.8z"
      />
      <path
        class="st3"
        d="M374.7,64.2c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C374.5,63.9,374.6,64,374.7,64.2z"
      />
      <path
        class="st3"
        d="M401.9,86.2c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-0.2,0-0.4,0.1-0.6,0.2c0.1,0.2,0.3,0.4,0.4,0.6
		c0.4,0.9,0.7,1.9,0.8,2.9h0.1c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5C401.6,86.9,401.9,86.6,401.9,86.2z"
      />
      <path
        class="st3"
        d="M558.6,31.4c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C557.7,29.7,557.6,30.7,558.6,31.4z"
      />
      <path
        class="st3"
        d="M592.4,54.4c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C592.1,54.1,592.3,54.2,592.4,54.4z"
      />
      <path
        class="st3"
        d="M331.9,77.9c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2c0.2,1,1.4,1.5,2.6,1.3
		c1.2-0.3,2-1.2,1.9-2.2C334.2,78.4,333,77.7,331.9,77.9z"
      />
      <path
        class="st3"
        d="M387.4,60.8c-0.4-1.6-0.1-3.4-0.8-5c-2.1,0.8-3,1.8-2.6,3.2C384.2,60.4,385.3,61,387.4,60.8z"
      />
      <path
        class="st3"
        d="M340.2,85.6c-0.3-1-1.3-1.5-2.6-1.2c-1.2,0.3-2,1.3-1.8,2.3c0.2,0.9,1.5,1.6,2.6,1.3
		C339.7,87.7,340.5,86.6,340.2,85.6z"
      />
      <path
        class="st3"
        d="M349.9,91.6c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C349.5,88.8,349.3,90.2,349.9,91.6z"
      />
      <path
        class="st3"
        d="M393.4,63.9c-0.2-0.9-1.3-1.5-2.4-1.3c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2
		C392.8,65.8,393.6,64.8,393.4,63.9z"
      />
      <path
        class="st3"
        d="M571.1,44.5C571.1,44.5,571.1,44.4,571.1,44.5c-0.2-0.4-0.3-0.6-0.4-0.9c-0.7,0.4-1.4,0.8-2,1.2
		c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6
		c0.6,1.2,0.3,2-0.5,2.7c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7
		C569.1,45.7,569.3,44.4,571.1,44.5L571.1,44.5z"
      />
      <path
        class="st3"
        d="M308.4,65.7c-0.2-0.8-1.2-1.4-2.2-1.3V68c0.2,0,0.3,0,0.5-0.1C307.9,67.7,308.6,66.7,308.4,65.7z"
      />
      <path
        class="st3"
        d="M576.7,54.6c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C576.2,54,576.4,54.3,576.7,54.6z"
      />
      <path
        class="st3"
        d="M394.9,78.5c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.4-0.3,0.6c1.2,0.2,2.3,0.6,3.2,1.3
		C396,80.5,396.2,79.3,394.9,78.5z"
      />
      <path
        class="st3"
        d="M377.1,74.6c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2s0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		c-0.4-0.4-1.1-0.7-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		C376.5,74.6,376.8,74.6,377.1,74.6z"
      />
      <path
        class="st3"
        d="M368.3,103c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.8,0.2-1.1,0.8-1,1.4
		c0,0.2,0.1,0.3,0.2,0.5c0.7,0,1.3,0,2,0.1c-0.3-0.3-0.6-0.7,0.1-1.3C366.8,103.2,367.5,103.8,368.3,103z"
      />
      <path
        class="st3"
        d="M449.4,61.2c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.2,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C449.3,60.7,449.3,61,449.4,61.2z"
      />
      <path
        class="st3"
        d="M544,51.2c-0.3,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C545.3,51.7,544.7,51.3,544,51.2z"
      />
      <path
        class="st3"
        d="M497.9,31.9c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C495.5,31.7,496.6,32.2,497.9,31.9z"
      />
      <path
        class="st3"
        d="M557.8,38.3c-0.2-0.8-1.2-1.3-2.2-1.1s-1.7,1.1-1.5,1.9c0.2,0.8,1.2,1.2,2.1,1C557.3,39.8,558,39.1,557.8,38.3
		z"
      />
      <path
        class="st3"
        d="M442.8,32.9c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C441.4,32,441.8,32.5,442.8,32.9z"
      />
      <path
        class="st3"
        d="M580.5,54.6c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1s-0.5-0.6-1.2-0.7C580.4,54.3,580.4,54.2,580.5,54.6z"
      />
      <path
        class="st3"
        d="M424.7,77.6c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0c1-0.2,1.7-1.1,1.5-1.9s-1.1-1.2-2-1.1
		c-1,0.2-1.6,0.9-1.6,1.7C424.6,77.4,424.6,77.5,424.7,77.6z"
      />
      <path
        class="st3"
        d="M364.9,59.3c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C362.9,58.9,363.9,59.5,364.9,59.3z"
      />
      <path
        class="st3"
        d="M606.6,20.3c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C606.5,20.1,606.6,20.2,606.6,20.3z"
      />
      <path
        class="st3"
        d="M330.2,95.4c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8c0.9-0.3,1.5-1.1,1.2-1.9
		c-0.1-0.4-0.5-0.7-0.7-1.1C331.1,95.2,330.7,95.3,330.2,95.4z"
      />
      <path
        class="st3"
        d="M586.2,66.1c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.8-0.9-2.2-0.3-3-0.9
		C586.6,65.2,585.9,65.9,586.2,66.1z"
      />
      <path
        class="st3"
        d="M419.4,83.4c0.1,0,0.1,0,0.1,0c1-0.2,1.6-1,1.4-1.8c-0.1-0.3-0.2-0.5-0.4-0.7c-0.4-0.4-1-0.6-1.6-0.5
		c-0.9,0.2-1.6,1-1.5,1.8C417.6,83,418.4,83.5,419.4,83.4z"
      />
      <path
        class="st3"
        d="M541.2,34c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C539.2,33.7,540.6,34.2,541.2,34z"
      />
      <path
        class="st3"
        d="M348.8,68.6c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C347.7,67.1,348,67.9,348.8,68.6z"
      />
      <path
        class="st3"
        d="M500,46.7c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8c0.6-0.3,1.1-0.7,1.6-0.9
		C500,48.5,500,47.7,500,46.7z"
      />
      <path
        class="st3"
        d="M330.3,93h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C328.4,92.8,329.3,93.2,330.3,93z"
      />
      <path
        class="st3"
        d="M357.4,75.3c0.3-1.9-0.6-2.7-3-2.8C353.6,74.5,354.6,75.5,357.4,75.3z"
      />
      <path
        class="st3"
        d="M381.5,62.7c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8
		C379.8,62.5,380.6,62.9,381.5,62.7z"
      />
      <path
        class="st3"
        d="M400.7,50.4c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C398.8,50.2,399.7,50.6,400.7,50.4z"
      />
      <path
        class="st3"
        d="M411.6,51.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C412,49.8,411.4,50.5,411.6,51.3z"
      />
      <path
        class="st3"
        d="M410.4,47.7L410.4,47.7c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3c-0.2-0.6-0.9-0.9-1.7-0.8
		c-0.9,0.1-1.6,1-1.5,1.7C408.6,47.5,409.5,47.9,410.4,47.7z"
      />
      <path
        class="st3"
        d="M549.5,56.7C549.5,56.7,549.4,56.7,549.5,56.7L549.5,56.7C549.4,56.7,549.4,56.7,549.5,56.7
		C549.4,56.7,549.4,56.7,549.5,56.7C549.5,56.8,549.5,56.8,549.5,56.7L549.5,56.7z"
      />
      <path
        class="st3"
        d="M551.6,57.3c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C550.3,56.6,551,56.6,551.6,57.3z"
      />
      <path
        class="st3"
        d="M334.2,97.7c0.8,0.5,1.5,1.1,2.4,1.7c1-0.6,1.4-1.3,1.1-2.1c-0.3-0.6-0.9-0.9-1.7-0.9
		C335,96.5,334.4,96.9,334.2,97.7z"
      />
      <path
        class="st3"
        d="M440.1,31c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C439.9,33,440.4,32,440.1,31z"
      />
      <path
        class="st3"
        d="M577.5,26.5c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C577.1,26.2,577.3,26.4,577.5,26.5z"
      />
      <path
        class="st3"
        d="M346.6,82.7c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C344.5,82.8,345.1,83,346.6,82.7z"
      />
      <path
        class="st3"
        d="M460.4,72c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8
		c0.3,0.2,0.7,0.1,1.1,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.7,0.4-1c0.2-0.3,0.4-0.6,0.6-1C460.2,72.4,460.3,72.2,460.4,72z"
      />
      <path
        class="st3"
        d="M378.8,82.5c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C378.4,83.8,378.9,83.2,378.8,82.5z"
      />
      <path
        class="st3"
        d="M602,33.8c0.8-0.1,1.4-0.8,1.3-1.5c-0.1-0.7-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4
		C600.4,33.4,601.1,33.9,602,33.8z"
      />
      <path
        class="st3"
        d="M562,47.7c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C561.1,47,561.5,47.2,562,47.7z"
      />
      <path
        class="st3"
        d="M438.6,76.6c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.7,1,1.1,1.8,0.9c0.7-0.2,1.3-0.8,1.2-1.4
		C440.2,76.9,439.4,76.5,438.6,76.6z"
      />
      <path
        class="st3"
        d="M365.4,91.5c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C368,91.6,367.5,91.3,365.4,91.5z"
      />
      <path
        class="st3"
        d="M348.8,80.7c0.1-1.6-0.4-2.1-2.6-2.4C346,80.2,346.7,80.8,348.8,80.7z"
      />
      <path
        class="st3"
        d="M343.3,100.2c0.1-0.1,0.2-0.2,0.3-0.2c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3
		c-0.3-0.3-0.7-0.4-1.2-0.3c-0.7,0.1-1.1,0.5-1.2,1.1C341.5,99.7,342.3,100,343.3,100.2z"
      />
      <path
        class="st3"
        d="M562.4,26.2c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C561.4,25.8,561.9,26,562.4,26.2z"
      />
      <path
        class="st3"
        d="M445.2,68.9c0.6,0.1,1.4-0.2,2-0.4c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8
		c-0.6,0.2-1.1,0.5-1.7,0.7C444.4,68.2,444.7,68.8,445.2,68.9z"
      />
      <path
        class="st3"
        d="M430.9,83.6c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2c-0.2,0.2-0.4,0.3-0.7,0.6
		C430.3,83.1,430.6,83.4,430.9,83.6z"
      />
      <path
        class="st3"
        d="M316.2,120.5c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C315.1,119.9,315.5,120.3,316.2,120.5z"
      />
      <path
        class="st3"
        d="M324.8,101c-0.7,0.2-1.3,0.8-1.2,1.4c0,0.2,0.2,0.5,0.5,0.6c0.6,0,1.2,0,1.8,0c0.4-0.3,0.7-0.8,0.6-1.3
		C326.3,101.2,325.6,100.8,324.8,101z"
      />
      <path
        class="st3"
        d="M371.9,97.5c-0.2-0.3-0.4-0.5-0.6-0.8C371.4,97,371.6,97.2,371.9,97.5z"
      />
      <path
        class="st3"
        d="M568.1,14.1c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C568.8,13.4,568.5,13.7,568.1,14.1z"
      />
      <path
        class="st3"
        d="M417.2,72c0.3-0.3,0.4-0.6,0.3-1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.5-0.9-0.8-1.6-0.6c-0.7,0.2-1.1,0.7-1,1.3
		c0.1,0.7,0.8,1,1.6,0.8C416.7,72.4,417,72.2,417.2,72z"
      />
      <path
        class="st3"
        d="M550.4,45c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C549.6,44.7,549.9,44.9,550.4,45z"
      />
      <path
        class="st3"
        d="M438.2,54.1c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3s-0.2,0.2-0.3,0.4
		c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C437.8,55.1,438.1,54.7,438.2,54.1z"
      />
      <path
        class="st3"
        d="M509.3,39.9c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C509.7,38.7,509.1,39.4,509.3,39.9z"
      />
      <path
        class="st3"
        d="M513.4,43.8c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0c-0.4-0.3-0.8-0.4-1.3-0.2
		h-0.1c-0.5,0.2-0.8,0.5-0.8,1C512.4,43.3,512.7,43.6,513.4,43.8z"
      />
      <path
        class="st3"
        d="M416.2,44.4c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4
		C414.7,44.3,415.5,44.7,416.2,44.4z"
      />
      <path
        class="st3"
        d="M568.9,12.5c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C567.5,12.4,568.2,12.7,568.9,12.5z"
      />
      <path
        class="st3"
        d="M416.7,55.2c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C417.1,54.6,416.8,54.9,416.7,55.2z"
      />
      <path
        class="st3"
        d="M332.7,43.5c0.7-0.1,1.2-0.7,1.1-1.3s-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C331.3,43.2,332,43.6,332.7,43.5z"
      />
      <path
        class="st3"
        d="M445.7,57c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C446.7,58.2,446.5,57.4,445.7,57z"
      />
      <path
        class="st3"
        d="M451.9,66.6c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1c0,0.4,0.1,0.8,0.7,0.9
		c0.6,0,1.2-0.1,1.7-0.1C452.4,67.5,452.4,66.9,451.9,66.6z"
      />
      <path
        class="st3"
        d="M406.7,30.6c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C405.4,30.3,406.1,30.7,406.7,30.6z"
      />
      <path
        class="st3"
        d="M551.2,66c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C550.3,65.8,550.7,66.1,551.2,66z"
      />
      <path
        class="st3"
        d="M384,54.7c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C382.7,54.5,383.4,54.8,384,54.7z"
      />
      <path
        class="st3"
        d="M514.8,40.7c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C513.8,40.6,514.4,40.8,514.8,40.7z"
      />
      <path
        class="st3"
        d="M452.3,68.1c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6s0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2
		c-0.5-0.3-1.1-0.6-1.7-0.9C453.1,67.6,452.7,67.9,452.3,68.1z"
      />
      <path
        class="st3"
        d="M330.3,59.8c-0.2,1.2-0.3,2.4-0.4,3.5C331.8,61.9,331.8,60.9,330.3,59.8z"
      />
      <path
        class="st3"
        d="M544.5,65.6c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C546.3,64.9,546.2,64.9,544.5,65.6z"
      />
      <path
        class="st3"
        d="M443.5,84.3c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0
		c-0.3,0.1-0.5,0.2-0.7,0.5l0,0C442.7,83.6,442.9,84.1,443.5,84.3z"
      />
      <path
        class="st3"
        d="M309,117.4c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C309,117.3,309,117.4,309,117.4z"
      />
      <path
        class="st3"
        d="M354.7,86.5c-0.3-1.3-0.4-1.4-2.2-1.8C352.5,86.4,353.1,86.9,354.7,86.5z"
      />
      <path
        class="st3"
        d="M552.8,3.5c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C551.8,3.2,552.3,3.6,552.8,3.5z"
      />
      <path
        class="st3"
        d="M442.2,36c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2C440.7,36,441.5,35.9,442.2,36z"
      />
      <path
        class="st3"
        d="M435.1,34.1c0.1,0.5,0.7,0.9,1.2,0.8c0.5-0.1,0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C435.3,32.9,435,33.6,435.1,34.1z"
      />
      <path
        class="st3"
        d="M486.5,37.9c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C487.2,38.7,487.2,38.3,486.5,37.9z"
      />
      <path
        class="st3"
        d="M517.6,40.1c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C519,40.2,518.4,39.9,517.6,40.1z"
      />
      <path
        class="st3"
        d="M397.9,97.3c0.5-0.1,0.9-0.5,1-0.9c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.5-0.4-0.9-0.3
		s-0.7,0.3-0.9,0.5c-0.1,0.1-0.2,0.3-0.2,0.5s0.2,0.4,0.4,0.6C397.3,97.3,397.6,97.4,397.9,97.3z"
      />
      <path
        class="st3"
        d="M595.4,44.6c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6c0.5-0.1,0.9-0.6,0.9-1.1
		C596.5,44.9,595.9,44.5,595.4,44.6z"
      />
      <path
        class="st3"
        d="M565.3,16.8c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C564.1,16.9,564.7,17,565.3,16.8z"
      />
      <path
        class="st3"
        d="M400.6,89.7c0.7-0.5,0.5-0.8-0.6-1.3c0,0.6,0,1.3-0.2,1.9c0.1-0.1,0.2-0.1,0.3-0.2
		C400.3,89.9,400.5,89.8,400.6,89.7z"
      />
      <path
        class="st3"
        d="M570.3,21c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C570,22,570.4,21.5,570.3,21z"
      />
      <path
        class="st3"
        d="M345.6,61.4c-0.1-0.9-0.7-1.4-1.9-1.6C343.3,61.5,343.8,62,345.6,61.4z"
      />
      <path
        class="st3"
        d="M493.8,43c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C492.6,42.7,493.2,43.1,493.8,43z"
      />
      <path
        class="st3"
        d="M485.3,46.1c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C484.6,46.7,485,46.6,485.3,46.1z"
      />
      <path
        class="st3"
        d="M507.5,35.8c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C507.9,34.7,507.4,35.3,507.5,35.8z"
      />
      <path
        class="st3"
        d="M493,54.7c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C492.6,55.2,492.9,54.9,493,54.7z"
      />
      <path
        class="st3"
        d="M393.5,77c-0.1-0.4-0.7-0.7-1.2-0.6s-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6C393.1,78.1,393.6,77.4,393.5,77z"
      />
      <path
        class="st3"
        d="M567.7,50c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C568.2,50.6,568,50.3,567.7,50z"
      />
      <path
        class="st3"
        d="M356.7,90.9c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C357,90.6,356.8,90.8,356.7,90.9z"
      />
      <path
        class="st3"
        d="M585,53.7c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C584.6,53.6,584.8,53.7,585,53.7z"
      />
      <path
        class="st3"
        d="M476.2,34.4c-0.2-0.9-0.8-1.4-2.1-1.1C474.6,34.8,474.9,34.9,476.2,34.4z"
      />
      <path
        class="st3"
        d="M482.4,62.8c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		C484.1,62.2,483.6,62.3,482.4,62.8z"
      />
      <path
        class="st3"
        d="M413.4,36.4c-1.3,0.9-1.3,0.9-0.8,2C414.2,37.3,414.2,37.3,413.4,36.4z"
      />
      <path
        class="st3"
        d="M454.9,66.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C455.8,66.1,455.3,66.2,454.9,66.3z"
      />
      <path
        class="st3"
        d="M421.1,43.6c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C419.3,44,419.9,44,421.1,43.6z"
      />
      <path
        class="st3"
        d="M592.7,66.6c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C592,67.5,592.6,67.2,592.7,66.6z"
      />
      <path
        class="st3"
        d="M552.4,14.9c0.3-0.5,0.7-0.8,0.7-1.2s-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C551.5,14.5,551.9,14.6,552.4,14.9z"
      />
      <path
        class="st3"
        d="M570.7,51.1c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C570.3,50.9,570.6,51,570.7,51.1z"
      />
      <path
        class="st3"
        d="M553.3,39.5c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C552.6,39.7,553.2,39.6,553.3,39.5z"
      />
      <path
        class="st3"
        d="M435.6,62.5c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C434.5,62.2,435.1,62.7,435.6,62.5z"
      />
      <path
        class="st3"
        d="M434.8,21.6c0.5-1.1,0.5-1.1-0.8-1.8C433.7,21.2,433.7,21.2,434.8,21.6z"
      />
      <path
        class="st3"
        d="M308.7,55c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1S308.1,55.2,308.7,55z"
      />
      <path
        class="st3"
        d="M492.8,47.8c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C492.4,46.9,492.2,47.4,492.8,47.8z"
      />
      <path
        class="st3"
        d="M557.6,48.4c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C558.3,49.2,557.9,48.8,557.6,48.4z"
      />
      <path
        class="st3"
        d="M582,58.4c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C582.6,57.8,582.1,57.8,582,58.4z"
      />
      <path
        class="st3"
        d="M444.6,30.2c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9S444.3,30,444.6,30.2z"
      />
      <path
        class="st3"
        d="M581.3,72.4c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C582.5,72.5,581.9,72.4,581.3,72.4z"
      />
      <path
        class="st3"
        d="M581.4,73.6C581.3,73.6,581.3,73.6,581.4,73.6C581.3,73.6,581.3,73.7,581.4,73.6
		C581.3,73.7,581.4,73.7,581.4,73.6C581.4,73.6,581.3,73.6,581.4,73.6C581.3,73.6,581.3,73.6,581.4,73.6L581.4,73.6z"
      />
      <path
        class="st3"
        d="M362.4,88c-0.5-0.6-1-1-1.9-1C360.4,88.5,360.8,88.6,362.4,88z"
      />
      <path
        class="st3"
        d="M425.4,39.5c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C423.9,39.1,424.5,39.3,425.4,39.5z"
      />
      <path
        class="st3"
        d="M485.7,42.4c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C484.5,42.3,485.2,42.2,485.7,42.4z"
      />
      <path
        class="st3"
        d="M483.7,50.9c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C483.3,51.3,483.6,51.1,483.7,50.9z"
      />
      <path
        class="st3"
        d="M434.3,50.3C434.3,50.3,434.2,50.3,434.3,50.3c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3
		c0.3,0.2,0.5,0.5,0.7,0.6c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C434.2,50.8,434.4,50.4,434.3,50.3z"
      />
      <path
        class="st3"
        d="M565.7,31c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C566.1,30.4,565.7,30.8,565.7,31z"
      />
      <path
        class="st3"
        d="M435.6,37.3c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0
		c-0.2,0.1-0.2,0.6-0.1,0.8C434.8,36.8,435.2,37,435.6,37.3z"
      />
      <path
        class="st3"
        d="M587.7,61.8c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C588.4,61.2,587.8,61.2,587.7,61.8z"
      />
      <path
        class="st3"
        d="M561.3,49.6c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C559.1,49.5,559.5,49.8,561.3,49.6z"
      />
      <path
        class="st3"
        d="M319.4,98.4c1-1,0.8-1.3-0.7-1.4C318.6,97.6,318.8,98.1,319.4,98.4z"
      />
      <path
        class="st3"
        d="M427.8,33.2c0.3-1.1,0.3-1.1-1.3-1.4C426.6,32.5,426.8,33,427.8,33.2z"
      />
      <path
        class="st3"
        d="M572.9,52.2L572.9,52.2c0.2,0.2,0.7,0.3,0.9,0.2c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C572.1,51.5,572.5,51.9,572.9,52.2z"
      />
      <path
        class="st3"
        d="M538.1,11.7c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C537.7,12.1,538.1,11.9,538.1,11.7z"
      />
      <path
        class="st3"
        d="M307.8,87.1c0.2-0.7,0.3-1.3-0.7-1.6C306.4,86.7,306.5,87,307.8,87.1z"
      />
      <path
        class="st3"
        d="M330.7,87.7c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8
		C329.9,87.4,330.3,87.5,330.7,87.7z"
      />
      <path
        class="st3"
        d="M553.4,28.6c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C552.5,28.7,553,28.8,553.4,28.6z"
      />
      <path
        class="st3"
        d="M408,84.2c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C408.4,84.6,408.3,84.3,408,84.2z"
      />
      <path
        class="st3"
        d="M430.9,53.2c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C430.1,53.8,430.6,53.9,430.9,53.2z"
      />
      <path
        class="st3"
        d="M309.9,134.1c0,0.2,0.4,0.3,0.7,0.5c0.2-0.2,0.4-0.5,0.8-0.8c-0.4-0.2-0.7-0.5-0.9-0.4
		C310.1,133.4,309.8,133.8,309.9,134.1z"
      />
      <path
        class="st3"
        d="M524.5,40.8c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C524.4,40.7,524.4,40.7,524.5,40.8z"
      />
      <path
        class="st3"
        d="M460.6,32.6c0.4-0.5,0.8-0.9,0.2-1.4C459.8,32,459.8,32,460.6,32.6z"
      />
      <path
        class="st3"
        d="M471.8,50c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C471.6,49.9,471.7,50,471.8,50z"
      />
      <path
        class="st3"
        d="M441.1,71.8c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C440.4,72,440.8,71.9,441.1,71.8z"
      />
      <path
        class="st3"
        d="M423.8,40.9c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C422.7,40.7,423,41.1,423.8,40.9z"
      />
      <path
        class="st3"
        d="M564.6,49.6c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C564.2,48.8,564.4,49.2,564.6,49.6z"
      />
      <path
        class="st3"
        d="M507.9,49.2c0.2,0.5,0.3,0.8,0.5,0.9c0.2,0.1,0.5,0.1,1.2,0.1l0,0C509,49.7,508.9,49,507.9,49.2z"
      />
      <path
        class="st3"
        d="M551.7,40.8C551.7,40.8,551.6,40.8,551.7,40.8c-0.1,0-0.2,0-0.2,0.1c-0.2,0.4-0.2,0.6,0.1,0.8
		c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C552.2,41.3,552,41,551.7,40.8z"
      />
      <path
        class="st3"
        d="M481.9,45c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C482.2,45.5,482,45.3,481.9,45z"
      />
      <path
        class="st3"
        d="M481.3,46.7L481.3,46.7C481.2,46.7,481.2,46.7,481.3,46.7C481.2,46.8,481.3,46.8,481.3,46.7L481.3,46.7z"
      />
      <path
        class="st3"
        d="M508.5,15.7c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C507.9,16.3,508.1,16.1,508.5,15.7z"
      />
      <path
        class="st3"
        d="M400.5,70.6c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C400,69.7,400,69.7,400.5,70.6z"
      />
      <path
        class="st3"
        d="M429.5,43.6c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C429.7,43.2,429.4,43.5,429.5,43.6z"
      />
      <path
        class="st3"
        d="M438.7,29.6c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4C438,29.1,438,29.5,438.7,29.6z
		"
      />
      <path
        class="st3"
        d="M429.7,74.5c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C430,73.9,429.7,74.4,429.7,74.5z"
      />
      <path
        class="st3"
        d="M555.3,45.3c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C554.2,45.3,554.4,45.8,555.3,45.3z"
      />
      <path
        class="st3"
        d="M338.9,100.7c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9c0.1-0.1,0.2-0.2,0.2-0.3
		C339.3,101.4,339.2,101,338.9,100.7z"
      />
      <path
        class="st3"
        d="M373,91.5c0-0.6-0.3-0.9-0.8-1c-0.2,0-0.3-0.1-0.5-0.1c0,0.3,0,0.5,0,0.6C371.9,91.5,372.4,91.6,373,91.5z"
      />
      <path
        class="st3"
        d="M428.6,27.1c0.4-0.9-0.2-1.1-1-1.3C427.5,26.5,427.6,27.1,428.6,27.1z"
      />
      <path
        class="st3"
        d="M441.3,79.8c0.5,0.1,0.8,0.3,1.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.3-0.4-0.5-0.8-0.9-1.4
		C441.7,79.1,441.5,79.4,441.3,79.8z"
      />
      <path
        class="st3"
        d="M489.6,55.1c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C489.7,54.7,489.5,55,489.6,55.1z"
      />
      <path
        class="st3"
        d="M579.8,65.8c0.4-1.2,0.4-1.2-0.9-1.7C579.2,64.7,579.4,65.1,579.8,65.8z"
      />
      <path
        class="st3"
        d="M592.1,52.1c-0.2-0.3-0.4-0.6-0.8-1.1C590.8,51.9,591.2,52.1,592.1,52.1z"
      />
      <path
        class="st3"
        d="M579.2,67.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C579.8,66.8,579.5,67.1,579.2,67.3z"
      />
      <path
        class="st3"
        d="M490.8,53c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C490.5,53.5,490.6,53.2,490.8,53z"
      />
      <path
        class="st3"
        d="M440.7,57c-0.1,0.1-0.1,0.3-0.1,0.4c0.4,0.4,0.8,0.2,1.2-0.1c0,0,0-0.1,0.1-0.3C441,56.8,440.9,56.7,440.7,57z
		"
      />
      <path
        class="st3"
        d="M494.7,12.8c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C494,12.8,494.3,12.9,494.7,12.8z"
      />
      <path
        class="st3"
        d="M444.4,71.1c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1C444.5,70.7,444.5,70.9,444.4,71.1z
		"
      />
      <path
        class="st3"
        d="M437.1,43.7c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C436.5,43.2,436.4,43.6,437.1,43.7z"
      />
      <path
        class="st3"
        d="M463.3,31.8c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C462.7,31.7,463.1,31.7,463.3,31.8z"
      />
      <path
        class="st3"
        d="M476.4,38.2c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C475.8,38.7,476.1,38.5,476.4,38.2z"
      />
      <path
        class="st3"
        d="M391.9,79.2c0.7,0.3,1.1,0.1,1.4-0.6C392.5,78.4,392.1,78.6,391.9,79.2z"
      />
      <path
        class="st3"
        d="M441.3,59.8c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.3,0.7-0.5
		C441.7,60,441.4,59.8,441.3,59.8z"
      />
      <path
        class="st3"
        d="M440.8,48.6c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		c0.1,0,0.3,0,0.4-0.1C440.8,49,440.9,48.6,440.8,48.6L440.8,48.6z"
      />
      <path
        class="st3"
        d="M319.1,89.3c-0.1-0.6-0.2-1-0.3-1.4C318.2,88.6,318.3,89,319.1,89.3z"
      />
      <path
        class="st3"
        d="M313.9,102.2c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C312.8,101.3,312.9,101.7,313.9,102.2z"
      />
      <path
        class="st3"
        d="M578.6,66.3c-0.4-0.4-0.8-0.6-1.6,0.1C577.7,66.6,578.1,67.1,578.6,66.3z"
      />
      <path
        class="st3"
        d="M498.8,55.4c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.1-0.6-0.3-0.7-0.2
		C499,54.9,498.8,55.2,498.8,55.4z"
      />
      <path
        class="st3"
        d="M393.2,99.7c0.3-0.3,0.5-0.6,0.7-0.9C393,99.1,393,99.1,393.2,99.7z"
      />
      <path
        class="st3"
        d="M470.3,43.1c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C470.1,42.5,470.2,42.8,470.3,43.1z"
      />
      <path
        class="st3"
        d="M477.1,51.2c-0.7,0.5-1,1-0.6,1.6C476.9,52.3,477.3,51.9,477.1,51.2z"
      />
      <path
        class="st3"
        d="M573.7,8.7c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C573.5,8.8,573.6,8.7,573.7,8.7z"
      />
      <path
        class="st3"
        d="M465.3,41.6c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C464.9,41.4,465.1,41.5,465.3,41.6z"
      />
      <path
        class="st3"
        d="M550.1,57.8c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C548.6,57.6,549.2,57.7,550.1,57.8z"
      />
      <path
        class="st3"
        d="M558.9,43.8c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C558.4,43.4,558.7,43.6,558.9,43.8z"
      />
      <path
        class="st3"
        d="M578.6,71.1c-0.5,0.5-0.5,0.9,0,1.3C579.2,71.9,579,71.5,578.6,71.1z"
      />
      <path
        class="st3"
        d="M437.4,58.5c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C436.9,58.2,437.1,58.3,437.4,58.5z"
      />
      <path
        class="st3"
        d="M571.1,37.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C570.8,37.1,571,37.1,571.1,37.1z"
      />
      <path
        class="st3"
        d="M480.5,48.2c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C480.5,48.1,480.5,48.1,480.5,48.2z"
      />
      <path
        class="st3"
        d="M544.1,64c-0.3-0.1-0.5-0.2-0.8-0.3h0.1c0,0,0,0-0.1,0c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9
		c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3v0.1c0,0,0,0,0.1,0C543.1,64.9,543.1,64.9,544.1,64z"
      />
      <path
        class="st3"
        d="M401.4,32.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C401.2,32.7,401.3,32.5,401.4,32.3z"
      />
      <path
        class="st3"
        d="M356,81.6c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1
		C356.2,81.8,356.1,81.7,356,81.6z"
      />
      <path
        class="st3"
        d="M553,48.3c0,0.8,0.8,0.6,1.2,0.8C554,48.6,553.7,48.2,553,48.3z"
      />
      <path
        class="st3"
        d="M411.4,65.5c0.2-0.8,0.2-1.2-0.7-1.2C410.9,64.7,411.1,65,411.4,65.5z"
      />
      <path
        class="st3"
        d="M547.3,63.2c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C547.6,62.2,547.4,62.5,547.3,63.2z"
      />
      <path
        class="st3"
        d="M434.4,46.8L434.4,46.8c-0.1,0-0.1,0.1-0.1,0.1C434.3,46.9,434.4,46.9,434.4,46.8
		C434.4,46.9,434.4,46.8,434.4,46.8z"
      />
      <path
        class="st3"
        d="M434.4,46.8c0.6-0.1,1.1-0.2,1.7-0.4C435.3,46,435.3,46,434.4,46.8z"
      />
      <path
        class="st3"
        d="M437.3,56.6c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C437,57,437.2,56.8,437.3,56.6z"
      />
      <path
        class="st3"
        d="M417.8,80c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C417.2,80.3,417.5,80.2,417.8,80z"
      />
      <path
        class="st3"
        d="M568.4,48c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C569,48.6,568.8,48.4,568.4,48z"
      />
      <path
        class="st3"
        d="M475,47.2c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C475.3,47.3,475.2,47.2,475,47.2z"
      />
      <path
        class="st3"
        d="M481.7,61.1C481.7,61.1,481.7,61,481.7,61.1h-0.1C481.7,61.1,481.7,61.1,481.7,61.1L481.7,61.1z"
      />
      <path
        class="st3"
        d="M482.6,61.7c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C481.8,61.5,481.9,61.8,482.6,61.7z"
      />
      <path
        class="st3"
        d="M484.1,60c-0.1,0.2-0.3,0.5-0.4,0.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6
		C484.4,60.1,484.2,60,484.1,60z"
      />
      <path
        class="st3"
        d="M362.1,84.5c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0c0.2,0,0.5-0.1,0.7-0.2
		c0-0.1,0-0.2,0-0.2C362.9,84.5,362.5,84.5,362.1,84.5z"
      />
      <path
        class="st3"
        d="M589.5,56.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C588.7,56.9,589.1,56.8,589.5,56.6z"
      />
      <path
        class="st3"
        d="M539.7,60.4c-0.1,0.6,0.3,0.8,1,1.1C540.6,60.8,540.4,60.5,539.7,60.4z"
      />
      <path
        class="st3"
        d="M432.6,21.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C432.4,21.5,432.5,21.5,432.6,21.4z"
      />
      <path
        class="st3"
        d="M559.4,35.6c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C559.1,35.8,559.3,35.7,559.4,35.6z"
      />
      <path
        class="st3"
        d="M573.8,46c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0C573.7,46.6,573.8,46.3,573.8,46z"
      />
      <path
        class="st3"
        d="M557.2,51.5c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C556.9,50.9,557,51.2,557.2,51.5z"
      />
      <path
        class="st3"
        d="M588,64.5c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3C588.6,64.7,588.3,64.6,588,64.5
		z"
      />
      <path
        class="st3"
        d="M436.3,47.8c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C436.4,47.4,436.3,47.6,436.3,47.8z"
      />
      <path
        class="st3"
        d="M448.7,61.8c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C447.7,62,448.1,62,448.7,61.8z"
      />
      <path
        class="st3"
        d="M473.7,44.5c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C473.4,44.8,473.5,44.6,473.7,44.5z"
      />
      <path
        class="st3"
        d="M420.5,39c0.4,0.2,0.7,0.4,1.2,0.7C421.6,38.8,421.2,38.7,420.5,39z"
      />
      <path
        class="st3"
        d="M484.4,20.9c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C483.8,21.3,484.1,21.3,484.4,20.9z"
      />
      <path
        class="st3"
        d="M523.7,50.5c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C523.4,50.4,523.6,50.4,523.7,50.5z"
      />
      <path
        class="st3"
        d="M483.7,55.6c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C483.6,54.8,483.5,55.2,483.7,55.6z"
      />
      <path
        class="st3"
        d="M484.1,54.6L484.1,54.6c0.1-0.1,0.1-0.2,0.2-0.2C484.2,54.4,484.2,54.5,484.1,54.6L484.1,54.6z"
      />
      <path
        class="st3"
        d="M441.8,63.9c-0.2,0.2-0.4,0.4-0.5,0.5c0,0.1,0.2,0.2,0.3,0.3h0.1c0.2,0,0.4-0.2,0.5-0.4l0,0
		C442.1,64.2,441.9,64.1,441.8,63.9z"
      />
      <path
        class="st3"
        d="M533.6,63.3c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C534,63.5,533.7,63.3,533.6,63.3z"
      />
      <path
        class="st3"
        d="M465.2,76.1c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1-0.2-0.2-0.5-0.5c-0.1,0.4-0.3,0.6-0.2,0.7
		C464.8,76,465,76,465.2,76.1z"
      />
      <path
        class="st3"
        d="M408.2,88.7c-0.1-0.3-0.2-0.6-0.3-0.9C407.5,88.5,407.5,88.5,408.2,88.7z"
      />
      <path
        class="st3"
        d="M479.8,47c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2C479.6,47,479.7,47,479.8,47z"
      />
      <path
        class="st3"
        d="M553,30.7c-0.2-0.3-0.5-0.5-0.8-1C552.1,30.4,552.3,30.7,553,30.7z"
      />
      <path
        class="st3"
        d="M553.2,41.8c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C553.6,41.5,553.4,41.6,553.2,41.8z"
      />
      <path
        class="st3"
        d="M442.1,66c0.3-0.1,0.6-0.2,0.8-0.3c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2C442,65.7,442.1,65.9,442.1,66z"
      />
      <path
        class="st3"
        d="M486,58.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.4C485.6,58,485.9,58.2,486,58.2z"
      />
      <path
        class="st3"
        d="M585.7,48.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1
		C585.4,48.2,585.5,48.4,585.7,48.6z"
      />
      <path
        class="st3"
        d="M594.9,58.4c0.4,0.2,0.6,0.3,1,0.4C595.6,58.3,595.6,58.3,594.9,58.4z"
      />
      <path
        class="st3"
        d="M447.9,59c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C447.6,58.9,447.7,59.1,447.9,59z"
      />
      <path
        class="st3"
        d="M576.8,0.6c-0.1-0.2-0.3-0.4-0.4-0.6H576l0,0c0.2,0.2,0.3,0.5,0.5,0.7C576.6,0.7,576.7,0.6,576.8,0.6z"
      />
      <path
        class="st3"
        d="M538.5,70.4c-0.7-0.3-1.1-0.4-1.5-0.6C537.1,70.3,537.5,70.6,538.5,70.4z"
      />
      <path
        class="st3"
        d="M537.1,69.8C537,69.8,537,69.7,537.1,69.8C537,69.7,537,69.7,537.1,69.8C537,69.8,537,69.8,537.1,69.8
		C537,69.8,537,69.8,537.1,69.8z"
      />
      <path
        class="st3"
        d="M451,35.9c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8C450.7,35.9,450.8,35.9,451,35.9z"
      />
      <path
        class="st3"
        d="M430.1,30.7c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5
		C430,30.9,430.2,30.8,430.1,30.7z"
      />
      <path
        class="st3"
        d="M433.2,27c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C432.9,27.1,433.2,27,433.2,27z"
      />
      <path
        class="st3"
        d="M543.2,64.9c-0.5,0.3-0.8,0.5-1.3,0.8C542.8,65.6,542.8,65.6,543.2,64.9z"
      />
      <path
        class="st3"
        d="M339.5,93c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C339.5,93.6,339.5,93.3,339.5,93z"
      />
      <path
        class="st3"
        d="M333.8,95.5c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C333.6,95.5,333.7,95.5,333.8,95.5z
		"
      />
      <path
        class="st3"
        d="M495.3,46.1c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C495.5,45.8,495.4,45.9,495.3,46.1z"
      />
      <path
        class="st3"
        d="M433.5,22.7c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C433,22.5,433.3,22.6,433.5,22.7z"
      />
      <path
        class="st3"
        d="M539.7,77.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C539.2,77.6,539.5,77.5,539.7,77.3z"
      />
      <path
        class="st3"
        d="M557.5,73.4c0.6-0.3,1-0.5,1.4-0.6C558.3,72.6,557.8,72.6,557.5,73.4z"
      />
      <path
        class="st3"
        d="M538.3,64.7c0.1-0.1,0.1-0.1,0.2-0.2l0,0c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1,0.1-0.2,0.2-0.3,0.2
		c0.1,0,0.1,0.1,0.2,0.1C538,64.4,538.2,64.5,538.3,64.7z"
      />
      <path
        class="st3"
        d="M539.4,65.9c-0.3,0.1-0.7,0.1-1,0.2v0.1C538.7,66.1,539.1,66.1,539.4,65.9C539.4,66,539.4,66,539.4,65.9z"
      />
      <path
        class="st3"
        d="M469.9,36.4c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C469.7,36.7,469.8,36.5,469.9,36.4z"
      />
      <path
        class="st3"
        d="M462.1,8.8c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3C461.8,8.7,462,8.8,462.1,8.8z"
      />
      <path
        class="st3"
        d="M596,40.6c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0C595.7,41.1,595.8,40.8,596,40.6z"
      />
      <path
        class="st3"
        d="M502.3,1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C501.9,1.1,502.2,1.2,502.3,1.3z"
      />
      <path
        class="st3"
        d="M477.4,44.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C477.1,44.9,477.2,44.6,477.4,44.4z"
      />
      <path
        class="st3"
        d="M453.5,57.8c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C453.7,57.6,453.6,57.7,453.5,57.8z"
      />
      <path
        class="st3"
        d="M459.7,37.3c0.1,0,0.3-0.2,0.3-0.3s-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1c0.2,0,0.3,0.1,0.4,0.1
		C459.7,37.3,459.7,37.3,459.7,37.3z"
      />
      <path
        class="st3"
        d="M433.9,30.1c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C433.9,29.9,433.8,30,433.9,30.1z"
      />
      <path
        class="st3"
        d="M610.7,15.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C610.6,15.7,610.7,15.7,610.7,15.7z"
      />
      <path
        class="st3"
        d="M550,38.7c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1c0,0,0,0,0,0.1
		c-0.1,0.1-0.1,0.2-0.1,0.3C549.7,38.6,549.9,38.7,550,38.7z"
      />
      <path
        class="st3"
        d="M578.7,61.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7
		C578.5,61.7,578.6,61.6,578.7,61.5z"
      />
      <path
        class="st3"
        d="M440.3,29.6c-0.1-0.3-0.1-0.7-0.7-0.7C439.7,29.2,439.6,29.6,440.3,29.6z"
      />
      <path
        class="st3"
        d="M569.4,35c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C569.5,35.5,569.5,35.3,569.4,35C569.5,35,569.5,35,569.4,35C569.5,35,569.4,35,569.4,35z"
      />
      <path
        class="st3"
        d="M435.1,48.1c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1V48C435,48.1,435,48.1,435.1,48.1z"
      />
      <path
        class="st3"
        d="M435.8,48.6c-0.3-0.2-0.5-0.3-0.7-0.5C435.2,48.4,435.1,48.8,435.8,48.6z"
      />
      <path
        class="st3"
        d="M389.4,75l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C389.1,74.8,389.2,74.9,389.4,75z"
      />
      <path
        class="st3"
        d="M383.7,42c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3C383.2,42.3,383.4,42.1,383.7,42
		z"
      />
      <path
        class="st3"
        d="M518.4,14c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C518,13.8,518.2,13.8,518.4,14z"
      />
      <path
        class="st3"
        d="M580.5,51.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.1,0,0.1,0.1,0.2,0.1C580.1,51.5,580.3,51.4,580.5,51.2L580.5,51.2z"
      />
      <path
        class="st3"
        d="M452.3,63c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.1-0.2,0.2-0.2,0.3s0.2,0.2,0.4,0.4C452.2,63.2,452.4,63.1,452.3,63z"
      />
      <path
        class="st3"
        d="M438,48.3c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C438.2,48.5,438.1,48.3,438,48.3z"
      />
      <path
        class="st3"
        d="M467.2,27.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C466.9,27.3,467,27.4,467.2,27.5z"
      />
      <path
        class="st3"
        d="M531.1,47c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C531,46.8,531,46.9,531.1,47z"
      />
      <path
        class="st3"
        d="M561.3,17.5c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C561.2,17.7,561.3,17.6,561.3,17.5z
		"
      />
      <path
        class="st3"
        d="M477.5,24.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C477.3,24.6,477.4,24.6,477.5,24.5z"
      />
      <path
        class="st3"
        d="M530.7,46.6C530.7,46.6,530.8,46.6,530.7,46.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0-0.1
		C530.8,46.6,530.8,46.6,530.7,46.6z"
      />
      <path
        class="st3"
        d="M530,46.5c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C530.1,46.3,530.1,46.4,530,46.5z"
      />
      <path
        class="st3"
        d="M464.7,28.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C464.5,29,464.6,28.9,464.7,28.8z"
      />
      <path
        class="st3"
        d="M537.2,9.4c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C537.3,9.3,537.2,9.4,537.2,9.4z"
      />
      <path
        class="st3"
        d="M537.3,9.7v0.1l0,0C537.3,9.8,537.3,9.8,537.3,9.7C537.4,9.8,537.4,9.8,537.3,9.7z"
      />
      <path
        class="st3"
        d="M432.6,36.5c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C432.4,36.3,432.5,36.4,432.6,36.5z"
      />
      <path
        class="st3"
        d="M541.3,42.8c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C541.2,42.7,541.3,42.7,541.3,42.8z"
      />
      <path
        class="st3"
        d="M576.2,63.1c0,0.4,0.1,0.7,0.1,0.9C576.8,63.8,576.4,63.5,576.2,63.1z"
      />
      <path
        class="st3"
        d="M574.1,50.8c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0s0,0.2-0.1,0.2C573.9,50.8,574,50.8,574.1,50.8z"
      />
      <path
        class="st3"
        d="M430.6,69.8c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C430.8,69.8,430.7,69.8,430.6,69.8z"
      />
      <path
        class="st3"
        d="M484.7,53.5c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.6
		C484.8,53.6,484.8,53.6,484.7,53.5z"
      />
      <path
        class="st3"
        d="M491.9,57.1c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C491.8,56.9,491.8,57,491.9,57.1z"
      />
      <path
        class="st3"
        d="M479.5,41.2c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C479.3,41.3,479.4,41.3,479.5,41.2z"
      />
      <path
        class="st3"
        d="M582.9,74c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C582.7,73.9,582.8,74,582.9,74z"
      />
      <path
        class="st3"
        d="M492.7,57.4c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C492.5,57.6,492.6,57.5,492.7,57.4z"
      />
      <path
        class="st3"
        d="M492.1,57.3C492,57.3,492,57.2,492.1,57.3c-0.1-0.1-0.1-0.1-0.1-0.2v0.1C492,57.3,492,57.3,492.1,57.3z"
      />
      <path
        class="st3"
        d="M381.3,75.7c0.1,0,0.2,0,0.2-0.1l0,0v-0.1c0,0,0,0-0.1,0.1L381.3,75.7z"
      />
      <path
        class="st3"
        d="M380.8,76c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C380.7,75.9,380.7,75.9,380.8,76z"
      />
      <path
        class="st3"
        d="M495.2,50.9L495.2,50.9C495.1,50.9,495.1,50.9,495.2,50.9C495.2,50.9,495.2,51,495.2,50.9L495.2,50.9z"
      />
      <path
        class="st3"
        d="M495.8,50.5c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C495.8,50.8,495.8,50.6,495.8,50.5z"
      />
      <path
        class="st3"
        d="M337.4,91.4c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.2-0.1-0.2
		C337.6,91.3,337.5,91.3,337.4,91.4z"
      />
      <path
        class="st3"
        d="M466,46.3l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1C466.2,46,466,46.1,466,46.3
		C466,46.2,466,46.3,466,46.3z"
      />
      <path
        class="st3"
        d="M505.8,47c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C505.8,46.8,505.7,47,505.8,47z"
      />
      <path
        class="st3"
        d="M555.9,46.2c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2C556,45.9,555.9,46.1,555.9,46.2
		C555.8,46.1,555.8,46.2,555.9,46.2z"
      />
      <path
        class="st3"
        d="M427,41.5c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1C427.1,41.4,427,41.5,427,41.5z"
      />
      <path
        class="st3"
        d="M427,63.7c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1S426.9,63.9,427,63.7z"
      />
      <path
        class="st3"
        d="M539.7,53.8c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C539.5,53.7,539.6,53.8,539.7,53.8z"
      />
      <path
        class="st3"
        d="M544.5,68.1c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C544.3,68.3,544.4,68.2,544.5,68.1z"
      />
      <path
        class="st3"
        d="M421.2,45.5c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1
		C421.3,45.6,421.3,45.6,421.2,45.5z"
      />
      <path
        class="st3"
        d="M526.1,22.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C526.1,23,526.1,22.8,526.1,22.6z"
      />
      <path
        class="st3"
        d="M581.3,43.7c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C581.2,44,581.2,43.9,581.3,43.7z"
      />
      <path
        class="st3"
        d="M540.5,67.4c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2S540.7,67.2,540.5,67.4
		C540.6,67.2,540.6,67.4,540.5,67.4z"
      />
      <path
        class="st3"
        d="M491.7,42.7c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C491.8,43.1,491.7,42.9,491.7,42.7z"
      />
      <path
        class="st3"
        d="M447.8,70.3c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C447.6,70.2,447.7,70.4,447.8,70.3z"
      />
      <path
        class="st3"
        d="M472.6,36.2h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C472.5,36.4,472.6,36.3,472.6,36.2z"
      />
      <path
        class="st3"
        d="M547.4,64.9c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C547.2,64.8,547.3,64.9,547.4,64.9z"
      />
      <path
        class="st3"
        d="M577,42.2c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2C577.1,42.1,577,42.2,577,42.2
		z"
      />
      <path
        class="st3"
        d="M494.2,33.4c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C494.4,33.2,494.3,33.3,494.2,33.4z"
      />
      <path
        class="st3"
        d="M594.6,38.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C594.4,38.5,594.5,38.6,594.6,38.6z"
      />
      <path
        class="st3"
        d="M456.7,69.9c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1-0.1-0.1l0,0c0,0-0.1,0-0.1-0.1l0,0l0,0c0,0,0,0,0,0.1
		c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C456.4,69.9,456.5,69.9,456.7,69.9z"
      />
      <path
        class="st3"
        d="M474.7,51.1c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C474.7,50.8,474.7,51,474.7,51.1z"
      />
      <path
        class="st3"
        d="M447,56.4L447,56.4C446.9,56.3,446.9,56.3,447,56.4C446.9,56.4,446.9,56.5,447,56.4
		C447,56.4,447,56.4,447,56.4z"
      />
      <path
        class="st3"
        d="M448,55.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C448.1,55.3,448.1,55.2,448,55.2z"
      />
      <path
        class="st3"
        d="M547.4,32c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C547.2,31.9,547.3,32,547.4,32z"
      />
      <path
        class="st3"
        d="M471.8,52.5c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C471.7,52.4,471.7,52.5,471.8,52.5z"
      />
      <path
        class="st3"
        d="M390.1,70.7c0,0,0.1-0.1,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1,0.1-0.2,0.1C390.2,70.6,390.1,70.6,390.1,70.7
		z"
      />
      <path
        class="st3"
        d="M412.1,66c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C412.4,66,412.3,66,412.1,66z"
      />
      <path
        class="st3"
        d="M489.6,42.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C489.6,42.1,489.5,42.2,489.6,42.2z"
      />
      <path
        class="st3"
        d="M382,73.7l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.3C382.1,73.7,382,73.7,382,73.7z"
      />
      <path
        class="st3"
        d="M381.6,75.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C381.6,75.4,381.6,75.4,381.6,75.2
		C381.6,75.3,381.6,75.2,381.6,75.2z"
      />
      <path
        class="st3"
        d="M502.8,37.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C502.8,37.6,502.8,37.5,502.8,37.5z"
      />
      <path
        class="st3"
        d="M477.5,55.9h0.1C477.6,55.9,477.6,55.8,477.5,55.9C477.5,55.8,477.5,55.8,477.5,55.9
		C477.4,55.9,477.5,55.9,477.5,55.9z"
      />
      <path
        class="st3"
        d="M418.2,53.4c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0
		C418.1,53.5,418.2,53.4,418.2,53.4z"
      />
      <path
        class="st3"
        d="M438.7,48c0,0,0.1,0,0.2,0c0,0,0-0.1-0.1-0.1C438.8,47.9,438.7,47.9,438.7,48C438.7,47.9,438.7,48,438.7,48z"
      />
      <path
        class="st3"
        d="M477.4,58c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C477.5,57.9,477.5,58,477.4,58z"
      />
      <path
        class="st3"
        d="M454.8,63.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C454.7,63.4,454.8,63.4,454.8,63.3L454.8,63.3z"
      />
      <path
        class="st3"
        d="M446.1,46.1c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C446.2,46.1,446.1,46.1,446.1,46.1z"
      />
      <path
        class="st3"
        d="M567.9,39.9L567.9,39.9C567.9,39.8,567.8,39.8,567.9,39.9h-0.2l0,0C567.7,40,567.8,40,567.9,39.9
		C567.9,40,567.9,40,567.9,39.9z"
      />
      <path
        class="st3"
        d="M469.4,40.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C469.5,40.3,469.4,40.4,469.4,40.4z"
      />
      <path
        class="st3"
        d="M581.2,74.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C581.1,73.8,581.1,74,581.2,74.1z"
      />
      <path
        class="st3"
        d="M597.1,35C597.1,35.1,597,35.1,597.1,35c-0.1,0.2-0.1,0.3-0.1,0.3S597,35.2,597.1,35
		C597.1,35.1,597.1,35.1,597.1,35z"
      />
      <path
        class="st3"
        d="M597.2,34.7c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C597.3,34.7,597.2,34.7,597.2,34.7z"
      />
      <path
        class="st3"
        d="M336.8,92.3l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C336.9,92.4,336.9,92.3,336.8,92.3z"
      />
      <path
        class="st3"
        d="M425.1,73.7c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C425.1,73.9,425.1,73.8,425.1,73.7z"
      />
      <path
        class="st3"
        d="M579.3,73.1L579.3,73.1c0.2,0,0.2,0,0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1C579.4,72.9,579.3,73,579.3,73.1z"
      />
      <path
        class="st3"
        d="M337.8,93.3l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C337.9,93.4,337.8,93.4,337.8,93.3z"
      />
      <path
        class="st3"
        d="M494.3,60.1l0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1C494.2,59.9,494.2,60,494.3,60.1z"
      />
      <path
        class="st3"
        d="M428.6,48.1c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1C428.6,48,428.6,48,428.6,48.1z
		"
      />
      <path
        class="st3"
        d="M560.1,45.6c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C560.2,45.6,560.2,45.5,560.1,45.6
		C560.1,45.5,560.1,45.6,560.1,45.6z"
      />
      <path
        class="st3"
        d="M551.5,47.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0
		C551.6,47.6,551.6,47.6,551.5,47.7z"
      />
      <path
        class="st3"
        d="M415.8,78.5L415.8,78.5C415.8,78.5,415.8,78.6,415.8,78.5c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C416.1,78.5,416,78.5,415.8,78.5C415.9,78.5,415.9,78.5,415.8,78.5z"
      />
      <path
        class="st3"
        d="M316.1,100.5H316v0.1c0.1,0,0.1,0,0.2,0C316.2,100.6,316.2,100.6,316.1,100.5z"
      />
      <path
        class="st3"
        d="M339.8,64.1L339.8,64.1C339.8,64.2,339.9,64.2,339.8,64.1C339.9,64.2,339.8,64.1,339.8,64.1z"
      />
      <path
        class="st3"
        d="M526.3,23.3l-0.1-0.1c0,0,0,0,0-0.1v0.1C526.2,23.3,526.2,23.3,526.3,23.3z"
      />
      <path
        class="st3"
        d="M526.6,23.6c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4L526.6,23.6z"
      />
      <path
        class="st3"
        d="M378.1,87.8c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1-0.1
		C377.9,87.9,378,87.8,378.1,87.8z"
      />
      <path
        class="st3"
        d="M377.7,87.9C377.7,88,377.7,88,377.7,87.9c-0.1,0.1-0.1,0.1-0.1,0.1S377.6,88,377.7,87.9
		C377.7,88,377.7,88,377.7,87.9z"
      />
      <path
        class="st3"
        d="M377.1,88.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.2,0.3-0.3C377.4,88.1,377.3,88.2,377.1,88.2z"
      />
      <path
        class="st3"
        d="M554.7,15.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C554.8,15.6,554.8,15.6,554.7,15.6z"
      />
      <path
        class="st3"
        d="M534.9,76.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C535.1,76.3,535,76.2,534.9,76.2z"
      />
      <path
        class="st3"
        d="M534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6
		C534.6,76.5,534.7,76.5,534.7,76.6L534.7,76.6L534.7,76.6z"
      />
      <path
        class="st3"
        d="M466.3,30.5c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C466.2,30.7,466.3,30.6,466.3,30.5z"
      />
      <path
        class="st3"
        d="M333,58.6l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C333.2,58.6,333.1,58.6,333,58.6z"
      />
      <path
        class="st3"
        d="M583.5,46.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C583.3,46.9,583.4,46.9,583.5,46.9
		C583.4,46.9,583.4,46.9,583.5,46.9z"
      />
      <path
        class="st3"
        d="M583.8,65.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C583.9,65.1,583.8,65.2,583.8,65.3z"
      />
      <path
        class="st3"
        d="M450.6,32.9c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C450.7,33,450.7,33,450.6,32.9z"
      />
      <path
        class="st3"
        d="M555.1,71c-0.2,0-0.4,0.1-0.6,0.1v0.1C554.7,71.2,554.9,71.1,555.1,71L555.1,71z"
      />
      <path
        class="st3"
        d="M333.9,58.1c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C333.8,57.9,333.8,58,333.9,58.1z"
      />
      <path
        class="st3"
        d="M333.6,57.6C333.6,57.7,333.7,57.7,333.6,57.6c0.1,0.1,0.1,0.1,0.1,0.1C333.7,57.8,333.7,57.7,333.6,57.6
		C333.7,57.7,333.7,57.7,333.6,57.6z"
      />
      <path
        class="st3"
        d="M450.4,31.8l-0.1-0.1l-0.1,0.1l0.1,0.1C450.4,31.9,450.4,31.8,450.4,31.8z"
      />
      <path
        class="st3"
        d="M317.6,121c-0.1,0-0.1,0.1-0.2,0.1l0.1,0.1C317.5,121.2,317.6,121.2,317.6,121
		C317.6,121.1,317.6,121.1,317.6,121z"
      />
      <path
        class="st3"
        d="M402.8,40.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C402.7,40.6,402.7,40.6,402.8,40.6z"
      />
      <path
        class="st3"
        d="M402.5,40.4L402.5,40.4l-0.1-0.1C402.4,40.3,402.4,40.3,402.5,40.4C402.5,40.3,402.5,40.4,402.5,40.4z"
      />
      <path
        class="st3"
        d="M479.1,22.8c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C479,22.9,479,22.9,479.1,22.8z"
      />
      <path
        class="st3"
        d="M576,62.8C576,62.8,576,62.7,576,62.8C576,62.7,575.9,62.7,576,62.8C575.9,62.7,575.9,62.7,576,62.8L576,62.8z
		"
      />
      <path
        class="st3"
        d="M426,33.8c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3L426,33.8z"
      />
      <path
        class="st3"
        d="M534.7,61.3c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1S534.6,61.4,534.7,61.3z"
      />
      <path
        class="st3"
        d="M550.5,68c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3C550.4,67.9,550.4,68,550.5,68z"
      />
      <path
        class="st3"
        d="M463.7,77.4C463.7,77.3,463.7,77.4,463.7,77.4c-0.1,0.1,0,0.2,0,0.2l0.1-0.1C463.8,77.4,463.7,77.4,463.7,77.4
		z"
      />
      <path
        class="st3"
        d="M549.3,58.9c0,0.1,0,0.1,0.1,0.2l0.1-0.1C549.4,58.9,549.4,58.9,549.3,58.9C549.4,58.9,549.3,58.9,549.3,58.9z
		"
      />
      <path
        class="st3"
        d="M574.4,53.5c0,0.1,0.1,0.1,0.2,0.2v-0.1C574.6,53.4,574.5,53.4,574.4,53.5C574.5,53.4,574.4,53.4,574.4,53.5z"
      />
      <path
        class="st3"
        d="M546,60.3L546,60.3c-0.1,0-0.2,0.1-0.2,0.2c0,0,0.1,0,0.1,0.1C545.9,60.4,546,60.3,546,60.3z"
      />
      <path
        class="st3"
        d="M592.2,57.7c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C592.2,57.4,592.1,57.5,592.2,57.7
		C592.1,57.6,592.2,57.6,592.2,57.7z"
      />
      <path
        class="st3"
        d="M413.3,30.1l-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C413.1,30.1,413.2,30.1,413.3,30.1z"
      />
      <path
        class="st3"
        d="M489.7,6.9C489.6,6.9,489.6,6.9,489.7,6.9c-0.1,0.1-0.1,0.2-0.1,0.2C489.7,7.1,489.7,7.1,489.7,6.9L489.7,6.9z
		"
      />
      <path
        class="st3"
        d="M399.6,92.2c0,0.1,0.1,0.1,0.2,0.2l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2L399.6,92.2z"
      />
      <path
        class="st3"
        d="M461,7.8c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C460.9,8,460.9,7.9,461,7.8z"
      />
      <path
        class="st3"
        d="M371.4,22.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C371.4,22.4,371.4,22.3,371.4,22.2z"
      />
      <path
        class="st3"
        d="M446.1,83.3c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C446.2,83.3,446.2,83.3,446.1,83.3z"
      />
      <path
        class="st3"
        d="M308.3,140.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C308.2,140.6,308.2,140.5,308.3,140.4z"
      />
      <path
        class="st3"
        d="M583.7,74.2L583.7,74.2h-0.2H583.7C583.6,74.3,583.7,74.3,583.7,74.2z"
      />
      <path
        class="st3"
        d="M306.5,133.3c0,0,0-0.1,0.1-0.1v-0.1c0,0-0.1,0-0.1,0.1V133.3z"
      />
      <path
        class="st3"
        d="M306.8,133l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.2C306.7,133.1,306.7,133,306.8,133z"
      />
      <path
        class="st3"
        d="M589.7,67.8C589.7,67.8,589.6,67.8,589.7,67.8L589.7,67.8L589.7,67.8C589.6,67.8,589.7,67.8,589.7,67.8z"
      />
      <path
        class="st3"
        d="M560.9,73.2L560.9,73.2C560.8,73.4,560.8,73.3,560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2z"
      />
      <path
        class="st3"
        d="M586.7,64.7c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.3l0,0C586.9,64.6,586.8,64.7,586.7,64.7z"
      />
      <path
        class="st3"
        d="M555.6,71.6L555.6,71.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0C555.7,71.6,555.6,71.6,555.6,71.6z"
      />
      <path
        class="st3"
        d="M587,64.6L587,64.6c0-0.1,0.1-0.2,0.1-0.3C587.1,64.4,587,64.5,587,64.6z"
      />
      <polygon class="st3" points="579.7,63.5 579.8,63.5 579.7,63.4 	" />
      <path
        class="st3"
        d="M576.1,64.3c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C576.2,64.2,576.2,64.2,576.1,64.3z"
      />
      <path
        class="st3"
        d="M314.4,119.8h0.1l0.1-0.1l-0.1-0.1C314.5,119.7,314.5,119.7,314.4,119.8z"
      />
      <path
        class="st3"
        d="M579.5,61.8L579.5,61.8C579.5,61.9,579.6,61.9,579.5,61.8C579.6,61.8,579.6,61.7,579.5,61.8
		C579.6,61.7,579.6,61.8,579.5,61.8z"
      />
      <polygon class="st3" points="576.8,62 576.8,61.9 576.7,62 	" />
      <polygon class="st3" points="372.4,103 372.3,103.1 372.4,103.1 	" />
      <path
        class="st3"
        d="M539.2,64c0,0.1,0,0.2-0.1,0.2C539.1,64.1,539.2,64.1,539.2,64c0.1-0.1,0.1-0.1,0.1-0.2
		C539.3,63.8,539.2,63.9,539.2,64z"
      />
      <polygon class="st3" points="459.4,77.3 459.5,77.3 459.5,77.2 	" />
      <path
        class="st3"
        d="M580.7,49.8c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C580.6,49.9,580.6,49.9,580.7,49.8z"
      />
      <path
        class="st3"
        d="M548.8,56.8c0.1,0,0.1,0,0.2,0C548.9,56.8,548.9,56.7,548.8,56.8C548.9,56.7,548.9,56.8,548.8,56.8z"
      />
      <path
        class="st3"
        d="M408.1,86.8c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C408,87,408.1,86.9,408.1,86.8z"
      />
      <path
        class="st3"
        d="M541.7,56.5L541.7,56.5C541.8,56.6,541.8,56.5,541.7,56.5C541.8,56.5,541.8,56.5,541.7,56.5
		C541.8,56.5,541.8,56.5,541.7,56.5z"
      />
      <path
        class="st3"
        d="M541.5,56.4c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C541.6,56.3,541.6,56.4,541.5,56.4z"
      />
      <polygon class="st3" points="462,73.6 462.1,73.7 462.1,73.6 	" />
      <polygon class="st3" points="548.7,54.6 548.8,54.6 548.8,54.5 	" />
      <path
        class="st3"
        d="M541.8,56c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C541.8,56.2,541.8,56.1,541.8,56z"
      />
      <path
        class="st3"
        d="M381.9,90.4l-0.1-0.1l-0.1,0.1l0.1,0.1C381.8,90.4,381.9,90.4,381.9,90.4z"
      />
      <polygon class="st3" points="552.4,48.2 552.3,48.1 552.2,48.1 	" />
      <path
        class="st3"
        d="M596.5,36.4c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C596.4,36.5,596.4,36.4,596.5,36.4z"
      />
      <path
        class="st3"
        d="M493.1,57c0-0.1,0.1-0.2,0.1-0.3C493.1,56.9,493.1,56.9,493.1,57c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0
		C492.8,57.3,493,57.2,493.1,57z"
      />
      <path
        class="st3"
        d="M484.6,58.7c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1L484.6,58.7z"
      />
      <polygon class="st3" points="481.5,59.1 481.4,59.1 481.5,59.2 	" />
      <polygon class="st3" points="409.6,74 409.5,74 409.5,74.1 	" />
      <path
        class="st3"
        d="M488.8,55.6c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C488.7,55.7,488.8,55.6,488.8,55.6z"
      />
      <path
        class="st3"
        d="M444.4,65.1L444.4,65.1L444.4,65.1c0-0.1-0.1-0.1-0.1-0.1S444.4,65,444.4,65.1z"
      />
      <polygon class="st3" points="560.3,39.2 560.3,39.3 560.4,39.2 	" />
      <path
        class="st3"
        d="M514.7,46.3C514.7,46.3,514.6,46.3,514.7,46.3c-0.1,0-0.1,0-0.1,0.1C514.6,46.3,514.6,46.3,514.7,46.3z"
      />
      <path
        class="st3"
        d="M380.5,75.2l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1C380.5,75.2,380.5,75.2,380.5,75.2z"
      />
      <path
        class="st3"
        d="M514.1,45.8L514.1,45.8c0.1-0.1,0-0.1,0-0.2V45.8C514,45.8,514.1,45.8,514.1,45.8z"
      />
      <polygon class="st3" points="549,36 548.9,36 548.9,36.1 	" />
      <path
        class="st3"
        d="M400.5,67.8C400.5,67.8,400.4,67.9,400.5,67.8l0.1,0.2c0-0.1,0-0.1,0-0.2H400.5z"
      />
      <polygon class="st3" points="333.4,82.4 333.6,82.4 333.4,82.3 	" />
      <polygon class="st3" points="548.5,35.5 548.4,35.4 548.4,35.6 	" />
      <polygon class="st3" points="433.3,57 433.4,57 433.3,56.9 	" />
      <path
        class="st3"
        d="M434.7,49.5h0.1l0.1-0.1l-0.1-0.1C434.7,49.4,434.7,49.5,434.7,49.5z"
      />
      <path
        class="st3"
        d="M575.6,17.7c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C575.6,17.8,575.6,17.7,575.6,17.7z"
      />
      <polygon
        class="st3"
        points="533.2,26.6 533.2,26.5 533.2,26.5 533.1,26.5 533.1,26.5 	"
      />
      <polygon class="st3" points="438.4,47 438.3,47.1 438.4,47.1 	" />
      <path
        class="st3"
        d="M501.4,32.7c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C501.4,32.8,501.4,32.7,501.4,32.7z"
      />
      <path
        class="st3"
        d="M501.2,33L501.2,33c-0.1,0.1-0.1,0.2-0.1,0.3C501.2,33.2,501.2,33.1,501.2,33L501.2,33z"
      />
      <polygon class="st3" points="445.9,44.9 446,44.9 446,44.8 	" />
      <polygon class="st3" points="548.7,22.2 548.6,22.3 548.7,22.3 	" />
      <polygon class="st3" points="532.7,25.7 532.6,25.8 532.7,25.8 	" />
      <path
        class="st3"
        d="M434.3,47.1L434.3,47.1C434.3,46.9,434.3,46.9,434.3,47.1C434.2,47,434.3,47,434.3,47.1z"
      />
      <path
        class="st3"
        d="M421.5,49.5l-0.1-0.1l-0.1,0.1l0.1,0.1C421.4,49.6,421.5,49.6,421.5,49.5z"
      />
      <polygon
        class="st3"
        points="308.8,73.9 308.8,73.9 308.7,74 308.8,74 308.8,74 	"
      />
      <path
        class="st3"
        d="M575.8,13c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C575.7,13,575.7,13,575.8,13z"
      />
      <polygon class="st3" points="418.5,45.1 418.5,45.2 418.6,45.1 	" />
      <path
        class="st3"
        d="M376.5,53.5h-0.1v0.1l0.1,0.1C376.5,53.7,376.5,53.6,376.5,53.5z"
      />
      <path
        class="st3"
        d="M412.6,43c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C412.7,42.8,412.7,42.9,412.6,43z"
      />
      <path class="st3" d="M465.4,30.3l-0.1-0.1l-0.1,0.1l0.1,0.1L465.4,30.3z" />
      <polygon class="st3" points="427.4,38.2 427.3,38.3 427.4,38.3 	" />
      <polygon class="st3" points="445.5,33.7 445.4,33.6 445.3,33.7 	" />
      <path
        class="st3"
        d="M463.2,29.2l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C463.2,29.2,463.2,29.2,463.2,29.2z"
      />
      <path
        class="st3"
        d="M402.2,40.2L402.2,40.2c0.1,0.1,0.1,0.1,0.2,0.1C402.3,40.2,402.3,40.2,402.2,40.2z"
      />
      <path
        class="st3"
        d="M462,25.3l0.1-0.1v-0.1l-0.1,0.1C462.1,25.2,462,25.3,462,25.3z"
      />
      <polygon class="st3" points="440.8,29.9 440.8,30 440.9,30 	" />
      <path
        class="st3"
        d="M546.1,163.8c0,0-0.1,0-0.1-0.1l0,0l0,0C546,163.8,546,163.8,546.1,163.8z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "VolleyballCover_c2",
  props: ["fill"],
};
</script>
